export const DataRUS = [
  {
    ID: 0,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "Канцелярия Специального представителя Генерального секретаря по вопросу о детях и вооруженных конфликтах",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Специального представителя Генерального секретаря по вопросу о детях и вооруженных конфликтах",
    Title: "Снижение подтвержденного числа детей, находящихся в местах содержания под стражей",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Сокращение масштабов сексуального насилия, в том числе его использования в качестве метода ведения войны и террора, и сокращение масштабов насилия в отношении детей, включая серьезные нарушения, совершаемые в отношении детей в условиях вооруженного конфликта",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CD,HT,NG,SO,YE",
    Image: "1POLICY1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=63"
  },
  {
    ID: 1,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "Канцелярия Специального представителя Генерального секретаря по вопросу о детях и вооруженных конфликтах",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Специального представителя Генерального секретаря по вопросу о детях и вооруженных конфликтах",
    Title: "Увеличение числа подписанных планов действий, протоколов передачи и других обязательств между Организацией Объединенных Наций и сторонами конфликта в связи с прекращением и предотвращением тяжких правонарушений в отношении детей",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Сокращение масштабов сексуального насилия, в том числе его использования в качестве метода ведения войны и террора, и сокращение масштабов насилия в отношении детей, включая серьезные нарушения, совершаемые в отношении детей в условиях вооруженного конфликта",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=64"
  },
  {
    ID: 2,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "Канцелярия Специального представителя Генерального секретаря по вопросу о детях и вооруженных конфликтах",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Специального представителя Генерального секретаря по вопросу о детях и вооруженных конфликтах",
    Title: "Уменьшение числа детей, завербованных и используемых сторонами конфликта в ситуациях вооруженного конфликта",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Сокращение масштабов сексуального насилия, в том числе его использования в качестве метода ведения войны и террора, и сокращение масштабов насилия в отношении детей, включая серьезные нарушения, совершаемые в отношении детей в условиях вооруженного конфликта",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=64"
  },
  {
    ID: 3,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "Канцелярия Специального представителя Генерального секретаря по вопросу о детях и вооруженных конфликтах",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Специального представителя Генерального секретаря по вопросу о детях и вооруженных конфликтах",
    Title: "Увеличение числа детей, выведенных из состава вооруженных сил и вооруженных групп",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Сокращение масштабов сексуального насилия, в том числе его использования в качестве метода ведения войны и террора, и сокращение масштабов насилия в отношении детей, включая серьезные нарушения, совершаемые в отношении детей в условиях вооруженного конфликта",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=65"
  },
  {
    ID: 4,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "Канцелярия Специального представителя Генерального секретаря по вопросу о сексуальном насилии в условиях конфликта",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Специального представителя Генерального секретаря по вопросу о сексуальном насилии в условиях конфликта",
    Title: "Укрепление национальной ответственности за предотвращение связанного с конфликтом сексуального насилия и отправление правосудия в интересах пострадавших: пример Украины",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Сокращение масштабов сексуального насилия, в том числе его использования в качестве метода ведения войны и террора, и сокращение масштабов насилия в отношении детей, включая серьезные нарушения, совершаемые в отношении детей в условиях вооруженного конфликта",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "UA",
    Image: "1POLICY5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=77"
  },
  {
    ID: 5,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "Канцелярия Специального представителя Генерального секретаря по вопросу о сексуальном насилии в условиях конфликта",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Специального представителя Генерального секретаря по вопросу о сексуальном насилии в условиях конфликта",
    Title: "Укрепление национальными властями систем предоставления услуг и отправления правосудия в отношении сексуального насилия, связанного с конфликтом",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Сокращение масштабов сексуального насилия, в том числе его использования в качестве метода ведения войны и террора, и сокращение масштабов насилия в отношении детей, включая серьезные нарушения, совершаемые в отношении детей в условиях вооруженного конфликта",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DJ,ER,ET,SO,SD,QQ",
    Image: "1POLICY6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=78"
  },
  {
    ID: 6,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "Канцелярия Специального представителя Генерального секретаря по вопросу о сексуальном насилии в условиях конфликта",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Специального представителя Генерального секретаря по вопросу о сексуальном насилии в условиях конфликта",
    Title: "Усиление мер судебного реагирования со стороны национальных властей для содействия отправлению правосудия и привлечению к ответственности по делам о сексуальном насилии, связанном с конфликтом, с упором на интересы пострадавших",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Сокращение масштабов сексуального насилия, в том числе его использования в качестве метода ведения войны и террора, и сокращение масштабов насилия в отношении детей, включая серьезные нарушения, совершаемые в отношении детей в условиях вооруженного конфликта",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CO,CF,CD,UA",
    Image: "1POLICY7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=79"
  },
  {
    ID: 7,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "Канцелярия Специального представителя Генерального секретаря по вопросу о сексуальном насилии в условиях конфликта",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Специального представителя Генерального секретаря по вопросу о сексуальном насилии в условиях конфликта",
    Title: "Более строгое соблюдение сторонами конфликта международных норм по предотвращению и пресечению сексуального насилия, связанного с конфликтом",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Сокращение масштабов сексуального насилия, в том числе его использования в качестве метода ведения войны и террора, и сокращение масштабов насилия в отношении детей, включая серьезные нарушения, совершаемые в отношении детей в условиях вооруженного конфликта",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=80"
  },
  {
    ID: 8,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "Канцелярия Специального представителя Генерального секретаря по вопросу о насилии в отношении детей",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Специального представителя Генерального секретаря по вопросу о насилии в отношении детей",
    Title: "Усиление приверженности частного сектора делу защиты детей от насилия в контексте путешествий и туризма",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Частный сектор, включая микро-, малые и средние предприятия ",
    SpecificResult: "Сокращение масштабов сексуального насилия, в том числе его использования в качестве метода ведения войны и террора, и сокращение масштабов насилия в отношении детей, включая серьезные нарушения, совершаемые в отношении детей в условиях вооруженного конфликта",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=90"
  },
  {
    ID: 9,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "Канцелярия Специального представителя Генерального секретаря по вопросу о насилии в отношении детей",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Специального представителя Генерального секретаря по вопросу о насилии в отношении детей",
    Title: "Активизация осуществления инициативы стран-первопроходцев по искоренению насилия в отношении детей к 2030 году (Глобальный альянс стран-первопроходцев по искоренению насилия в отношении детей)",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Сокращение масштабов сексуального насилия, в том числе его использования в качестве метода ведения войны и террора, и сокращение масштабов насилия в отношении детей, включая серьезные нарушения, совершаемые в отношении детей в условиях вооруженного конфликта",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=91"
  },
  {
    ID: 10,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "Канцелярия Специального представителя Генерального секретаря по вопросу о насилии в отношении детей",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Специального представителя Генерального секретаря по вопросу о насилии в отношении детей",
    Title: "Принятие государствами-членами стратегических дорожных карт для ускорения действий, направленных на прекращение насилия в отношении детей к 2030 году",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Сокращение масштабов сексуального насилия, в том числе его использования в качестве метода ведения войны и террора, и сокращение масштабов насилия в отношении детей, включая серьезные нарушения, совершаемые в отношении детей в условиях вооруженного конфликта",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=92"
  },
  {
    ID: 11,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "Канцелярия Специального представителя Генерального секретаря по вопросу о насилии в отношении детей",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Специального представителя Генерального секретаря по вопросу о насилии в отношении детей",
    Title: "Взаимное обучение государств-членов ускоряет принятие мер по искоренению насилия в отношении детей",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Сокращение масштабов сексуального насилия, в том числе его использования в качестве метода ведения войны и террора, и сокращение масштабов насилия в отношении детей, включая серьезные нарушения, совершаемые в отношении детей в условиях вооруженного конфликта",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=92"
  },
  {
    ID: 12,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "Канцелярия Специального координатора по совершенствованию мер реагирования Организации Объединенных Наций на сексуальную эксплуатацию и сексуальные надругательства",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Специального координатора по совершенствованию мер реагирования Организации Объединенных Наций на сексуальную эксплуатацию и сексуальные надругательства",
    Title: "Более широкое внедрение мер защиты в рамочные программы сотрудничества со странами",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Принятие более эффективных мер реагирования на случаи сексуальной эксплуатации и сексуальных злоупотреблений, сексуальных домогательств, мошенничества и коррупции; более широкое применение подхода, ориентированного на интересы жертв",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=106"
  },
  {
    ID: 13,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "Канцелярия Специального координатора по совершенствованию мер реагирования Организации Объединенных Наций на сексуальную эксплуатацию и сексуальные надругательства",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Специального координатора по совершенствованию мер реагирования Организации Объединенных Наций на сексуальную эксплуатацию и сексуальные надругательства",
    Title: "Применение скоординированного подхода в рамках инициативы «Единая Организация Объединенных Наций» в целях более эффективной борьбы с сексуальной эксплуатацией и сексуальными надругательствами",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Принятие более эффективных мер реагирования на случаи сексуальной эксплуатации и сексуальных злоупотреблений, сексуальных домогательств, мошенничества и коррупции; более широкое применение подхода, ориентированного на интересы жертв",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=106"
  },
  {
    ID: 14,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "Канцелярия Специального координатора по совершенствованию мер реагирования Организации Объединенных Наций на сексуальную эксплуатацию и сексуальные надругательства",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Специального координатора по совершенствованию мер реагирования Организации Объединенных Наций на сексуальную эксплуатацию и сексуальные надругательства",
    Title: "Принятие эффективных мер предотвращения и реагирования путем институционализации защиты от сексуальной эксплуатации и сексуальных надругательств в рамках всей системы Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Принятие более эффективных мер реагирования на случаи сексуальной эксплуатации и сексуальных злоупотреблений, сексуальных домогательств, мошенничества и коррупции; более широкое применение подхода, ориентированного на интересы жертв",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=107"
  },
  {
    ID: 15,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "Канцелярия Специального координатора по совершенствованию мер реагирования Организации Объединенных Наций на сексуальную эксплуатацию и сексуальные надругательства",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Специального координатора по совершенствованию мер реагирования Организации Объединенных Наций на сексуальную эксплуатацию и сексуальные надругательства",
    Title: "Укрепление общесистемного стратегического подхода к борьбе с сексуальной эксплуатацией и сексуальными надругательствами",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Принятие более эффективных мер реагирования на случаи сексуальной эксплуатации и сексуальных злоупотреблений, сексуальных домогательств, мошенничества и коррупции; более широкое применение подхода, ориентированного на интересы жертв",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=108"
  },
  {
    ID: 16,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "Канцелярия Омбудсмена и посредников Организации Объединенных Наций",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Омбудсмена и посредников Организации Объединенных Наций",
    Title: "Более эффективное урегулирование трудовых конфликтов с помощью мероприятий по укреплению потенциала и формированию навыков",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление механизмов внутреннего правосудия и посредничества в целях обеспечения более этичного поведения, более гармоничных отношений и более широкого доступа к правосудию в рамках ООН",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=118"
  },
  {
    ID: 17,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "Канцелярия Омбудсмена и посредников Организации Объединенных Наций",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Омбудсмена и посредников Организации Объединенных Наций",
    Title: "Лица, не являющиеся сотрудниками Организации Объединенных Наций, имеют доступ к услугам по неформальному урегулированию конфликтов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление механизмов внутреннего правосудия и посредничества в целях обеспечения более этичного поведения, более гармоничных отношений и более широкого доступа к правосудию в рамках ООН",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=119"
  },
  {
    ID: 18,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "Канцелярия Омбудсмена и посредников Организации Объединенных Наций",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Омбудсмена и посредников Организации Объединенных Наций",
    Title: "Улучшение доступа к услугам для сотрудников на местах",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление механизмов внутреннего правосудия и посредничества в целях обеспечения более этичного поведения, более гармоничных отношений и более широкого доступа к правосудию в рамках ООН",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=119"
  },
  {
    ID: 19,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "Канцелярия Омбудсмена и посредников Организации Объединенных Наций",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Канцелярия Омбудсмена и посредников Организации Объединенных Наций",
    Title: "Повышение осведомленности о посреднических услугах",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление механизмов внутреннего правосудия и посредничества в целях обеспечения более этичного поведения, более гармоничных отношений и более широкого доступа к правосудию в рамках ООН",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=120"
  },
  {
    ID: 20,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "Управление по вопросам отправления правосудия",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Управление по вопросам отправления правосудия",
    Title: "Расширение возможностей по отслеживанию дел, поступающих в Трибунал по спорам Организации Объединенных Наций",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление механизмов внутреннего правосудия и посредничества в целях обеспечения более этичного поведения, более гармоничных отношений и более широкого доступа к правосудию в рамках ООН",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=129"
  },
  {
    ID: 21,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "Управление по вопросам отправления правосудия",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Управление по вопросам отправления правосудия",
    Title: "Повышение транспарентности системы отправления правосудия путем использования инструментов анализа данных и подготовки отчетности на основе анализа тенденций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление механизмов внутреннего правосудия и посредничества в целях обеспечения более этичного поведения, более гармоничных отношений и более широкого доступа к правосудию в рамках ООН",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=129"
  },
  {
    ID: 22,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "Управление по вопросам отправления правосудия",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Управление по вопросам отправления правосудия",
    Title: "Более активное использование юридических консультаций Отдела юридической помощи персоналу",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление механизмов внутреннего правосудия и посредничества в целях обеспечения более этичного поведения, более гармоничных отношений и более широкого доступа к правосудию в рамках ООН",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=130"
  },
  {
    ID: 23,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "Управление по вопросам отправления правосудия",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Управление по вопросам отправления правосудия",
    Title: "Более своевременное рассмотрение дел в Трибунале по спорам Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление механизмов внутреннего правосудия и посредничества в целях обеспечения более этичного поведения, более гармоничных отношений и более широкого доступа к правосудию в рамках ООН",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=131"
  },
  {
    ID: 24,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "Бюро по вопросам этики",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Бюро по вопросам этики",
    Title: "Повышение уверенности сотрудников в том, что они могут обращаться за консультацией по вопросам защиты от преследований",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление механизмов внутреннего правосудия и посредничества в целях обеспечения более этичного поведения, более гармоничных отношений и более широкого доступа к правосудию в рамках ООН",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=141"
  },
  {
    ID: 25,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "Бюро по вопросам этики",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Бюро по вопросам этики",
    Title: "Повышение уровня осведомленности персонала на местах о вопросах этики и расширение его доступа к услугам в области этики",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление механизмов внутреннего правосудия и посредничества в целях обеспечения более этичного поведения, более гармоничных отношений и более широкого доступа к правосудию в рамках ООН",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=142"
  },
  {
    ID: 26,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "Бюро по вопросам этики",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Бюро по вопросам этики",
    Title: "Повышение транспарентности и усиление подотчетности благодаря расширению деятельности по предоставлению консультаций и рекомендаций в рамках программы раскрытия финансовой информации",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление механизмов внутреннего правосудия и посредничества в целях обеспечения более этичного поведения, более гармоничных отношений и более широкого доступа к правосудию в рамках ООН",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=143"
  },
  {
    ID: 27,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "Бюро по вопросам этики",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Бюро по вопросам этики",
    Title: "Углубление понимания персоналом процедур, связанных с защитой от преследований, и обеспечение их более своевременного осуществления",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление механизмов внутреннего правосудия и посредничества в целях обеспечения более этичного поведения, более гармоничных отношений и более широкого доступа к правосудию в рамках ООН",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=143"
  },
  {
    ID: 28,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "Система координаторов-резидентов",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Система координаторов-резидентов",
    Title: "Национальные правительства содействовали применению комплексных подходов к выработке политики в целях ускорения достижения целей в области устойчивого развития",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=155"
  },
  {
    ID: 29,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "Система координаторов-резидентов",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Система координаторов-резидентов",
    Title: "Повышение транспарентности и усиление подотчетности в отношении результатов деятельности Организации Объединенных Наций и вклада в достижение целей в области устойчивого развития посредством использования стандартных показателей Рамочной программы Организации Объединенных Наций по сотрудничеству в области устойчивого развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление потенциала для подготовки отчетности о прогрессе в достижении ЦУР; увеличение числа/повышение качества добровольных национальных обзоров",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=156"
  },
  {
    ID: 30,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "Система координаторов-резидентов",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Система координаторов-резидентов",
    Title: "Повышение эффективности поддержки, оказываемой Организацией Объединенных Наций для достижения целей в области устойчивого развития, посредством принятия основанных на фактических данных решений и внедрения цифровых инноваций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=156"
  },
  {
    ID: 31,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "Система координаторов-резидентов",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Система координаторов-резидентов",
    Title: "Спасение жизней людей и сохранение источников средств к существованию в условиях долгосрочных социально-экономических последствий кризисов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Государственное управление ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=157"
  },
  {
    ID: 32,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "Молодежное бюро Организации Объединенных Наций",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Молодежное бюро Организации Объединенных Наций",
    Title: "Прогресс в реализации приоритетов в интересах молодежи и обеспечении ее значимого участия",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Укрепление многосторонности",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=175"
  },
  {
    ID: 33,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "Молодежное бюро Организации Объединенных Наций",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Молодежное бюро Организации Объединенных Наций",
    Title: "Участие молодежи на всех уровнях",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=175"
  },
  {
    ID: 34,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "Молодежное бюро Организации Объединенных Наций",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Молодежное бюро Организации Объединенных Наций",
    Title: "Создание глобальной молодежной инвестиционной платформы для расширения масштабов деятельности по разработке молодежных программ",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Укрепление потенциала для подготовки отчетности о прогрессе в достижении ЦУР; увеличение числа/повышение качества добровольных национальных обзоров",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=176"
  },
  {
    ID: 35,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "Молодежное бюро Организации Объединенных Наций",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Молодежное бюро Организации Объединенных Наций",
    Title: "Расширение участия молодежи в процессах обеспечения мира и безопасности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Укрепление многосторонности",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=177"
  },
  {
    ID: 36,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "Бюро по вопросам защиты и конфиденциальности данных",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Бюро по вопросам защиты и конфиденциальности данных",
    Title: "Повышение оперативной готовности в области обеспечения защиты и конфиденциальности данных",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=186"
  },
  {
    ID: 37,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "Бюро по вопросам защиты и конфиденциальности данных",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Бюро по вопросам защиты и конфиденциальности данных",
    Title: "Повышение уровня обеспечения защиты и конфиденциальности данных во всем Секретариате",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=187"
  },
  {
    ID: 38,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "Бюро по вопросам защиты и конфиденциальности данных",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Бюро по вопросам защиты и конфиденциальности данных",
    Title: "Оптимизация рабочих процессов в целях интеграции обеспечения соблюдения политики защиты и конфиденциальности данных в рамках всей Организации",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Создание благоприятной нормативно-правовой базы; снижение риска наступления юридической ответственности",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=188"
  },
  {
    ID: 39,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "Бюро по вопросам защиты и конфиденциальности данных",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Бюро по вопросам защиты и конфиденциальности данных",
    Title: "Повышение организационной устойчивости к потрясениям и развитие подходов, предполагающих обеспечение защиты и конфиденциальности данных на этапе проектирования, в эпоху искусственного интеллекта",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Технические достижения, позволяющие повысить качество, наличие, доступность и безопасность информации",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=189"
  },
  {
    ID: 40,
    BudgetSection: 1,
    Entity: "ODET",
    EntityFullName: "Управление цифровых и новейших технологий",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Управление цифровых и новейших технологий",
    Title: "Прогресс в осуществлении Глобального цифрового договора становится очевидным для всех заинтересованных сторон",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=197"
  },
  {
    ID: 41,
    BudgetSection: 1,
    Entity: "ODET",
    EntityFullName: "Управление цифровых и новейших технологий",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Управление цифровых и новейших технологий",
    Title: "Укрепление многосторонней приверженности Глобальному цифровому договору",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=197"
  },
  {
    ID: 42,
    BudgetSection: 1,
    Entity: "ODET",
    EntityFullName: "Управление цифровых и новейших технологий",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Управление цифровых и новейших технологий",
    Title: "Расширение сотрудничества в области международного управления искусственным интеллектом",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=198"
  },
  {
    ID: 43,
    BudgetSection: 1,
    Entity: "UNAOC",
    EntityFullName: "Альянс цивилизаций Организации Объединенных Наций",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Альянс цивилизаций Организации Объединенных Наций",
    Title: "Повышение ответственности государств-членов за укрепление культуры мира, обеспечение межрелигиозного и межкультурного диалога в интересах взаимопонимания и борьбу со всеми формами религиозной нетерпимости",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=211"
  },
  {
    ID: 44,
    BudgetSection: 1,
    Entity: "UNAOC",
    EntityFullName: "Альянс цивилизаций Организации Объединенных Наций",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Альянс цивилизаций Организации Объединенных Наций",
    Title: "Повышение осведомленности о современных проявлениях исламофобии среди государственных и негосударственных субъектов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=212"
  },
  {
    ID: 45,
    BudgetSection: 1,
    Entity: "UNAOC",
    EntityFullName: "Альянс цивилизаций Организации Объединенных Наций",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Альянс цивилизаций Организации Объединенных Наций",
    Title: "Укрепление общесистемной координации в рамках Организации Объединенных Наций и взаимодействия с заинтересованными сторонами в целях противодействия антисемитизму",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=212"
  },
  {
    ID: 46,
    BudgetSection: 1,
    Entity: "UNSWE",
    EntityFullName: "Управление по общесистемной оценке в составе Группы Организации Объединенных Наций по устойчивому развитию",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Управление по общесистемной оценке в составе Группы Организации Объединенных Наций по устойчивому развитию",
    Title: "Результаты общесистемных оценок используются при принятии решений в рамках инициативы «ООН-80»",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=212"
  },
  {
    ID: 47,
    BudgetSection: 1,
    Entity: "UNSWE",
    EntityFullName: "Управление по общесистемной оценке в составе Группы Организации Объединенных Наций по устойчивому развитию",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Управление по общесистемной оценке в составе Группы Организации Объединенных Наций по устойчивому развитию",
    Title: "Расширение доступности и использования результатов общесистемных оценок",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=222"
  },
  {
    ID: 48,
    BudgetSection: 1,
    Entity: "UNSWE",
    EntityFullName: "Управление по общесистемной оценке в составе Группы Организации Объединенных Наций по устойчивому развитию",
    Programme: "Общее формирование политики, руководство и координация",
    Subprogramme: "Управление по общесистемной оценке в составе Группы Организации Объединенных Наций по устойчивому развитию",
    Title: "Более эффективное использование данных оценок системы Организации Объединенных Наций государствами-членами и межправительственными органами при принятии решений",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ru#page=223"
  },
  {
    ID: 49,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Департамент по делам Генеральной Ассамблеи и конференционному управлению",
    Programme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Subprogramme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Title: "Рост числа неформальных процессов, проводимых сокоординаторами, назначенными Председателем Генеральной Ассамблеи",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности многосторонних заседаний и обсуждений",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ru#page=10"
  },
  {
    ID: 50,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Департамент по делам Генеральной Ассамблеи и конференционному управлению",
    Programme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Subprogramme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Title: "В распоряжении делегатов имеется стандартизированная информация о работе различных межправительственных органов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Технические достижения, позволяющие повысить качество, наличие, доступность и безопасность информации",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ru#page=11"
  },
  {
    ID: 51,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Департамент по делам Генеральной Ассамблеи и конференционному управлению",
    Programme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Subprogramme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Title: "Более простое и интуитивное взаимодействие между делегациями и Секретариатом с использованием портала e-deleGATE",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ru#page=12"
  },
  {
    ID: 52,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Департамент по делам Генеральной Ассамблеи и конференционному управлению",
    Programme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Subprogramme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Title: "Расширение доступа модулей портала e-deleGATE для вспомогательных органов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ru#page=12"
  },
  {
    ID: 53,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Департамент по делам Генеральной Ассамблеи и конференционному управлению",
    Programme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Subprogramme: "Планирование и координация конференционного обслуживания",
    Title: "Увеличение количества обслуживаемых совещаний, проводимых вне Центральных учреждений",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BR,CA,CR,ET,FR,DE,MA,PA,QA,SA,ES,EI,TH,TM,UY",
    Image: "2DGACM5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ru#page=15"
  },
  {
    ID: 54,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Департамент по делам Генеральной Ассамблеи и конференционному управлению",
    Programme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Subprogramme: "Планирование и координация конференционного обслуживания",
    Title: "Глобальный портал для обслуживания конференций и заседаний",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности многосторонних заседаний и обсуждений",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ru#page=16"
  },
  {
    ID: 55,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Департамент по делам Генеральной Ассамблеи и конференционному управлению",
    Programme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Subprogramme: "Планирование и координация конференционного обслуживания",
    Title: "Получение большего числа отзывов от государств-членов благодаря проведению глобального опроса",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ru#page=17"
  },
  {
    ID: 56,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Департамент по делам Генеральной Ассамблеи и конференционному управлению",
    Programme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Subprogramme: "Планирование и координация конференционного обслуживания",
    Title: "Обеспечение устойчивости оперативной работы за счет перекрестного обучения сотрудников, занимающихся обслуживанием конференций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ru#page=17"
  },
  {
    ID: 57,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Департамент по делам Генеральной Ассамблеи и конференционному управлению",
    Programme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Subprogramme: "Услуги по обработке документации",
    Title: "Своевременный выпуск документации, несмотря на существующие ограничения",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности многосторонних заседаний и обсуждений",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ru#page=22"
  },
  {
    ID: 58,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Департамент по делам Генеральной Ассамблеи и конференционному управлению",
    Programme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Subprogramme: "Услуги по обработке документации",
    Title: "Выпуск многоязычной документации высокого качества с применением системы контроля качества письменного перевода",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ru#page=23"
  },
  {
    ID: 59,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Департамент по делам Генеральной Ассамблеи и конференционному управлению",
    Programme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Subprogramme: "Услуги по обработке документации",
    Title: "Своевременный выпуск документации для заседаний",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности многосторонних заседаний и обсуждений",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ru#page=24"
  },
  {
    ID: 60,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Департамент по делам Генеральной Ассамблеи и конференционному управлению",
    Programme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Subprogramme: "Услуги по обработке документации",
    Title: "Обеспечение равного отношения к официальным языкам",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности многосторонних заседаний и обсуждений",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ru#page=25"
  },
  {
    ID: 61,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Департамент по делам Генеральной Ассамблеи и конференционному управлению",
    Programme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Subprogramme: "Обслуживание заседаний и издательские услуги",
    Title: "Обеспечение качества и экономия средств в результате повышения эффективности для организаторов совещаний за счет комплексного глобального управления ресурсами подразделений устного перевода",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ru#page=29"
  },
  {
    ID: 62,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Департамент по делам Генеральной Ассамблеи и конференционному управлению",
    Programme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Subprogramme: "Обслуживание заседаний и издательские услуги",
    Title: "Расширение возможностей предоставления услуг устного перевода для удовлетворения растущего спроса государств-членов на заседания, на которых обеспечивается устный перевод",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ru#page=31"
  },
  {
    ID: 63,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Департамент по делам Генеральной Ассамблеи и конференционному управлению",
    Programme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Subprogramme: "Обслуживание заседаний и издательские услуги",
    Title: "Повышение качества издательской продукции для государств-членов и общественности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Технические достижения, позволяющие повысить качество, наличие, доступность и безопасность информации",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ru#page=31"
  },
  {
    ID: 64,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Департамент по делам Генеральной Ассамблеи и конференционному управлению",
    Programme: "Дела Генеральной Ассамблеи и Экономического и Социального Совета",
    Subprogramme: "Обслуживание заседаний и издательские услуги",
    Title: "Обеспечение непрерывной поддержки заседаний за счет использования внутренней технологии планирования услуг устного перевода",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Технические достижения, позволяющие повысить качество, наличие, доступность и безопасность информации",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ru#page=32"
  },
  {
    ID: 65,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Предотвращение, регулирование и разрешение конфликтов",
    Title: "Внесение государствами-членами и другими заинтересованными сторонами вклада в проведение обзора будущего всех форм операций Организации Объединенных Наций в пользу мира",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=15"
  },
  {
    ID: 66,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Предотвращение, регулирование и разрешение конфликтов",
    Title: "Снижение угроз международному миру и безопасности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CO,LY,MZ,SD,QQ",
    Image: "3DPPA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=16"
  },
  {
    ID: 67,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Предотвращение, регулирование и разрешение конфликтов",
    Title: "Региональные и субрегиональные организации имеют доступ к поддержке в области посредничества, превентивной дипломатии и добрых услуг",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=17"
  },
  {
    ID: 68,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Предотвращение, регулирование и разрешение конфликтов",
    Title: "Расширение доступа государств-членов к оперативной поддержке в области посредничества",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=17"
  },
  {
    ID: 69,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Помощь в проведении выборов",
    Title: "Укрепление руководящей роли и расширение участия женщин в избирательных и политических процессах",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Женщины и девочки",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=21"
  },
  {
    ID: 70,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Помощь в проведении выборов",
    Title: "Увеличение представленности женщин в избирательных и политических процессах",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Женщины и девочки",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=22"
  },
  {
    ID: 71,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Помощь в проведении выборов",
    Title: "Укрепление потенциала государств-членов, получающих помощь Организации Объединенных Наций в проведении выборов, посредством совместных инициатив с региональными и субрегиональными организациями",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=23"
  },
  {
    ID: 72,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Помощь в проведении выборов",
    Title: "Своевременное и эффективное реагирование на просьбы государств-членов о получении помощи в проведении выборов со стороны Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=24"
  },
  {
    ID: 73,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Дела Совета Безопасности",
    Title: "Совершенствование методов работы Совета Безопасности за счет более своевременного учета отзывов его членов",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности многосторонних заседаний и обсуждений",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=27"
  },
  {
    ID: 74,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Дела Совета Безопасности",
    Title: "Расширение взаимодействия с государствами-членами по вопросам работы Совета Безопасности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=28"
  },
  {
    ID: 75,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Дела Совета Безопасности",
    Title: "Улучшение доступа государств-членов и общественности к актуальной и современной аналитической информации о практике и работе Совета Безопасности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=28"
  },
  {
    ID: 76,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Дела Совета Безопасности",
    Title: "Своевременное получение членами Совета Безопасности информации об осуществлении санкционных мер",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=29"
  },
  {
    ID: 77,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Деколонизация",
    Title: "Повышение информированности общественности о деколонизации",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=32"
  },
  {
    ID: 78,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Деколонизация",
    Title: "Специальный комитет имеет доступ к актуальному списку квалифицированных экспертов по деколонизации",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=33"
  },
  {
    ID: 79,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Деколонизация",
    Title: "Более широкое распространение информации о деколонизации",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=34"
  },
  {
    ID: 80,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Деколонизация",
    Title: "Специальный комитет имеет доступ к улучшенной отчетности о помощи, оказываемой несамоуправляющимся территориям",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление потенциала для подготовки отчетности о прогрессе в достижении ЦУР; увеличение числа/повышение качества добровольных национальных обзоров",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=34"
  },
  {
    ID: 81,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Вопрос о Палестине",
    Title: "Расширение участия государств-членов в работе Комитета и поддержки ими его деятельности",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Укрепление многосторонности",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=38"
  },
  {
    ID: 82,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Вопрос о Палестине",
    Title: "Расширение информационно-разъяснительной работы Комитета с общественностью по вопросу о Палестине",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=38"
  },
  {
    ID: 83,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Вопрос о Палестине",
    Title: "Повышение информативности брифингов Комитета и активизация взаимодействия с Советом Безопасности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Укрепление многосторонности",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=39"
  },
  {
    ID: 84,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Вопрос о Палестине",
    Title: "Активизация Комитетом информационно-пропагандистской работы и увеличение охвата аудитории коммуникациями по вопросу о Палестине",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=40"
  },
  {
    ID: 85,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Управление по поддержке миростроительства",
    Title: "Укрепление государствами-членами национальных стратегий и подходов в области предотвращения и миростроительства",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Государства-члены в Азиатско-Тихоокеанском регионе",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "TD,MR,PG",
    Image: "3DPPA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=43"
  },
  {
    ID: 86,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Управление по поддержке миростроительства",
    Title: "Уделение большего внимания переходным процессам в связи с выводом или преобразованием миссий",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=44"
  },
  {
    ID: 87,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Управление по поддержке миростроительства",
    Title: "Укрепление партнерства с международными финансовыми учреждениями для реализации национальных стратегий миростроительства и предотвращения конфликтов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=45"
  },
  {
    ID: 88,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Управление по поддержке миростроительства",
    Title: "Увеличение объема инвестиций в инициативы Фонда миростроительства, демонстрирующие каталитический эффект",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=46"
  },
  {
    ID: 89,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Сотрудничество между Организацией Объединенных Наций и Лигой арабских государств",
    Title: "Укрепление сотрудничества между Лигой арабских государств и Организацией Объединенных Наций в вопросах прав женщин и защиты детей в условиях вооруженного конфликта",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=49"
  },
  {
    ID: 90,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Сотрудничество между Организацией Объединенных Наций и Лигой арабских государств",
    Title: "Достижение Лигой арабских государств прогресса в области превентивной дипломатии, посредничества и анализа соответствующих вопросов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=49"
  },
  {
    ID: 91,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Сотрудничество между Организацией Объединенных Наций и Лигой арабских государств",
    Title: "Укрепление взаимодействия с Генеральным секретариатом Лиги арабских государств и государствами — членами Лиги",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=50"
  },
  {
    ID: 92,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Департамент политических и миростроительных дел",
    Programme: "Политические вопросы",
    Subprogramme: "Сотрудничество между Организацией Объединенных Наций и Лигой арабских государств",
    Title: "Укрепление партнерства между Организацией Объединенных Наций и Лигой арабских государств в деле обеспечения прогресса в области предотвращения конфликтов и сохранения мира в Арабском регионе",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=51"
  },
  {
    ID: 93,
    BudgetSection: "3",
    Entity: "UNSCO",
    EntityFullName: "Канцелярия Специального координатора Организации Объединенных Наций по ближ-невосточному мирному процессу",
    Programme: "Политические вопросы",
    Subprogramme: "Канцелярия Специального координатора Организации Объединенных Наций по ближ-невосточному мирному процессу",
    Title: "Планирование восстановления Газы на основе фактических данных",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=78"
  },
  {
    ID: 94,
    BudgetSection: "3",
    Entity: "UNSCO",
    EntityFullName: "Канцелярия Специального координатора Организации Объединенных Наций по ближ-невосточному мирному процессу",
    Programme: "Политические вопросы",
    Subprogramme: "Канцелярия Специального координатора Организации Объединенных Наций по ближ-невосточному мирному процессу",
    Title: "Прогресс на пути к созданию единого палестинского правительства, которое будет управлять всей оккупированной палестинской территорией, в рамках урегулирования в соответствии с принципом сосуществования двух государств в результате переговоров",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "PS",
    Image: "3DPPA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=79"
  },
  {
    ID: 95,
    BudgetSection: "3",
    Entity: "UNSCO",
    EntityFullName: "Канцелярия Специального координатора Организации Объединенных Наций по ближ-невосточному мирному процессу",
    Programme: "Политические вопросы",
    Subprogramme: "Канцелярия Специального координатора Организации Объединенных Наций по ближ-невосточному мирному процессу",
    Title: "Создание политической рамочной основы для урегулирования израильско-палестинского конфликта",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "PS",
    Image: "3DPPA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=80"
  },
  {
    ID: 96,
    BudgetSection: "3",
    Entity: "UNSCO",
    EntityFullName: "Канцелярия Специального координатора Организации Объединенных Наций по ближ-невосточному мирному процессу",
    Programme: "Политические вопросы",
    Subprogramme: "Канцелярия Специального координатора Организации Объединенных Наций по ближ-невосточному мирному процессу",
    Title: "Прогресс в осуществлении Комплексного плана по прекращению конфликта в секторе Газа, одобренного в резолюции 2803 (2025) Совета Безопасности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=81"
  },
  {
    ID: 97,
    BudgetSection: "3",
    Entity: "UNRoD",
    EntityFullName: "Реестр Организации Объединенных Наций для регистрации ущерба, причиненного в результате строительства стены на оккупированной палестинской территории",
    Programme: "Политические вопросы",
    Subprogramme: "Реестр Организации Объединенных Наций для регистрации ущерба, причиненного в результате строительства стены на оккупированной палестинской территории",
    Title: "Оптимизация процесса рассмотрения требований о возмещении ущерба с целью ускорить обслуживание заявителей",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=90"
  },
  {
    ID: 98,
    BudgetSection: "3",
    Entity: "UNRoD",
    EntityFullName: "Реестр Организации Объединенных Наций для регистрации ущерба, причиненного в результате строительства стены на оккупированной палестинской территории",
    Programme: "Политические вопросы",
    Subprogramme: "Реестр Организации Объединенных Наций для регистрации ущерба, причиненного в результате строительства стены на оккупированной палестинской территории",
    Title: "Сокращение числа необработанных требований",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "PS",
    Image: "3DPPA34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=91"
  },
  {
    ID: 99,
    BudgetSection: "3",
    Entity: "UNRoD",
    EntityFullName: "Реестр Организации Объединенных Наций для регистрации ущерба, причиненного в результате строительства стены на оккупированной палестинской территории",
    Programme: "Политические вопросы",
    Subprogramme: "Реестр Организации Объединенных Наций для регистрации ущерба, причиненного в результате строительства стены на оккупированной палестинской территории",
    Title: "Усовершенствование процесса исправления недостатков в собранных требованиях",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "PS",
    Image: "3DPPA35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=92"
  },
  {
    ID: 100,
    BudgetSection: "3",
    Entity: "UNRoD",
    EntityFullName: "Реестр Организации Объединенных Наций для регистрации ущерба, причиненного в результате строительства стены на оккупированной палестинской территории",
    Programme: "Политические вопросы",
    Subprogramme: "Реестр Организации Объединенных Наций для регистрации ущерба, причиненного в результате строительства стены на оккупированной палестинской территории",
    Title: "Улучшение процесса принятия решений Советом путем унификации процедур подачи требований",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=93"
  },
  {
    ID: 101,
    BudgetSection: "3",
    Entity: "UNOAU",
    EntityFullName: "Отделение Организации Объединенных Наций при Африканском союзе",
    Programme: "Политические вопросы",
    Subprogramme: "Отделение Организации Объединенных Наций при Африканском союзе",
    Title: "Передача ответственности за обеспечение безопасности в Сомали и укрепление потенциала Африканского союза в области содействия миру",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SO",
    Image: "3DPPA37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=102"
  },
  {
    ID: 102,
    BudgetSection: "3",
    Entity: "UNOAU",
    EntityFullName: "Отделение Организации Объединенных Наций при Африканском союзе",
    Programme: "Политические вопросы",
    Subprogramme: "Отделение Организации Объединенных Наций при Африканском союзе",
    Title: "Расширение участия молодежи в инициативах по обеспечению мира и безопасности в Африке",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "3DPPA38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=103"
  },
  {
    ID: 103,
    BudgetSection: "3",
    Entity: "UNOAU",
    EntityFullName: "Отделение Организации Объединенных Наций при Африканском союзе",
    Programme: "Политические вопросы",
    Subprogramme: "Отделение Организации Объединенных Наций при Африканском союзе",
    Title: "Активизация совместных усилий Организации Объединенных Наций и Африканского союза по предотвращению и посредничеству в конфликтах, сохранению мира и устранению первопричин конфликтов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "3DPPA39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=104"
  },
  {
    ID: 104,
    BudgetSection: "3",
    Entity: "UNOAU",
    EntityFullName: "Отделение Организации Объединенных Наций при Африканском союзе",
    Programme: "Политические вопросы",
    Subprogramme: "Отделение Организации Объединенных Наций при Африканском союзе",
    Title: "Расширение значимого участия, руководящей роли и влияния женщин в процессах обеспечения мира и безопасности в Африке",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "3DPPA40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=105"
  },
  {
    ID: 105,
    BudgetSection: "3",
    Entity: "OCT",
    EntityFullName: "Контртеррористическое управление",
    Programme: "Политические вопросы",
    Subprogramme: "Контртеррористическое управление",
    Title: "Глобальная сеть жертв терроризма для содействия защите их прав, участию в формировании политики и получению ими поддержки",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=122"
  },
  {
    ID: 106,
    BudgetSection: "3",
    Entity: "OCT",
    EntityFullName: "Контртеррористическое управление",
    Programme: "Политические вопросы",
    Subprogramme: "Контртеррористическое управление",
    Title: "Активизация государствами-членами усилий по противодействию применению оружия террористами",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=123"
  },
  {
    ID: 107,
    BudgetSection: "3",
    Entity: "OCT",
    EntityFullName: "Контртеррористическое управление",
    Programme: "Политические вопросы",
    Subprogramme: "Контртеррористическое управление",
    Title: "Укрепление национального контртеррористического потенциала путем усиления межведомственной координации и повышения квалификации аналитиков разведывательной информации в целях предупреждения терроризма и борьбы с ним",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=123"
  },
  {
    ID: 108,
    BudgetSection: "3",
    Entity: "OCT",
    EntityFullName: "Контртеррористическое управление",
    Programme: "Политические вопросы",
    Subprogramme: "Контртеррористическое управление",
    Title: "Укрепление национального потенциала противодействия использованию беспилотных авиационных систем в террористических целях",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ru#page=124"
  },
  {
    ID: 109,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Управление по вопросам разоружения",
    Programme: "Разоружение",
    Subprogramme: "Многосторонние переговоры и обсуждения по разоружению и ограничению вооружений",
    Title: "Увеличение числа ежегодных докладов, представляемых Высокими Договаривающимися Сторонами Конвенции о запрещении или ограничении применения конкретных видов обычного оружия, которые могут считаться наносящими чрезмерные повреждения или имеющими неизбирательное действие",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Разоружение",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Продвижение усилий и инициатив в области разоружения, нераспространения и контроля над вооружениями",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ru#page=10"
  },
  {
    ID: 110,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Управление по вопросам разоружения",
    Programme: "Разоружение",
    Subprogramme: "Многосторонние переговоры и обсуждения по разоружению и ограничению вооружений",
    Title: "Активизация обсуждений и последующих переговоров на Конференции  по разоружению",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Разоружение",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Продвижение усилий и инициатив в области разоружения, нераспространения и контроля над вооружениями",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ru#page=11"
  },
  {
    ID: 111,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Управление по вопросам разоружения",
    Programme: "Разоружение",
    Subprogramme: "Многосторонние переговоры и обсуждения по разоружению и ограничению вооружений",
    Title: "Предотвращение гонки вооружений в космическом пространстве",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Разоружение",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Продвижение усилий и инициатив в области разоружения, нераспространения и контроля над вооружениями",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ru#page=12"
  },
  {
    ID: 112,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Управление по вопросам разоружения",
    Programme: "Разоружение",
    Subprogramme: "Многосторонние переговоры и обсуждения по разоружению и ограничению вооружений",
    Title: "Рассмотрение вопроса о новых технологиях в сфере создания смертоносных автономных систем вооружений",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Разоружение",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Продвижение усилий и инициатив в области разоружения, нераспространения и контроля над вооружениями",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ru#page=13"
  },
  {
    ID: 113,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Управление по вопросам разоружения",
    Programme: "Разоружение",
    Subprogramme: "Оружие массового уничтожения",
    Title: "Государства-члены из Азиатско-Тихоокеанского региона определяют возможности для взаимодействия в рамках механизмов, направленных на противодействие угрозе, создаваемой распространением или применением биологического оружия",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Разоружение",
    Beneficiary: "Государства-члены в Латинской Америке и Карибском бассейне ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Продвижение усилий и инициатив в области разоружения, нераспространения и контроля над вооружениями",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CL,CO,CR,CU,DM,DO,EC,SV,GD,GT,GY,HT,HN,JM,MX,NI,PA,PY,PE,KN,LC,VC,SR,TT,UY,VE,AF,BH,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,IN,AP,ID,IR,IQ,JP,JO,KZ,KW,KG,LA,LB,MY,MV,MH,FM,MN,MM,NR,NP,OM,PK,PW,PG,PH,QA,KR,WS,SA,SG,SB,LK,SY,TJ,TH,TL,TO,TR,TM,TV,AE,UZ,VU,VN,YE",
    Image: "4ODA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ru#page=17"
  },
  {
    ID: 114,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Управление по вопросам разоружения",
    Programme: "Разоружение",
    Subprogramme: "Оружие массового уничтожения",
    Title: "Переход к достижению цели создания на Ближнем Востоке зоны, свободной от ядерного оружия и других видов оружия массового уничтожения",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Разоружение",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Продвижение усилий и инициатив в области разоружения, нераспространения и контроля над вооружениями",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,DJ,EG,QG,IR,IQ,JO,KW,LB,LY,MA,OM,QA,SA,SY,TN,AE,PS,YE",
    Image: "4ODA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ru#page=18"
  },
  {
    ID: 115,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Управление по вопросам разоружения",
    Programme: "Разоружение",
    Subprogramme: "Оружие массового уничтожения",
    Title: "Повышение уровня готовности Механизма Генерального секретаря  по расследованию предполагаемых случаев применения химического и биологического оружия",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Разоружение",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Продвижение усилий и инициатив в области разоружения, нераспространения и контроля над вооружениями",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ru#page=19"
  },
  {
    ID: 116,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Управление по вопросам разоружения",
    Programme: "Разоружение",
    Subprogramme: "Оружие массового уничтожения",
    Title: "Группа научных и технических экспертов по контролю за ядерным разоружением способствует лучшему пониманию технических проблем и возможных подходов в области контроля за ядерным разоружением",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Разоружение",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Продвижение усилий и инициатив в области разоружения, нераспространения и контроля над вооружениями",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ru#page=20"
  },
  {
    ID: 117,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Управление по вопросам разоружения",
    Programme: "Разоружение",
    Subprogramme: "Обычные вооружения",
    Title: "Более глубокое понимание последствий глобального роста военных расходов для хода достижения целей в области устойчивого развития, а также предложения по смягчению этих последствий",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Разоружение",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ru#page=26"
  },
  {
    ID: 118,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Управление по вопросам разоружения",
    Programme: "Разоружение",
    Subprogramme: "Обычные вооружения",
    Title: "Более широкое использование глобального механизма оказания помощи по вопросам управления боеприпасами на протяжении их жизненного цикла",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Разоружение",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Продвижение усилий и инициатив в области разоружения, нераспространения и контроля над вооружениями",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ru#page=27"
  },
  {
    ID: 119,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Управление по вопросам разоружения",
    Programme: "Разоружение",
    Subprogramme: "Обычные вооружения",
    Title: "Рассмотрение новшеств, связанных с изготовлением, технологией производства и конструкцией стрелкового оружия и легких вооружений, в целях предотвращения, пресечения и искоренения незаконной торговли ими и их неправомерного применения",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Разоружение",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Продвижение усилий и инициатив в области разоружения, нераспространения и контроля над вооружениями",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ru#page=28"
  },
  {
    ID: 120,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Управление по вопросам разоружения",
    Programme: "Разоружение",
    Subprogramme: "Обычные вооружения",
    Title: "Укрепление экспертного потенциала в целях содействия осуществлению Программы действий по стрелковому оружию и легким вооружениям и ее Международного документа по отслеживанию",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Разоружение",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Продвижение усилий и инициатив в области разоружения, нераспространения и контроля над вооружениями",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ru#page=29"
  },
  {
    ID: 121,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Управление по вопросам разоружения",
    Programme: "Разоружение",
    Subprogramme: "Региональное разоружение, наращивание потенциала и информационно-пропагандистская деятельность",
    Title: "Укрепление национального экспертного потенциала в области разоружения в целях содействия усилиям по разоружению",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Разоружение",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Продвижение усилий и инициатив в области разоружения, нераспространения и контроля над вооружениями",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SR,ZM",
    Image: "4ODA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ru#page=33"
  },
  {
    ID: 122,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Управление по вопросам разоружения",
    Programme: "Разоружение",
    Subprogramme: "Региональное разоружение, наращивание потенциала и информационно-пропагандистская деятельность",
    Title: "Глобальный механизм по достижениям в области информационно-коммуникационные технологий в контексте международной безопасности и поощрение ответственного поведения государств в сфере использования информационно-коммуникационных технологий",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Разоружение",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Продвижение усилий и инициатив в области разоружения, нераспространения и контроля над вооружениями",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ru#page=34"
  },
  {
    ID: 123,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Управление по вопросам разоружения",
    Programme: "Разоружение",
    Subprogramme: "Многосторонние переговоры и обсуждения по разоружению и ограничению вооружений",
    Title: "Увеличение числа экспертов по вопросам разоружения с помощью Программы стипендий, подготовки кадров и консультативных услуг Организации Объединенных Наций по разоружению",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Разоружение",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Продвижение усилий и инициатив в области разоружения, нераспространения и контроля над вооружениями",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ru#page=39"
  },
  {
    ID: 124,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Управление по вопросам разоружения",
    Programme: "Разоружение",
    Subprogramme: "Информационно-пропагандистская деятельность",
    Title: "Расширение прав и возможностей молодежи в области разоружения и нераспространения",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Разоружение",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Продвижение усилий и инициатив в области разоружения, нераспространения и контроля над вооружениями",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ru#page=39"
  },
  {
    ID: 125,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Управление по вопросам разоружения",
    Programme: "Разоружение",
    Subprogramme: "Информационно-пропагандистская деятельность",
    Title: "Повышение степени осведомленности о вопросах разоружения и нераспространения",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Разоружение",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Продвижение усилий и инициатив в области разоружения, нераспространения и контроля над вооружениями",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ru#page=40"
  },
  {
    ID: 126,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Управление по вопросам разоружения",
    Programme: "Разоружение",
    Subprogramme: "Региональное разоружение",
    Title: "Повышение степени осведомленности на региональном, субрегиональном и национальном уровнях и поддержка осуществления Глобального рамочного документа по вопросам управления обычными боеприпасами на протяжении их жизненного цикла",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Разоружение",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Продвижение усилий и инициатив в области разоружения, нераспространения и контроля над вооружениями",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ru#page=41"
  },
  {
    ID: 127,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Управление по вопросам разоружения",
    Programme: "Разоружение",
    Subprogramme: "Региональное разоружение",
    Title: "Более активная интеграция вопросов разоружения в национальные механизмы развития",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Разоружение",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Продвижение усилий и инициатив в области разоружения, нераспространения и контроля над вооружениями",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ru#page=41"
  },
  {
    ID: 128,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Департамент операций в пользу мира",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Оперативная деятельность",
    Title: "Ход осуществления Политического соглашения о мире и примирении в Центральноафриканской Республике 2019 года",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Государства-члены в Африке ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CF",
    Image: "5DPO1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=9"
  },
  {
    ID: 129,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Департамент операций в пользу мира",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Оперативная деятельность",
    Title: "Прогресс в осуществлении Обновленного соглашения об урегулировании конфликта в Республике Южный Судан 2018 года",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Государства-члены в Африке ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "SS,II",
    Image: "5DPO2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=10"
  },
  {
    ID: 130,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Департамент операций в пользу мира",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Оперативная деятельность",
    Title: "Укрепление миростроительства в Абьее на основе осуществления в нем совместной программы резидентов-координаторов в Судане и Южном Судане",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Государства-члены в Африке ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SS,II,SD,QQ",
    Image: "5DPO3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=11"
  },
  {
    ID: 131,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Департамент операций в пользу мира",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Оперативная деятельность",
    Title: "Активизация процессов разоружения, демобилизации, репатриации, расселения и реинтеграции иностранных комбатантов в восточной части Демократической Республики Конго",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Государства-члены в Африке ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CD",
    Image: "5DPO4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=12"
  },
  {
    ID: 132,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Департамент операций в пользу мира",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Военный компонент",
    Title: "Повышение готовности к процессам перехода и вывода миссий Организации Объединенных Наций по поддержанию мира",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Повышение эффективности, охраны и безопасности миссий по поддержанию мира, включая обеспечение плавного перехода в соответствии с резолюциями Совета Безопасности",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CY,LB,SS,II,SD,QQ",
    Image: "5DPO5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=15"
  },
  {
    ID: 133,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Департамент операций в пользу мира",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Военный компонент",
    Title: "Миссии обеспечивают возможности в плане обезвреживания взрывоопасных боеприпасов для реагирования на угрозы, исходящие от самодельных взрывных устройств",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Повышение эффективности, охраны и безопасности миссий по поддержанию мира, включая обеспечение плавного перехода в соответствии с резолюциями Совета Безопасности",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "LB",
    Image: "5DPO6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=16"
  },
  {
    ID: 134,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Департамент операций в пользу мира",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Военный компонент",
    Title: "Миротворческие операции реагируют на угрозы, исходящие от враждебных беспилотных авиационных систем",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Повышение эффективности, охраны и безопасности миссий по поддержанию мира, включая обеспечение плавного перехода в соответствии с резолюциями Совета Безопасности",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CD,ML",
    Image: "5DPO7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=17"
  },
  {
    ID: 135,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Департамент операций в пользу мира",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Военный компонент",
    Title: "Операции по поддержанию мира укрепляют механизмы мониторинга ложной информации, дезинформации и ненавистнических высказываний, их анализа и реагирования на такую информацию",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Повышение эффективности, охраны и безопасности миссий по поддержанию мира, включая обеспечение плавного перехода в соответствии с резолюциями Совета Безопасности",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CD,LB,ML,SS,II",
    Image: "5DPO8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=17"
  },
  {
    ID: 136,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Департамент операций в пользу мира",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Верховенство права и органы безопасности",
    Title: "Укрепление национального и регионального потенциала в области противодействия угрозам, создаваемым самодельными взрывными устройствами",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=22"
  },
  {
    ID: 137,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Департамент операций в пользу мира",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Верховенство права и органы безопасности",
    Title: "Улучшение работы полиции Организации Объединенных Наций в целях повышения эффективности выполнения мандата",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=23"
  },
  {
    ID: 138,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Департамент операций в пользу мира",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Верховенство права и органы безопасности",
    Title: "Предоставление принимающим государствам возможности продолжать и поддерживать прогресс в реформировании органов правопорядка и безопасности на этапе переходного периода в миссии и после него",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CF,CD,ML,SO",
    Image: "5DPO11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=23"
  },
  {
    ID: 139,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Департамент операций в пользу мира",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Верховенство права и органы безопасности",
    Title: "Повышение ответственности за преступления, совершенные в отношении персонала Организации Объединенных Наций, служащего в операциях по поддержанию мира",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CF,CD,LB,ML",
    Image: "5DPO12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=25"
  },
  {
    ID: 140,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Департамент операций в пользу мира",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Политика, оценка и обучение",
    Title: "Укрепление политики и руководящих принципов в области защиты гражданского населения в операциях по содействию миру, проводимых под руководством Африканского союза",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Государства-члены в Африке ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "5DPO13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=30"
  },
  {
    ID: 141,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Департамент операций в пользу мира",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Политика, оценка и обучение",
    Title: "Онлайновая платформа для налаживания прямого сотрудничества между государствами-членами в области подготовки миротворческого персонала",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=31"
  },
  {
    ID: 142,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Департамент операций в пользу мира",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Политика, оценка и обучение",
    Title: "Улучшение анализа и планирования на уровне полевых отделений в целях учета динамики местных конфликтов и содействия принятию политических решений",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=32"
  },
  {
    ID: 143,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Департамент операций в пользу мира",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Политика, оценка и обучение",
    Title: "Укрепление мер по предупреждению сексуального насилия, связанного с конфликтом, и реагированию на него в рамках операций по поддержанию мира",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Сокращение масштабов сексуального насилия, в том числе его использования в качестве метода ведения войны и террора, и сокращение масштабов насилия в отношении детей, включая серьезные нарушения, совершаемые в отношении детей в условиях вооруженного конфликта",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=32"
  },
  {
    ID: 144,
    BudgetSection: "5",
    Entity: "UNTSO",
    EntityFullName: "Орган Организации Объединенных Наций по наблюдению за выполнением условий перемирия",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Орган Организации Объединенных Наций по наблюдению за выполнением условий перемирия",
    Title: "Усиленное наблюдение вдоль линии прекращения огня и в районе разъединения",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=53"
  },
  {
    ID: 145,
    BudgetSection: "5",
    Entity: "UNTSO",
    EntityFullName: "Орган Организации Объединенных Наций по наблюдению за выполнением условий перемирия",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Орган Организации Объединенных Наций по наблюдению за выполнением условий перемирия",
    Title: "Повышение вовлеченности в выполнение мандата и работу Органа Организации Объединенных Наций по наблюдению за выполнением условий перемирия",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=54"
  },
  {
    ID: 146,
    BudgetSection: "5",
    Entity: "UNTSO",
    EntityFullName: "Орган Организации Объединенных Наций по наблюдению за выполнением условий перемирия",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Орган Организации Объединенных Наций по наблюдению за выполнением условий перемирия",
    Title: "Укрепление способности организации адаптироваться к изменяющимся условиям деятельности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности, охраны и безопасности миссий по поддержанию мира, включая обеспечение плавного перехода в соответствии с резолюциями Совета Безопасности",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=55"
  },
  {
    ID: 147,
    BudgetSection: "5",
    Entity: "UNTSO",
    EntityFullName: "Орган Организации Объединенных Наций по наблюдению за выполнением условий перемирия",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Орган Организации Объединенных Наций по наблюдению за выполнением условий перемирия",
    Title: "Укрепление механизмов планирования и координации в южных районах Ливана",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности, охраны и безопасности миссий по поддержанию мира, включая обеспечение плавного перехода в соответствии с резолюциями Совета Безопасности",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=55"
  },
  {
    ID: 148,
    BudgetSection: "5",
    Entity: "UNMOGIP",
    EntityFullName: "Группа военных наблюдателей Организации Объединенных Наций в Индии и Пакистане",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Группа военных наблюдателей Организации Объединенных Наций в Индии и Пакистане",
    Title: "Ограниченное число жалоб о предполагаемых нарушениях режима прекращения огня",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "IN,AP,PK",
    Image: "5DPO21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=63"
  },
  {
    ID: 149,
    BudgetSection: "5",
    Entity: "UNMOGIP",
    EntityFullName: "Группа военных наблюдателей Организации Объединенных Наций в Индии и Пакистане",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Группа военных наблюдателей Организации Объединенных Наций в Индии и Пакистане",
    Title: "Улучшение осведомленности о ситуации с использованием систем геопространственной информации",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "IN,AP,PK",
    Image: "5DPO22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=64"
  },
  {
    ID: 150,
    BudgetSection: "5",
    Entity: "UNMOGIP",
    EntityFullName: "Группа военных наблюдателей Организации Объединенных Наций в Индии и Пакистане",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Группа военных наблюдателей Организации Объединенных Наций в Индии и Пакистане",
    Title: "Непрерывное присутствие вдоль линии контроля",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "IN,AP,PK",
    Image: "5DPO23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=65"
  },
  {
    ID: 151,
    BudgetSection: "5",
    Entity: "UNMOGIP",
    EntityFullName: "Группа военных наблюдателей Организации Объединенных Наций в Индии и Пакистане",
    Programme: "Операции по поддержанию мира",
    Subprogramme: "Группа военных наблюдателей Организации Объединенных Наций в Индии и Пакистане",
    Title: "Углубление взаимопонимания благодаря укреплению связей и взаимодействия",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "IN,AP,PK",
    Image: "5DPO24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ru#page=66"
  },
  {
    ID: 152,
    BudgetSection: "6",
    Entity: "OOSA",
    EntityFullName: "Управление по вопросам космического пространства",
    Programme: "Использование космического пространства в мирных целях",
    Subprogramme: "Использование космического пространства в мирных целях",
    Title: "Совершенствование планирования и повышение готовности применительно к потенциально опасным объектам, сближающимся с Землей",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "6COPUOS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.6)&l=ru#page=5"
  },
  {
    ID: 153,
    BudgetSection: "6",
    Entity: "OOSA",
    EntityFullName: "Управление по вопросам космического пространства",
    Programme: "Использование космического пространства в мирных целях",
    Subprogramme: "Использование космического пространства в мирных целях",
    Title: "Расширение доступа к космическому пространству",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "6COPUOS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.6)&l=ru#page=6"
  },
  {
    ID: 154,
    BudgetSection: "6",
    Entity: "OOSA",
    EntityFullName: "Управление по вопросам космического пространства",
    Programme: "Использование космического пространства в мирных целях",
    Subprogramme: "Использование космического пространства в мирных целях",
    Title: "Расширение доступа к космическим решениям и возможностям для партнерства, наращивания потенциала и участия в регулировании космической деятельности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    SpecificResult: "Укрепление многосторонности",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "6COPUOS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.6)&l=ru#page=7"
  },
  {
    ID: 155,
    BudgetSection: "6",
    Entity: "OOSA",
    EntityFullName: "Управление по вопросам космического пространства",
    Programme: "Использование космического пространства в мирных целях",
    Subprogramme: "Использование космического пространства в мирных целях",
    Title: "Расширение использования космических технологий и данных для предотвращения и ликвидации последствий бедствий и экстренного реагирования",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поддержание международного мира и безопасности ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Технические достижения, позволяющие повысить качество, наличие, доступность и безопасность информации",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "6COPUOS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.6)&l=ru#page=7"
  },
  {
    ID: 156,
    BudgetSection: "7",
    Entity: "ICJ",
    EntityFullName: "Международный Суд",
    Programme: "Международный Суд",
    Subprogramme: "Секретариат Суда",
    Title: "Более глубокое понимание деятельности Суда широкой общественностью",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.7)&l=ru#page=4"
  },
  {
    ID: 157,
    BudgetSection: "7",
    Entity: "ICJ",
    EntityFullName: "Международный Суд",
    Programme: "Международный Суд",
    Subprogramme: "Секретариат Суда",
    Title: "Улучшение процесса передачи и получения документов, относящихся к судебным разбирательствам",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.7)&l=ru#page=5"
  },
  {
    ID: 158,
    BudgetSection: "7",
    Entity: "ICJ",
    EntityFullName: "Международный Суд",
    Programme: "Международный Суд",
    Subprogramme: "Секретариат Суда",
    Title: "Повышение доступности информации о Суде в социальных сетях",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.7)&l=ru#page=6"
  },
  {
    ID: 159,
    BudgetSection: "7",
    Entity: "ICJ",
    EntityFullName: "Международный Суд",
    Programme: "Международный Суд",
    Subprogramme: "Секретариат Суда",
    Title: "Повышение осведомленности молодежи о деятельности Суда и уровня понимания ею его деятельности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Молодежь",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.7)&l=ru#page=6"
  },
  {
    ID: 160,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Предоставление юридических услуг системе Организации Объединенных Наций в целом",
    Title: "Правовые рамки для создания новой полевой операции Организации Объединенных Наций в Гаити и оказания поддержки Многонациональным силам по пресечению бандитизма в Гаити",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Создание благоприятной нормативно-правовой базы; снижение риска наступления юридической ответственности",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "HT",
    Image: "8OLA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=11"
  },
  {
    ID: 161,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Предоставление юридических услуг системе Организации Объединенных Наций в целом",
    Title: "Заключение соглашения о сохранении остаточных функций чрезвычайных палат в судах Камбоджи",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Создание благоприятной нормативно-правовой базы; снижение риска наступления юридической ответственности",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "KH",
    Image: "8OLA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=12"
  },
  {
    ID: 162,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Предоставление юридических услуг системе Организации Объединенных Наций в целом",
    Title: "Наличие правовой и процедурной базы для конференций Организации Объединенных Наций, включая Конференцию Организации Объединенных Наций по водным ресурсам 2026 года для ускорения достижения цели 6 в области устойчивого развития «Обеспечение наличия и рационального использования водных ресурсов и санитарии для всех»",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Создание благоприятной нормативно-правовой базы; снижение риска наступления юридической ответственности",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SN,AE",
    Image: "8OLA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=12"
  },
  {
    ID: 163,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Предоставление юридических услуг системе Организации Объединенных Наций в целом",
    Title: "Продвижение организационных реформ и институциональных преобразований",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Создание благоприятной нормативно-правовой базы; снижение риска наступления юридической ответственности",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=13"
  },
  {
    ID: 164,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Предоставление услуг общеправового характера органам и программам Организации Объединенных Наций",
    Title: "Доступ обслуживаемых подразделений к шаблонам типовых договоров",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Создание благоприятной нормативно-правовой базы; снижение риска наступления юридической ответственности",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=17"
  },
  {
    ID: 165,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Предоставление услуг общеправового характера органам и программам Организации Объединенных Наций",
    Title: "Облегчение доступа клиентов к юридическим консультациям благодаря обновленной системе управления делами",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Создание благоприятной нормативно-правовой базы; снижение риска наступления юридической ответственности",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=17"
  },
  {
    ID: 166,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Предоставление услуг общеправового характера органам и программам Организации Объединенных Наций",
    Title: "Наличие у клиентов доступа к обновленным общим условиям контрактов Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Создание благоприятной нормативно-правовой базы; снижение риска наступления юридической ответственности",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=18"
  },
  {
    ID: 167,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Предоставление услуг общеправового характера органам и программам Организации Объединенных Наций",
    Title: "Предоставление клиентам доступа к обновленному типовому контракту на оказание услуг по перевозке грузов воздушным транспортом",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Создание благоприятной нормативно-правовой базы; снижение риска наступления юридической ответственности",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=18"
  },
  {
    ID: 168,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Прогрессивное развитие и кодификация международного права",
    Title: "Специальный комитет по Уставу Организации Объединенных Наций и усилению роли Организации утвердил доклад по вопросам существа",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=21"
  },
  {
    ID: 169,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Прогрессивное развитие и кодификация международного права",
    Title: "Поступление от большего числа государств заявок на участие в учебных программах по международному праву в рамках Программы помощи",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=21"
  },
  {
    ID: 170,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Прогрессивное развитие и кодификация международного права",
    Title: "Расширение доступа международного юридического сообщества к документальным материалам юридического характера, которые касаются Организации Объединенных Наций и связанных с ней межправительственных организаций и содержатся в Юридическом ежегоднике Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=22"
  },
  {
    ID: 171,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Прогрессивное развитие и кодификация международного права",
    Title: "Более глубокое понимание правовых вопросов, связанных с урегулированием споров, в которых участвуют международные организации",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=23"
  },
  {
    ID: 172,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Морское право и вопросы океана",
    Title: "Выполнены необходимые условия для вступления в силу Соглашения о морском биологическом разнообразии в районах за пределами действия национальной юрисдикции",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Климат и окружающая среда ",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=27"
  },
  {
    ID: 173,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Морское право и вопросы океана",
    Title: "Усиление приверженности государств-членов сохранению Мирового океана и его ресурсов и рачительному пользованию ими путем применения международного права",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Климат и окружающая среда ",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=27"
  },
  {
    ID: 174,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Морское право и вопросы океана",
    Title: "Укрепление научно-политического взаимодействия в контексте защиты морской среды и сохранения и рачительного использования морских ресурсов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Климат и окружающая среда ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=28"
  },
  {
    ID: 175,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Морское право и вопросы океана",
    Title: "Усиление роли Комиссии по границам континентального шельфа и ее подкомиссий в соответствии с Конвенцией",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Климат и окружающая среда ",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=29"
  },
  {
    ID: 176,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Прогрессивное согласование, модернизация и унификация права международной торговли",
    Title: "Укрепление потенциала судебных органов в вопросах применения рекомендаций, содержащихся в документах Комиссии Организации Объединенных Наций по праву международной торговли в отношении законодательства о несостоятельности",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Частный сектор, включая микро-, малые и средние предприятия ",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=34"
  },
  {
    ID: 177,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Прогрессивное согласование, модернизация и унификация права международной торговли",
    Title: "Повышение правовой определенности при проведении коммерческих операций с данными",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Частный сектор, включая микро-, малые и средние предприятия ",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=35"
  },
  {
    ID: 178,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Прогрессивное согласование, модернизация и унификация права международной торговли",
    Title: "Рассмотрение Комиссией Организации Объединенных Наций по праву международной торговли вопроса об актуальности своих документов в отношении механизмов публичных закупок",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=36"
  },
  {
    ID: 179,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Прогрессивное согласование, модернизация и унификация права международной торговли",
    Title: "Осуществление реформ в области урегулирования споров между инвесторами и государствами с помощью механизма многосторонней рамочной конвенции",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Частный сектор, включая микро-, малые и средние предприятия ",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=37"
  },
  {
    ID: 180,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Хранение, регистрация и опубликование договоров",
    Title: "Открытие для подписания Конвенции Организации Объединенных Наций против киберпреступности; укрепление международного сотрудничества в борьбе с определенными преступлениями, совершаемыми с использованием информационно- коммуникационных систем, и в обмене доказательствами в электронной форме, относящимися к серьезным преступлениям",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=40"
  },
  {
    ID: 181,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Хранение, регистрация и опубликование договоров",
    Title: "Дальнейшее обсуждение государствами-членами договорной практики",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=41"
  },
  {
    ID: 182,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Хранение, регистрация и опубликование договоров",
    Title: "Размещение договоров и договорных актов в открытом доступе в Сборнике договоров Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=42"
  },
  {
    ID: 183,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Управление по правовым вопросам",
    Programme: "Правовые вопросы",
    Subprogramme: "Хранение, регистрация и опубликование договоров",
    Title: "Государства-члены рассматривают роль международного сотрудничества, в том числе в области использования технологий и наращивания потенциала, в укреплении международного договорного режима",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=42"
  },
  {
    ID: 184,
    BudgetSection: "8",
    Entity: "IIMM",
    EntityFullName: "Независимый механизм по расследованию для Мьянмы",
    Programme: "Правовые вопросы",
    Subprogramme: "Независимый механизм по расследованию для Мьянмы",
    Title: "Компетентные органы имеют доступ к криминалистической оценке информации из открытых источников",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "MM",
    Image: "8OLA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=70"
  },
  {
    ID: 185,
    BudgetSection: "8",
    Entity: "IIMM",
    EntityFullName: "Независимый механизм по расследованию для Мьянмы",
    Programme: "Правовые вопросы",
    Subprogramme: "Независимый механизм по расследованию для Мьянмы",
    Title: "Участие жертв, пострадавших, представителей гражданского общества и лиц, предоставляющих информацию, в процессах привлечения виновных к ответственности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "MM",
    Image: "8OLA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=71"
  },
  {
    ID: 186,
    BudgetSection: "8",
    Entity: "IIMM",
    EntityFullName: "Независимый механизм по расследованию для Мьянмы",
    Programme: "Правовые вопросы",
    Subprogramme: "Независимый механизм по расследованию для Мьянмы",
    Title: "Расширение доступа к максимально приемлемым доказательствам в национальных, региональных и международных судах",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "MM",
    Image: "8OLA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=72"
  },
  {
    ID: 187,
    BudgetSection: "8",
    Entity: "IIMM",
    EntityFullName: "Независимый механизм по расследованию для Мьянмы",
    Programme: "Правовые вопросы",
    Subprogramme: "Независимый механизм по расследованию для Мьянмы",
    Title: "Свидетели и источники информации вносят свой вклад в работу, направленную на привлечение к ответственности, в условиях безопасности и при наличии необходимой психосоциальной поддержки",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "MM",
    Image: "8OLA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=73"
  },
  {
    ID: 188,
    BudgetSection: "8",
    Entity: "IIIM",
    EntityFullName: "Международный беспристрастный и независимый механизм для содействия проведению расследований в отношении лиц, которые несут ответственность за наиболее серьезные преступления по международному праву, совершенные в Сирийской Арабской Республике с марта 2011 года, и их судебному преследованию",
    Programme: "Правовые вопросы",
    Subprogramme: "Международный беспристрастный и независимый механизм для содействия проведению расследований в отношении лиц, которые несут ответственность за наиболее серьезные преступления по международному праву, совершенные в Сирийской Арабской Республике с марта 2011 года, и их судебному преследованию",
    Title: "Шаги на пути к правосудию переходного периода под руководством сирийских властей",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SY",
    Image: "8OLA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=83"
  },
  {
    ID: 189,
    BudgetSection: "8",
    Entity: "IIIM",
    EntityFullName: "Международный беспристрастный и независимый механизм для содействия проведению расследований в отношении лиц, которые несут ответственность за наиболее серьезные преступления по международному праву, совершенные в Сирийской Арабской Республике с марта 2011 года, и их судебному преследованию",
    Programme: "Правовые вопросы",
    Subprogramme: "Международный беспристрастный и независимый механизм для содействия проведению расследований в отношении лиц, которые несут ответственность за наиболее серьезные преступления по международному праву, совершенные в Сирийской Арабской Республике с марта 2011 года, и их судебному преследованию",
    Title: "Усиление защиты и поддержки жертв, свидетелей и других лиц, сотрудничающих с Механизмом",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SY",
    Image: "8OLA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=84"
  },
  {
    ID: 190,
    BudgetSection: "8",
    Entity: "IIIM",
    EntityFullName: "Международный беспристрастный и независимый механизм для содействия проведению расследований в отношении лиц, которые несут ответственность за наиболее серьезные преступления по международному праву, совершенные в Сирийской Арабской Республике с марта 2011 года, и их судебному преследованию",
    Programme: "Правовые вопросы",
    Subprogramme: "Международный беспристрастный и независимый механизм для содействия проведению расследований в отношении лиц, которые несут ответственность за наиболее серьезные преступления по международному праву, совершенные в Сирийской Арабской Республике с марта 2011 года, и их судебному преследованию",
    Title: "Применение комплексного подхода при отправлении инклюзивного правосудия",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "SY",
    Image: "8OLA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=85"
  },
  {
    ID: 191,
    BudgetSection: "8",
    Entity: "IIIM",
    EntityFullName: "Международный беспристрастный и независимый механизм для содействия проведению расследований в отношении лиц, которые несут ответственность за наиболее серьезные преступления по международному праву, совершенные в Сирийской Арабской Республике с марта 2011 года, и их судебному преследованию",
    Programme: "Правовые вопросы",
    Subprogramme: "Международный беспристрастный и независимый механизм для содействия проведению расследований в отношении лиц, которые несут ответственность за наиболее серьезные преступления по международному праву, совершенные в Сирийской Арабской Республике с марта 2011 года, и их судебному преследованию",
    Title: "Обеспечение установления истины, справедливости и ответственности за наиболее тяжкие преступления по международному праву, совершенные в Сирийской Арабской Республике с 2011 года, под руководством сирийцев и под их контролем",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие правосудию и развитию международного права ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SY",
    Image: "8OLA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ru#page=85"
  },
  {
    ID: 192,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Межправительственная поддержка и координация в интересах устойчивого развития",
    Title: "Подтвержденные политические обязательства в отношении Повестки дня в области устойчивого развития на период до 2030 года в связи с ее десятой годовщиной",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=20"
  },
  {
    ID: 193,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Межправительственная поддержка и координация в интересах устойчивого развития",
    Title: "Укрепление роли Экономического и Социального Совета в оказании поддержки государствам-членам в целях воплощения обязательств, принятых на Саммите по целям в области устойчивого развития, в практические действия и национальные стратегии",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление потенциала для подготовки отчетности о прогрессе в достижении ЦУР; увеличение числа/повышение качества добровольных национальных обзоров",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=20"
  },
  {
    ID: 194,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Межправительственная поддержка и координация в интересах устойчивого развития",
    Title: "Ускоренное достижение целей в области устойчивого развития благодаря эффективному процессу подготовки добровольных национальных обзоров",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление потенциала для подготовки отчетности о прогрессе в достижении ЦУР; увеличение числа/повышение качества добровольных национальных обзоров",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=21"
  },
  {
    ID: 195,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Межправительственная поддержка и координация в интересах устойчивого развития",
    Title: "Усиление руководящей роли Экономического и Социального Совета в системе развития Организации Объединенных Наций в целях более эффективного осуществления оперативной деятельности в интересах развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=22"
  },
  {
    ID: 196,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Всеохватное социальное развитие",
    Title: "«Доклад о мировом социальном положении» за 2025 год послужил основой для диалога по вопросам социальной политики в межправительственных органах",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=26"
  },
  {
    ID: 197,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Всеохватное социальное развитие",
    Title: "Повышение согласованности усилий системы Организации Объединенных Наций по удовлетворению потребностей коренных народов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=27"
  },
  {
    ID: 198,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Всеохватное социальное развитие",
    Title: "Ускоренное социальное развитие благодаря второй Всемирной встрече на высшем уровне в интересах социального развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=28"
  },
  {
    ID: 199,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Всеохватное социальное развитие",
    Title: "Повышение качества жизни пожилых людей по итогам пятого обзора и оценки хода осуществления Мадридского международного плана действий по проблемам старения",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=28"
  },
  {
    ID: 200,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Устойчивое развитие",
    Title: "Обнародован план осуществления Десятилетия Организации Объединенных Наций, посвященного устойчивому транспорту (2026–2035 годы)",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=32"
  },
  {
    ID: 201,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Устойчивое развитие",
    Title: "Ускорение прогресса в достижении цели 14 в области устойчивого развития на основе третьей Конференции Организации Объединенных Наций по океану",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=33"
  },
  {
    ID: 202,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Устойчивое развитие",
    Title: "Ускорение достижения цели 6 в области устойчивого развития на основе Конференции Организации Объединенных Наций по водным ресурсам 2026 года",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=33"
  },
  {
    ID: 203,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Устойчивое развитие",
    Title: "«Доклад об устойчивом развитии в мире» за 2027 год служит ориентиром для реализации Повестки дня на период до 2030 года",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=34"
  },
  {
    ID: 204,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Статистика",
    Title: "Пользователи лучше понимают статистику миграции",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=38"
  },
  {
    ID: 205,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Статистика",
    Title: "Модернизация портала UNdata в качестве единого отправного пункта для получения достоверных статистических данных от системы Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=39"
  },
  {
    ID: 206,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Статистика",
    Title: "Укрепление глобального потенциала для отслеживания хода достижения целей в области устойчивого развития на основе фактических данных",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=39"
  },
  {
    ID: 207,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Статистика",
    Title: "Государства-члены внедряют Систему национальных счетов 2025 года",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=40"
  },
  {
    ID: 208,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Народонаселение",
    Title: "Прогнозы численности населения на национальном и провинциальном уровнях, составленные с использованием общепризнанных на международном уровне вероятностных методов",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Повышение качества информации о народонаселении, миграции, регистрации актов гражданского состояния и демографической ситуации, включая статистические данные в разбивке по признаку пола",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "UG",
    Image: "9DESA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=45"
  },
  {
    ID: 209,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Народонаселение",
    Title: "Повышение сопоставимости оценок и прогнозов урбанизации и географического распределения населения в интересах достижения целей в области устойчивого развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=46"
  },
  {
    ID: 210,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Народонаселение",
    Title: "Совершенствование онлайн-инструментов для демографического анализа, прогнозирования и визуализации",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Повышение качества информации о народонаселении, миграции, регистрации актов гражданского состояния и демографической ситуации, включая статистические данные в разбивке по признаку пола",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=46"
  },
  {
    ID: 211,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Народонаселение",
    Title: "Укрепление доказательной базы по вопросам международной миграции в целях содействия разработке политики и улучшению информационной составляющей общественных обсуждений",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Повышение качества информации о народонаселении, миграции, регистрации актов гражданского состояния и демографической ситуации, включая статистические данные в разбивке по признаку пола",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=47"
  },
  {
    ID: 212,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Экономический анализ и политика",
    Title: "Усовершенствованные цифровые инструменты для углубления знаний государственных служащих в области макроэкономики и торговли",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=51"
  },
  {
    ID: 213,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Экономический анализ и политика",
    Title: "Использование передовых инструментов моделирования политики для разработки политики на основе данных и фактических сведений",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Укрепление потенциала для подготовки отчетности о прогрессе в достижении ЦУР; увеличение числа/повышение качества добровольных национальных обзоров",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=52"
  },
  {
    ID: 214,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Экономический анализ и политика",
    Title: "Расширение участия и активизация использования аналитических материалов для разработки политики на основе фактических данных",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=53"
  },
  {
    ID: 215,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Экономический анализ и политика",
    Title: "Наименее развитые страны готовы пройти процесс выхода из категории наименее развитых стран и адаптироваться к условиям, которые возникнут после этого перехода",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "9DESA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=53"
  },
  {
    ID: 216,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Инновации и цифровые преобразования",
    Title: "Высшие ревизионные учреждения провели оценку хода реализации 13 цели в области устойчивого развития, касающейся борьбы с изменением климата",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Климат и окружающая среда ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=58"
  },
  {
    ID: 217,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Инновации и цифровые преобразования",
    Title: "Внедрение на национальном уровне принципов эффективного государственного управления в интересах устойчивого развития для повышения доверия к государственным учреждениям",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=59"
  },
  {
    ID: 218,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Инновации и цифровые преобразования",
    Title: "Эффективное и устойчивое реагирование на будущие вызовы и возможности для ускорения устойчивого развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=60"
  },
  {
    ID: 219,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Инновации и цифровые преобразования",
    Title: "Государственные служащие применяют знания в области поведенческих наук и внедряют передовой опыт для содействия инновациям и цифровой трансформации",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=60"
  },
  {
    ID: 220,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Неистощительное лесопользование",
    Title: "Государства-члены приступают к реализации новой четырехлетней программы работы (2025–2028 годы) по ускоренной реализации Стратегического плана Организации Объединенных Наций по лесам",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Климат и окружающая среда ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=65"
  },
  {
    ID: 221,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Неистощительное лесопользование",
    Title: "Расширение охвата Форума Организации Объединенных Наций по лесам и увеличение вклада лесов в реализацию Повестки дня на период до 2030 года",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Климат и окружающая среда ",
    SpecificResult: "Укрепление потенциала для подготовки отчетности о прогрессе в достижении ЦУР; увеличение числа/повышение качества добровольных национальных обзоров",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=65"
  },
  {
    ID: 222,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Неистощительное лесопользование",
    Title: "Содействие достижению целей в области устойчивого развития через стратегический план Организации Объединенных Наций по лесам на 2017–2030 годы",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Климат и окружающая среда ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=66"
  },
  {
    ID: 223,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Неистощительное лесопользование",
    Title: "Укрепление приверженности и активизация деятельности в рамках Международного механизма по лесам в целях достижения глобальных целей в отношении лесов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Климат и окружающая среда ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=67"
  },
  {
    ID: 224,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Финансирование устойчивого развития",
    Title: "«Севильское обязательство» как новая концепция финансирования, принятая в рамках реализации Аддис-Абебской программы действий",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=71"
  },
  {
    ID: 225,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Финансирование устойчивого развития",
    Title: "Более активное участие государств-членов в процессе последующей деятельности в области финансирования развития в целях повышения согласованности и эффективности осуществления принятых итоговых документов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=72"
  },
  {
    ID: 226,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Финансирование устойчивого развития",
    Title: "Расширение участия развивающихся стран в формировании международных налоговых норм",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=73"
  },
  {
    ID: 227,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Департамент по экономическим и социальным вопросам",
    Programme: "Экономические и социальные вопросы",
    Subprogramme: "Финансирование устойчивого развития",
    Title: "Создана система управления международным долгом",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ru#page=73"
  },
  {
    ID: 228,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Канцелярия Высокого представителя по наименее развитым странам, развивающимся странам, не имеющим выхода к морю, и малым островным развивающимся государствам",
    Programme: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю,  и малые островные развивающиеся государства",
    Subprogramme: "Наименее развитые страны",
    Title: "Ускоренное осуществление и более эффективный мониторинг Дохинской программы действий для наименее развитых стран",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление потенциала для подготовки отчетности о прогрессе в достижении ЦУР; увеличение числа/повышение качества добровольных национальных обзоров",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ru#page=9"
  },
  {
    ID: 229,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Канцелярия Высокого представителя по наименее развитым странам, развивающимся странам, не имеющим выхода к морю, и малым островным развивающимся государствам",
    Programme: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю,  и малые островные развивающиеся государства",
    Subprogramme: "Наименее развитые страны",
    Title: "Создание нового механизма накопления запасов продовольствия в целях уменьшения остроты проблемы отсутствия продовольственной безопасности в наименее развитых странах",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ru#page=10"
  },
  {
    ID: 230,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Канцелярия Высокого представителя по наименее развитым странам, развивающимся странам, не имеющим выхода к морю, и малым островным развивающимся государствам",
    Programme: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю,  и малые островные развивающиеся государства",
    Subprogramme: "Наименее развитые страны",
    Title: "Повышение устойчивости к внешним потрясениям в наименее развитых странах",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Инклюзивное и устойчивое восстановление после бедствий; повышение устойчивости к будущим бедствиям",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ru#page=11"
  },
  {
    ID: 231,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Канцелярия Высокого представителя по наименее развитым странам, развивающимся странам, не имеющим выхода к морю, и малым островным развивающимся государствам",
    Programme: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю,  и малые островные развивающиеся государства",
    Subprogramme: "Наименее развитые страны",
    Title: "Наименее развитые страны расширяют возможности для устойчивого и необратимого выхода из категории наименее развитых стран",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ru#page=12"
  },
  {
    ID: 232,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Канцелярия Высокого представителя по наименее развитым странам, развивающимся странам, не имеющим выхода к морю, и малым островным развивающимся государствам",
    Programme: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю,  и малые островные развивающиеся государства",
    Subprogramme: "Развивающиеся страны, не имеющие выхода к морю",
    Title: "Принятие Авазинской политической декларации на третьей Конференции Организации Объединенных Наций по развивающимся странам, не имеющим выхода к морю",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ru#page=15"
  },
  {
    ID: 233,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Канцелярия Высокого представителя по наименее развитым странам, развивающимся странам, не имеющим выхода к морю, и малым островным развивающимся государствам",
    Programme: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю,  и малые островные развивающиеся государства",
    Subprogramme: "Развивающиеся страны, не имеющие выхода к морю",
    Title: "Осуществление стратегических инициатив по финансированию развития в целях повышения экономической устойчивости развивающихся стран, не имеющих выхода к морю",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ru#page=16"
  },
  {
    ID: 234,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Канцелярия Высокого представителя по наименее развитым странам, развивающимся странам, не имеющим выхода к морю, и малым островным развивающимся государствам",
    Programme: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю,  и малые островные развивающиеся государства",
    Subprogramme: "Развивающиеся страны, не имеющие выхода к морю",
    Title: "Продвижение вопросов свободы транзита для развивающихся стран, не имеющих выхода к морю",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ru#page=17"
  },
  {
    ID: 235,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Канцелярия Высокого представителя по наименее развитым странам, развивающимся странам, не имеющим выхода к морю, и малым островным развивающимся государствам",
    Programme: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю,  и малые островные развивающиеся государства",
    Subprogramme: "Развивающиеся страны, не имеющие выхода к морю",
    Title: "Всесторонний учет Авазинской программы действий для развивающихся стран, не имеющих выхода к морю, в национальных и секторальных стратегиях развития, рамочных программах по сотрудничеству в области развития и стратегических планах",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ru#page=18"
  },
  {
    ID: 236,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Канцелярия Высокого представителя по наименее развитым странам, развивающимся странам, не имеющим выхода к морю, и малым островным развивающимся государствам",
    Programme: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю,  и малые островные развивающиеся государства",
    Subprogramme: "Малые островные развивающиеся государства",
    Title: "Улучшение ситуации с приемлемостью задолженности малых островных развивающихся государств",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ru#page=22"
  },
  {
    ID: 237,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Канцелярия Высокого представителя по наименее развитым странам, развивающимся странам, не имеющим выхода к морю, и малым островным развивающимся государствам",
    Programme: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю,  и малые островные развивающиеся государства",
    Subprogramme: "Малые островные развивающиеся государства",
    Title: "Принятие решений на основе данных для устранения структурной уязвимости и повышения жизнестойкости малых островных развивающихся государств",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ru#page=23"
  },
  {
    ID: 238,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Канцелярия Высокого представителя по наименее развитым странам, развивающимся странам, не имеющим выхода к морю, и малым островным развивающимся государствам",
    Programme: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю,  и малые островные развивающиеся государства",
    Subprogramme: "Малые островные развивающиеся государства",
    Title: "Использование малыми островными развивающимися государствами механизма мониторинга и отчетности в рамках Повестки дня Антигуа и Барбуды для малых островных развивающихся государств для обоснования национальных стратегий планирования",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление потенциала для подготовки отчетности о прогрессе в достижении ЦУР; увеличение числа/повышение качества добровольных национальных обзоров",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ru#page=24"
  },
  {
    ID: 239,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Канцелярия Высокого представителя по наименее развитым странам, развивающимся странам, не имеющим выхода к морю, и малым островным развивающимся государствам",
    Programme: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю,  и малые островные развивающиеся государства",
    Subprogramme: "Малые островные развивающиеся государства",
    Title: "Налаживание стратегических партнерств для ускорения осуществления Повестки дня Антигуа и Барбуды для малых островных развивающихся государств",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Улучшение сотрудничества и партнерских отношений, повышение согласованности и синергии и уменьшение дублирования благодаря последовательной коммуникации",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ru#page=24"
  },
  {
    ID: 240,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Канцелярия Высокого представителя по наименее развитым странам, развивающимся странам, не имеющим выхода к морю, и малым островным развивающимся государствам",
    Programme: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю,  и малые островные развивающиеся государства",
    Subprogramme: "Информационно-пропагандистская, просветительская и аналитическая деятельность",
    Title: "Более полный учет всех трех программ действий в соответствующих межправительственных процессах",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление потенциала для подготовки отчетности о прогрессе в достижении ЦУР; увеличение числа/повышение качества добровольных национальных обзоров",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AO,AG,AM,AZ,BS,SD,QQ,BD,BZ,BJ,BT,BO,BW,BF,BI,CV,KH,CF,TD,KM,CK,CU,CD,DJ,DM,DO,ER,SZ,ET,FJ,GM,GD,GN,GW,HT,JM,KZ,KG,KI,LA,LS,LR,MK,MG,MW,MV,ML,MH,MR,MU,FM,MN,MZ,MM,NR,NP,NE,NU,PW,PG,PY,MD,RW,KN,LC,VC,WS,SN,SC,SL,SB,SO,SS,II,SD,QQ,SR,TJ,TL,TG,TO,TT,TM,TV,UG,TZ,UZ,VU,YE,ZM,ZW",
    Image: "10UNOHRLLS13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ru#page=28"
  },
  {
    ID: 241,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Канцелярия Высокого представителя по наименее развитым странам, развивающимся странам, не имеющим выхода к морю, и малым островным развивающимся государствам",
    Programme: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю,  и малые островные развивающиеся государства",
    Subprogramme: "Информационно-пропагандистская, просветительская и аналитическая деятельность",
    Title: "Аналитика в режиме реального времени и мониторинг всех трех программ действий для использования такой информации в процессах разработки политики, планирования и принятия решений",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,AG,AM,AZ,BS,SD,QQ,BD,BZ,BJ,BT,BO,BW,BF,BI,CV,KH,CF,TD,KM,CK,CU,CD,DJ,DM,DO,ER,SZ,ET,FJ,GM,GD,GN,GW,HT,JM,KZ,KG,KI,LA,LS,LR,MK,MG,MW,MV,ML,MH,MR,MU,FM,MN,MZ,MM,NR,NP,NE,NU,PW,PG,PY,MD,RW,KN,LC,VC,WS,SN,SC,SL,SB,SO,SS,II,SD,QQ,SR,TJ,TL,TG,TO,TT,TM,TV,UG,TZ,UZ,VU,YE,ZM,ZW",
    Image: "10UNOHRLLS14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ru#page=29"
  },
  {
    ID: 242,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Канцелярия Специального советника по Африке",
    Programme: "Поддержка системой Организации Объединенных Наций Повестки дня Африканского союза на период до 2063 года «Африка, какой мы хотим ее видеть»",
    Subprogramme: "Управление данными и знаниями в интересах основанной на фактах политики и информационно-просветительской деятельности в поддержку Повестки дня на период до 2063 года",
    Title: "Применение лицами, ответственными за разработку политики в странах Африки, комплексных аналитических подходов для содействия достижению долгосрочных результатов в области мира и развития",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Развитие Африки",
    Beneficiary: "Государства-члены в Африке ",
    BeneficiaryTwo: " ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ru#page=10"
  },
  {
    ID: 243,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Канцелярия Специального советника по Африке",
    Programme: "Поддержка системой Организации Объединенных Наций Повестки дня Африканского союза на период до 2063 года «Африка, какой мы хотим ее видеть»",
    Subprogramme: "Управление данными и знаниями в интересах основанной на фактах политики и информационно-просветительской деятельности в поддержку Повестки дня на период до 2063 года",
    Title: "Цифровые решения для преобразования финансовых систем и управления долгом в Африке",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государства-члены в Африке ",
    BeneficiaryTwo: " ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ru#page=11"
  },
  {
    ID: 244,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Канцелярия Специального советника по Африке",
    Programme: "Поддержка системой Организации Объединенных Наций Повестки дня Африканского союза на период до 2063 года «Африка, какой мы хотим ее видеть»",
    Subprogramme: "Управление данными и знаниями в интересах основанной на фактах политики и информационно-просветительской деятельности в поддержку Повестки дня на период до 2063 года",
    Title: "Экосистемы стратегий для подготовки африканских кадров к работе в условиях глобальной цифровой экономики",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государства-члены в Африке ",
    BeneficiaryTwo: "Частный сектор, включая микро-, малые и средние предприятия ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ru#page=12"
  },
  {
    ID: 245,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Канцелярия Специального советника по Африке",
    Programme: "Поддержка системой Организации Объединенных Наций Повестки дня Африканского союза на период до 2063 года «Африка, какой мы хотим ее видеть»",
    Subprogramme: "Управление данными и знаниями в интересах основанной на фактах политики и информационно-просветительской деятельности в поддержку Повестки дня на период до 2063 года",
    Title: "Совершенствование политики, касающейся образования и развития навыков молодежи, в целях решения проблемы отсутствия продовольственной безопасности и содействия климатической жизнестойкости в Африке",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государства-члены в Африке ",
    BeneficiaryTwo: "Молодежь",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ru#page=12"
  },
  {
    ID: 246,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Канцелярия Специального советника по Африке",
    Programme: "Поддержка системой Организации Объединенных Наций Повестки дня Африканского союза на период до 2063 года «Африка, какой мы хотим ее видеть»",
    Subprogramme: "Региональная координация поддержки Организацией Объединенных Наций комплексного осуществления Повестки дня в области устойчивого развития на период до 2030 года и Повестки дня на период до 2063 года",
    Title: "Стратегия мобилизации внутренних ресурсов, принятая для финансирования второго десятилетнего плана осуществления Повестки дня на период до 2063 года",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Развитие Африки",
    Beneficiary: "Государства-члены в Африке ",
    BeneficiaryTwo: " ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ru#page=17"
  },
  {
    ID: 247,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Канцелярия Специального советника по Африке",
    Programme: "Поддержка системой Организации Объединенных Наций Повестки дня Африканского союза на период до 2063 года «Африка, какой мы хотим ее видеть»",
    Subprogramme: "Региональная координация поддержки Организацией Объединенных Наций комплексного осуществления Повестки дня в области устойчивого развития на период до 2030 года и Повестки дня на период до 2063 года",
    Title: "Долгосрочные стратегии управления долгом в Африке",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государства-члены в Африке ",
    BeneficiaryTwo: " ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ru#page=17"
  },
  {
    ID: 248,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Канцелярия Специального советника по Африке",
    Programme: "Поддержка системой Организации Объединенных Наций Повестки дня Африканского союза на период до 2063 года «Африка, какой мы хотим ее видеть»",
    Subprogramme: "Региональная координация поддержки Организацией Объединенных Наций комплексного осуществления Повестки дня в области устойчивого развития на период до 2030 года и Повестки дня на период до 2063 года",
    Title: "Повышение оперативности реагирования и подотчетности государственных учреждений",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государства-члены в Африке ",
    BeneficiaryTwo: "Государственное управление ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ru#page=18"
  },
  {
    ID: 249,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Канцелярия Специального советника по Африке",
    Programme: "Поддержка системой Организации Объединенных Наций Повестки дня Африканского союза на период до 2063 года «Африка, какой мы хотим ее видеть»",
    Subprogramme: "Региональная координация поддержки Организацией Объединенных Наций комплексного осуществления Повестки дня в области устойчивого развития на период до 2030 года и Повестки дня на период до 2063 года",
    Title: "Разработка африканскими государствами-членами политики по преодолению последствий изменения климата",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государства-члены в Африке ",
    BeneficiaryTwo: "Климат и окружающая среда ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ru#page=18"
  },
  {
    ID: 250,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Канцелярия Специального советника по Африке",
    Programme: "Поддержка системой Организации Объединенных Наций Повестки дня Африканского союза на период до 2063 года «Африка, какой мы хотим ее видеть»",
    Subprogramme: "Деятельность по информированию и повышению осведомленности общественности в поддержку Повестки дня на период до 2063 года",
    Title: "Освещение позиций африканских стран по вопросам искусственного интеллекта и занятости в цифровой сфере в рамках партнерства со средствами массовой информации с охватом 130 миллионов человек",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Развитие Африки",
    Beneficiary: "Государства-члены в Африке ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ru#page=22"
  },
  {
    ID: 251,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Канцелярия Специального советника по Африке",
    Programme: "Поддержка системой Организации Объединенных Наций Повестки дня Африканского союза на период до 2063 года «Африка, какой мы хотим ее видеть»",
    Subprogramme: "Деятельность по информированию и повышению осведомленности общественности в поддержку Повестки дня на период до 2063 года",
    Title: "Привлечение широкой общественности к обсуждению проблемы долгового бремени Африки и поиску возможных решений",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государства-члены в Африке ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ru#page=23"
  },
  {
    ID: 252,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Канцелярия Специального советника по Африке",
    Programme: "Поддержка системой Организации Объединенных Наций Повестки дня Африканского союза на период до 2063 года «Африка, какой мы хотим ее видеть»",
    Subprogramme: "Деятельность по информированию и повышению осведомленности общественности в поддержку Повестки дня на период до 2063 года",
    Title: "Активизация информационно-просветительской деятельности партнеров из числа средств массовой информации по вопросам образования, достойной занятости и социальной защиты в Африке",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государства-члены в Африке ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Улучшение сотрудничества и партнерских отношений, повышение согласованности и синергии и уменьшение дублирования благодаря последовательной коммуникации",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ru#page=23"
  },
  {
    ID: 253,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Канцелярия Специального советника по Африке",
    Programme: "Поддержка системой Организации Объединенных Наций Повестки дня Африканского союза на период до 2063 года «Африка, какой мы хотим ее видеть»",
    Subprogramme: "Деятельность по информированию и повышению осведомленности общественности в поддержку Повестки дня на период до 2063 года",
    Title: "Привлечение внимания к разрабатываемым под руководством молодежи решениям в области климатической жизнестойкости",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государства-члены в Африке ",
    BeneficiaryTwo: "Молодежь",
    SpecificResult: "Улучшение сотрудничества и партнерских отношений, повышение согласованности и синергии и уменьшение дублирования благодаря последовательной коммуникации",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ru#page=24"
  },
  {
    ID: 254,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Глобализация, взаимозависимость и развитие",
    Title: "В основе обсуждений и принятия решений на глобальном уровне лежат «Прогнозы в области торговли и развития»",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=15"
  },
  {
    ID: 255,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Глобализация, взаимозависимость и развитие",
    Title: "Повышение прозрачности данных о состоянии задолженности развивающихся стран",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EC,EG,QG,JO",
    Image: "12UNCTAD2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=16"
  },
  {
    ID: 256,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Глобализация, взаимозависимость и развитие",
    Title: "Разработка развивающимися странами политики устойчивого промышленного развития и структурных преобразований на основе сотрудничества Юг — Юг и трехстороннего сотрудничества",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: "Частный сектор, включая микро-, малые и средние предприятия ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "KZ,MY,PK,TR",
    Image: "12UNCTAD3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=16"
  },
  {
    ID: 257,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Глобализация, взаимозависимость и развитие",
    Title: "Более эффективное и устойчивое управление задолженностью странами-заемщиками",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=17"
  },
  {
    ID: 258,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Инвестиции и предпринимательство",
    Title: "Укрепление экосистем предпринимательства в целях инклюзивного и инновационного развития предпринимательства",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: " ",
    SpecificResult: "Предпринимательство и повышение конкурентоспособности микро-, малых и средних предприятий",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=22"
  },
  {
    ID: 259,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Инвестиции и предпринимательство",
    Title: "Активизация инвестиций в достижение целей в области устойчивого развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=23"
  },
  {
    ID: 260,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Инвестиции и предпринимательство",
    Title: "Содействие созданию благоприятного делового и инвестиционного климата со стороны государств-членов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=24"
  },
  {
    ID: 261,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Инвестиции и предпринимательство",
    Title: "Более широкое внедрение методов устойчивого инвестирования",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=25"
  },
  {
    ID: 262,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Международная торговля и сырьевые товары",
    Title: "Повышение безопасности потребительских товаров",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Укрепление многосторонности",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=31"
  },
  {
    ID: 263,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Международная торговля и сырьевые товары",
    Title: "Более активная реализация развивающимися странами определяемых на национальном уровне вкладов через торговую политику",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "GM",
    Image: "12UNCTAD10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=32"
  },
  {
    ID: 264,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Международная торговля и сырьевые товары",
    Title: "Государства-члены осваивают важнейшие для энергетического перехода полезные ископаемые в интересах устойчивого развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "NA,ZM",
    Image: "12UNCTAD11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=33"
  },
  {
    ID: 265,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Международная торговля и сырьевые товары",
    Title: "Своевременные данные о нетарифных мерах, принимаемых в целях совершенствования практики регулирования и для содействия экономическому развитию",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=34"
  },
  {
    ID: 266,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Технологии и логистика",
    Title: "Успехи развивающихся стран в области формирования концепции и создания научно-технологических и инновационных парков в целях достижения устойчивого развития",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "GH,MN,MZ,UZ",
    Image: "12UNCTAD13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=42"
  },
  {
    ID: 267,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Технологии и логистика",
    Title: "Повышение доступности статистических данных о цифровой экономике в развивающихся странах",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Частный сектор, включая микро-, малые и средние предприятия ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=42"
  },
  {
    ID: 268,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Технологии и логистика",
    Title: "Повышение эффективности и устойчивости торговых процедур",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "JM,VC,TJ,TL,VU,ZW",
    Image: "12UNCTAD15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=43"
  },
  {
    ID: 269,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Технологии и логистика",
    Title: "Укрепление принципов инклюзивности в сфере упрощения процедур торговли",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Женщины и девочки",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=44"
  },
  {
    ID: 270,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Африка, наименее развитые страны и специальные программы",
    Title: "Формирование наименее развитыми странами общей позиции по правилам происхождения товаров и повестке дня четырнадцатой Конференции министров Всемирной торговой организации",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление многосторонности",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,AG,AM,AZ,BS,SD,QQ,BD,BZ,BJ,BT,BO,BW,BF,BI,CV,KH,CF,TD,KM,CK,CU,CD,DJ,DM,DO,ER,SZ,ET,FJ,GM,GD,GN,GW,HT,JM,KZ,KG,KI,LA,LS,LR,MK,MG,MW,MV,ML,MH,MR,MU,FM,MN,MZ,MM,NR,NP,NE,NU,PW,PG,PY,MD,RW,KN,LC,VC,WS,SN,SC,SL,SB,SO,SS,II,SD,QQ,SR,TJ,TL,TG,TO,TT,TM,TV,UG,TZ,UZ,VU,YE,ZM,ZW",
    Image: "12UNCTAD17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=50"
  },
  {
    ID: 271,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Африка, наименее развитые страны и специальные программы",
    Title: "Укрепление статистического потенциала наименее развитых стран и других развивающихся стран для принятия ими новых концепций при разработке целостной политики диверсификации экономики",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AO,ET,KE,NG",
    Image: "12UNCTAD18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=51"
  },
  {
    ID: 272,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Африка, наименее развитые страны и специальные программы",
    Title: "Расширение возможностей малых островных развивающихся государств по наращиванию производственного потенциала",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,KM,DO,MV,JM,VC,TT",
    Image: "12UNCTAD19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=52"
  },
  {
    ID: 273,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Конференция Организации Объединённых Наций по торговле и развитию",
    Programme: "Торговля и развитие",
    Subprogramme: "Африка, наименее развитые страны и специальные программы",
    Title: "Наименее развитые страны получают возможность разрабатывать и проводить инклюзивную и последовательную торговую политику",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BF,TD,TZ",
    Image: "12UNCTAD20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ru#page=53"
  },
  {
    ID: 274,
    BudgetSection: "13",
    Entity: "ITC",
    EntityFullName: "Международный торговый центр",
    Programme: "Международный торговый центр",
    Subprogramme: "Оперативные аспекты поощрения торговли и развития экспорта",
    Title: "Улучшение возможностей в плане осуществления инноваций, ведения предпринимательской деятельности и создания рабочих мест в Африке и Латинской Америке для молодежных стартапов и молодых предпринимателей",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Молодежь",
    SpecificResult: "Предпринимательство и повышение конкурентоспособности микро-, малых и средних предприятий",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CO,UG",
    Image: "13ITC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.13)&l=ru#page=6"
  },
  {
    ID: 275,
    BudgetSection: "13",
    Entity: "ITC",
    EntityFullName: "Международный торговый центр",
    Programme: "Международный торговый центр",
    Subprogramme: "Международный торговый центр",
    Title: "Повышение качества услуг, предоставляемых местными организациями по поддержке предпринимательства малым предприятиям в целях задействования преимуществ Африканской континентальной зоны свободной торговли",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    SpecificResult: "Предпринимательство и повышение конкурентоспособности микро-, малых и средних предприятий",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "13ITC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.13)&l=ru#page=7"
  },
  {
    ID: 276,
    BudgetSection: "13",
    Entity: "ITC",
    EntityFullName: "Международный торговый центр",
    Programme: "Международный торговый центр",
    Subprogramme: "Международный торговый центр",
    Title: "Переход малых и средних предприятий текстильной и швейной промышленности в Африке и Азиатско-Тихоокеанском регионе на экологически устойчивую операционную модель",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    SpecificResult: "Предпринимательство и повышение конкурентоспособности микро-, малых и средних предприятий",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW,AF,BH,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,IN,AP,ID,IR,IQ,JP,JO,KZ,KW,KG,LA,LB,MY,MV,MH,FM,MN,MM,NR,NP,OM,PK,PW,PG,PH,QA,KR,WS,SA,SG,SB,LK,SY,TJ,TH,TL,TO,TR,TM,TV,AE,UZ,VU,VN,YE",
    Image: "13ITC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.13)&l=ru#page=7"
  },
  {
    ID: 277,
    BudgetSection: "13",
    Entity: "ITC",
    EntityFullName: "Международный торговый центр",
    Programme: "Международный торговый центр",
    Subprogramme: "Международный торговый центр",
    Title: "Повышение экспортной конкурентоспособности малых и средних предприятий из Восточной Европы и Центральной Азии",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: " ",
    SpecificResult: "Предпринимательство и повышение конкурентоспособности микро-, малых и средних предприятий",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AM,KZ,KG,TJ,UZ",
    Image: "13ITC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.13)&l=ru#page=8"
  },
  {
    ID: 278,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Борьба с изменением климата",
    Title: "Города берут на себя обязательства по достижению целевых показателей в области экологически безопасного охлаждения",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=13"
  },
  {
    ID: 279,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Борьба с изменением климата",
    Title: "Разработка государствами-членами национальных программ и планов действий по метану",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=14"
  },
  {
    ID: 280,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Борьба с изменением климата",
    Title: "Внедрение государствами-членами экологически безопасных технологий для смягчения последствий изменения климата и адаптации к нему",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=14"
  },
  {
    ID: 281,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Борьба с изменением климата",
    Title: "Правительства на национальном и субнациональном уровнях принимают стратегии и меры по адаптации к изменению климата, включая национальные планы в области адаптации",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=15"
  },
  {
    ID: 282,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Цифровые преобразования в поддержку природоохранной деятельности",
    Title: "Правительства и лица, ответственные за принятие решений, получают доступ к порталу по вопросам охраны окружающей среды, функционирующему на базе искусственного интеллекта",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=18"
  },
  {
    ID: 283,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Цифровые преобразования в поддержку природоохранной деятельности",
    Title: "Повышение операционной совместимости глобальных экологических данных",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=19"
  },
  {
    ID: 284,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Цифровые преобразования в поддержку природоохранной деятельности",
    Title: "Укрепление цифрового потенциала для обеспечения экологической устойчивости",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Технические достижения, позволяющие повысить качество, наличие, доступность и безопасность информации",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=20"
  },
  {
    ID: 285,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Цифровые преобразования в поддержку природоохранной деятельности",
    Title: "Информационная платформа «Состояние окружающей среды в мире» способствует принятию решений политического характера",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=20"
  },
  {
    ID: 286,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Природоохранная деятельность",
    Title: "Государства-члены берут на себя обязательство охранять биологическое разнообразие морской среды за пределами национальных границ",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=24"
  },
  {
    ID: 287,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Природоохранная деятельность",
    Title: "Учет государственными учреждениями экономической значимости биологического разнообразия и экосистемных услуг при принятии решений",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=24"
  },
  {
    ID: 288,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Природоохранная деятельность",
    Title: "Повышение устойчивости экосистем прибрежных рифов и местных сообществ",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Инклюзивное и устойчивое восстановление после бедствий; повышение устойчивости к будущим бедствиям",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=25"
  },
  {
    ID: 289,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Природоохранная деятельность",
    Title: "Расширение находящихся под рациональным управлением и восстановленных экосистем",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=25"
  },
  {
    ID: 290,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Регулирование природопользования",
    Title: "Государства-члены совершенствуют правовые основы и национальные стратегии по борьбе с незаконным оборотом отходов",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=29"
  },
  {
    ID: 291,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Регулирование природопользования",
    Title: "Сокращение производства и потребления гидрофторуглеродов благодаря реализации Кигалийской поправки к Монреальскому протоколу по веществам, разрушающим озоновый слой",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=30"
  },
  {
    ID: 292,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Регулирование природопользования",
    Title: "Повышение эффективности применения и обеспечения соблюдения экологического законодательства заинтересованными юридическими лицами",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Развитие международного права и укрепление международных механизмов разрешения споров",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=30"
  },
  {
    ID: 293,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Регулирование природопользования",
    Title: "Экологические цели включаются в национальную политику и правовые основы",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=31"
  },
  {
    ID: 294,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Химические вещества и борьба с проблемой загрязнения",
    Title: "Сокращение использования химических веществ, вызывающих обеспокоенность на глобальном уровне, и объема образующихся отходов",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=34"
  },
  {
    ID: 295,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Химические вещества и борьба с проблемой загрязнения",
    Title: "Внедрение стратегий и практик, направленных на поддержку подходов экономики замкнутого цикла в секторах с высоким уровнем воздействия на окружающую среду в целях сокращения масштабов загрязнения",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=35"
  },
  {
    ID: 296,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Химические вещества и борьба с проблемой загрязнения",
    Title: "Принятие политики и стратегий для учета экологических аспектов устойчивости к противомикробным препаратам",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=35"
  },
  {
    ID: 297,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Химические вещества и борьба с проблемой загрязнения",
    Title: "Государства-члены принимают стратегии, законы или нормативные акты в области обращения с химическими веществами и отходами в ключевых секторах",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=36"
  },
  {
    ID: 298,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Финансово-экономические преобразования",
    Title: "Страховые компании обязуются внедрять в свою практику ведения дел подходы, ориентированные на устойчивость",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Улучшение сотрудничества и партнерских отношений, повышение согласованности и синергии и уменьшение дублирования благодаря последовательной коммуникации",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=39"
  },
  {
    ID: 299,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Финансово-экономические преобразования",
    Title: "Повышение доступности инструментов и мер для изменения выбора и поведения правительств, предприятий и индивидуальных потребителей в интересах экологической устойчивости",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=40"
  },
  {
    ID: 300,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Финансово-экономические преобразования",
    Title: "Ускорение прогресса в деле внедрения моделей рационального потребления и производства",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=41"
  },
  {
    ID: 301,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Финансово-экономические преобразования",
    Title: "Государства-члены принимают меры по расширению масштабов устойчивого финансирования",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=42"
  },
  {
    ID: 302,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Наука и политика",
    Title: "Страны внедряют Систему эколого-экономического учета",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=45"
  },
  {
    ID: 303,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Наука и политика",
    Title: "Улучшение мониторинга и сбора электронных отходов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=46"
  },
  {
    ID: 304,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Наука и политика",
    Title: "Укрепление научно-политического взаимодействия в Латинской Америке и Карибском бассейне",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CL,CO,CR,CU,DM,DO,EC,SV,GD,GT,GY,HT,HN,JM,MX,NI,PA,PY,PE,KN,LC,VC,SR,TT,UY,VE",
    Image: "14UNEP27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=47"
  },
  {
    ID: 305,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Программа Организации Объединённых Наций по окружающей среде",
    Programme: "Окружающая среда",
    Subprogramme: "Наука и политика",
    Title: "Правительства и учреждения используют знания, данные, статистику и оценки Программы Организации Объединенных Наций по окружающей среде для формирования процессов разработки политики",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ru#page=47"
  },
  {
    ID: 306,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Программа Организации Объединённых Наций по населенным пунктам",
    Programme: "Населенные пункты",
    Subprogramme: "Жилье, земля, базовые услуги и городская окружающая среда",
    Title: "устойчивой мобильности и жилье, ориентированное на развитие транспорта, для расширения справедливого и равноправного доступа к безопасному общественному транспорту в городах, особенно на городских окраинах",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "GH,KE,NG,UG",
    Image: "15UN-Habitat1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ru#page=15"
  },
  {
    ID: 307,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Программа Организации Объединённых Наций по населенным пунктам",
    Programme: "Населенные пункты",
    Subprogramme: "Жилье, земля, базовые услуги и городская окружающая среда",
    Title: "Принятие городами и странами обязательства обеспечивать надлежащее жилье для всех и решать проблемы бездомности и жилищной уязвимости",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CR,KM,CU,MX",
    Image: "15UN-Habitat2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ru#page=16"
  },
  {
    ID: 308,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Программа Организации Объединённых Наций по населенным пунктам",
    Programme: "Населенные пункты",
    Subprogramme: "Жилье, земля, базовые услуги и городская окружающая среда",
    Title: "Обеспечение более надежных гарантий землевладения",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "NP",
    Image: "15UN-Habitat3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ru#page=17"
  },
  {
    ID: 309,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Программа Организации Объединённых Наций по населенным пунктам",
    Programme: "Населенные пункты",
    Subprogramme: "Жилье, земля, базовые услуги и городская окружающая среда",
    Title: "Расширение доступа к надлежащему жилью, земле и базовым услугам",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ru#page=17"
  },
  {
    ID: 310,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Программа Организации Объединённых Наций по населенным пунктам",
    Programme: "Населенные пункты",
    Subprogramme: "Планирование, финансовая политика, адаптация к местным условиям и управление",
    Title: "Реформы законодательства в сфере планирования укрепляют многоуровневое управление в интересах жизнестойких и устойчивых городов",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BW,SL,ZW",
    Image: "15UN-Habitat5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ru#page=22"
  },
  {
    ID: 311,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Программа Организации Объединённых Наций по населенным пунктам",
    Programme: "Населенные пункты",
    Subprogramme: "Планирование, финансовая политика, адаптация к местным условиям и управление",
    Title: "Модернизация систем получения доходов из собственных источников для повышения эффективности работы местных органов власти",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ru#page=23"
  },
  {
    ID: 312,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Программа Организации Объединённых Наций по населенным пунктам",
    Programme: "Населенные пункты",
    Subprogramme: "Планирование, финансовая политика, адаптация к местным условиям и управление",
    Title: "Адаптация целей в области устойчивого развития к местным условиям способствует системным изменениям и территориальной трансформации за счет укрепления основанного на широком участии многоуровневого управления, участия заинтересованных сторон, институционального потенциала и финансирования местных решений",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ru#page=24"
  },
  {
    ID: 313,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Программа Организации Объединённых Наций по населенным пунктам",
    Programme: "Населенные пункты",
    Subprogramme: "Знания, данные, цифровизация и создание потенциала",
    Title: "Специалисты в области городского развития имеют свободный доступ к практическим знаниям и рекомендациям на различных языках, что способствует ускорению реализации Новой программы развития городов и целей в области устойчивого развития",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Молодежь",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ru#page=29"
  },
  {
    ID: 314,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Программа Организации Объединённых Наций по населенным пунктам",
    Programme: "Населенные пункты",
    Subprogramme: "Знания, данные, цифровизация и создание потенциала",
    Title: "Цифровые преобразования в интересах устойчивого развития городов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ru#page=30"
  },
  {
    ID: 315,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Программа Организации Объединённых Наций по населенным пунктам",
    Programme: "Населенные пункты",
    Subprogramme: "Знания, данные, цифровизация и создание потенциала",
    Title: "Расширение и совершенствование производства дезагрегированных и актуальных для разработки политики данных по жилью, земле и базовым услугам национальными и местными органами власти (нарастающим итогом)",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ru#page=30"
  },
  {
    ID: 316,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Программа Организации Объединённых Наций по населенным пунктам",
    Programme: "Населенные пункты",
    Subprogramme: "Партнерства, коалиции, информационно-пропагандистская деятельность и коммуникация",
    Title: "Глобальный форум заинтересованных сторон содействует инклюзивному и подотчетному городскому развитию",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ru#page=34"
  },
  {
    ID: 317,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Программа Организации Объединённых Наций по населенным пунктам",
    Programme: "Населенные пункты",
    Subprogramme: "Партнерства, коалиции, информационно-пропагандистская деятельность и коммуникация",
    Title: "Использование Всемирного форума по вопросам городов в качестве платформы для продвижения глобальных обязательств по обеспечению всех людей надлежащим жильем, землей и базовыми услугами",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ru#page=35"
  },
  {
    ID: 318,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Программа Организации Объединённых Наций по населенным пунктам",
    Programme: "Населенные пункты",
    Subprogramme: "Укрепление мер по борьбе с изменением климата и улучшение состояния городской окружающей среды",
    Title: "Более широкий учет городской тематики в определяемых на национальном уровне вкладах",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Климат и окружающая среда ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ru#page=39"
  },
  {
    ID: 319,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Программа Организации Объединённых Наций по населенным пунктам",
    Programme: "Населенные пункты",
    Subprogramme: "Сокращение пространственного неравенства и масштабов нищеты в общинах в городских и сельских районах",
    Title: "Планы действий по борьбе с изменением климата в городах для повышения жизнестойкости наиболее уязвимых слоев населения",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Инклюзивное и устойчивое восстановление после бедствий; повышение устойчивости к будущим бедствиям",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ru#page=40"
  },
  {
    ID: 320,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Программа Организации Объединённых Наций по населенным пунктам",
    Programme: "Населенные пункты",
    Subprogramme: "Эффективное предотвращение кризисов и реагирование на них в городах",
    Title: "Устойчивая интеграция перемещенного населения в городских районах Сомали",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "SO",
    Image: "15UN-Habitat15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ru#page=42"
  },
  {
    ID: 321,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "Программа Организации Объединённых Наций по населенным пунктам",
    Programme: "Населенные пункты",
    Subprogramme: "Эффективное предотвращение кризисов и реагирование на них в городах",
    Title: "Комплексные и основанные на широком участии городское планирование и всеохватное развитие",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SO",
    Image: "15UN-Habitat16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ru#page=43"
  },
  {
    ID: 322,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Борьба с транснациональной организованной преступностью",
    Title: "Укрепление международного сотрудничества в области борьбы с киберпреступностью и обмена электронными доказательствами по делам о серьезных преступлениях",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=25"
  },
  {
    ID: 323,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Борьба с транснациональной организованной преступностью",
    Title: "Улучшение регистрации и отслеживания огнестрельного оружия, его составных частей и компонентов, а также боеприпасов к нему",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Усиление борьбы с торговлей наркотиками, незаконными товарами и людьми; сокращение незаконных финансовых потоков",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "HN,SN",
    Image: "16UNODC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=26"
  },
  {
    ID: 324,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Борьба с транснациональной организованной преступностью",
    Title: "Повышение эффективности выявления незаконного оборота на воздушном, морском и наземном транспорте",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Усиление борьбы с торговлей наркотиками, незаконными товарами и людьми; сокращение незаконных финансовых потоков",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=27"
  },
  {
    ID: 325,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Борьба с транснациональной организованной преступностью",
    Title: "Укрепление нормативных, политических и институциональных мер по противодействию организованной преступности в глобальном масштабе",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Усиление борьбы с торговлей наркотиками, незаконными товарами и людьми; сокращение незаконных финансовых потоков",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=27"
  },
  {
    ID: 326,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Комплексный и сбалансированный подход к борьбе с мировой проблемой наркотиков",
    Title: "Расширение возможностей государств-членов в плане пресечения деятельности преступных сетей, занимающихся незаконным оборотом наркотиков, посредством укрепления международного сотрудничества по конкретным делам",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Усиление борьбы с торговлей наркотиками, незаконными товарами и людьми; сокращение незаконных финансовых потоков",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AR,BO,BR,CV,CL,CI,DE,PE",
    Image: "16UNODC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=31"
  },
  {
    ID: 327,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Комплексный и сбалансированный подход к борьбе с мировой проблемой наркотиков",
    Title: "Осуществление государствами-членами в странах Африки к югу от Сахары мероприятий, направленных на укрепление мер в области здравоохранения и развития в контексте решения мировой проблемы наркотиков",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "16UNODC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=32"
  },
  {
    ID: 328,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Комплексный и сбалансированный подход к борьбе с мировой проблемой наркотиков",
    Title: "Устранение глобальных пробелов в предоставлении услуг благодаря реализации новых инициатив в области здравоохранения и развития на национальном уровне",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=33"
  },
  {
    ID: 329,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Комплексный и сбалансированный подход к борьбе с мировой проблемой наркотиков",
    Title: "Подготовка сотрудников лабораторий криминалистической экспертизы в области анализа и идентификации синтетических наркотиков и химических веществ — прекурсоров, используемых при их изготовлении",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Усиление борьбы с торговлей наркотиками, незаконными товарами и людьми; сокращение незаконных финансовых потоков",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=34"
  },
  {
    ID: 330,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Борьба с коррупцией",
    Title: "Расследование сложных международных коррупционных дел, осуществление судебного преследования в связи с ними и вынесение решений по ним государствами-членами",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DO,KE,MY,PA,TZ,VN",
    Image: "16UNODC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=38"
  },
  {
    ID: 331,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Борьба с коррупцией",
    Title: "Расширение использования государствами информации о собственниках-бенефициарах при проведении антикоррупционных мероприятий",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "GT,HN,PY,PH,VN,ZM",
    Image: "16UNODC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=39"
  },
  {
    ID: 332,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Борьба с коррупцией",
    Title: "Укрепление сотрудничества между государствами на региональном уровне в целях противодействия коррупции",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=40"
  },
  {
    ID: 333,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Борьба с коррупцией",
    Title: "Создание в государствах эффективной правовой и политической базы для борьбы с коррупцией в соответствии с Конвенцией Организации Объединенных Наций против коррупции",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=40"
  },
  {
    ID: 334,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Предупреждение терроризма",
    Title: "Усиление мер в области уголовного правосудия для борьбы с финансированием терроризма в Котд’Ивуаре",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CI",
    Image: "16UNODC13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=44"
  },
  {
    ID: 335,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Предупреждение терроризма",
    Title: "Институциональные изменения на юге Африки для создания сильных и подотчетных систем уголовного правосудия и для борьбы с терроризмом",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "MZ",
    Image: "16UNODC14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=44"
  },
  {
    ID: 336,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Предупреждение терроризма",
    Title: "Увеличение вклада женщин — сотрудниц правоохранительных органов, в укрепление систем уголовного правосудия в контексте борьбы с терроризмом",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Женщины и девочки",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=45"
  },
  {
    ID: 337,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Предупреждение терроризма",
    Title: "Государства лучше подготовлены к противодействию радиологическому и ядерному терроризму на основе Международной конвенции о борьбе с актами ядерного терроризма",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=46"
  },
  {
    ID: 338,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Правосудие",
    Title: "Повышение уровня соответствия национальных пенитенциарных систем международным стандартам в целях содействия реабилитации",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=50"
  },
  {
    ID: 339,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Правосудие",
    Title: "Усилия по предупреждению преступности и реформированию системы уголовного правосудия при полном соблюдении прав человека",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=51"
  },
  {
    ID: 340,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Правосудие",
    Title: "Расширение прав и возможностей детей и молодежи в целях предотвращения вовлечения детей в преступность и насилие",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Молодежь",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=51"
  },
  {
    ID: 341,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Правосудие",
    Title: "Повышение степени национальной ответственности за осуществление инициатив в области предупреждения преступности и уголовного правосудия на основе институциональных партнерств",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=52"
  },
  {
    ID: 342,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Исследования, анализ тенденций и судебная экспертиза",
    Title: "Укрепление потенциала и повышение квалификации сотрудников правоохранительных органов и экспертов-криминалистов стран Америки в том, что касается исследования места происшествия и экспертизы поддельных и фальшивых защищенных документов",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление борьбы с торговлей наркотиками, незаконными товарами и людьми; сокращение незаконных финансовых потоков",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AR,BO,CL,CR,DO,EC,SV,GT,GY,HN,JM,PA,PY,PE,TT,UY",
    Image: "16UNODC21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=55"
  },
  {
    ID: 343,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Исследования, анализ тенденций и судебная экспертиза",
    Title: "Лаборатории экспертизы наркотиков и токсикологических исследований в государствах-членах осуществляют мониторинг своей работы в рамках практики обеспечения качества",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление борьбы с торговлей наркотиками, незаконными товарами и людьми; сокращение незаконных финансовых потоков",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=56"
  },
  {
    ID: 344,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Исследования, анализ тенденций и судебная экспертиза",
    Title: "Расширение доступа к фактическим данным, необходимым государствам-членам для понимания проблемы торговли людьми и борьбы с ней",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Усиление борьбы с торговлей наркотиками, незаконными товарами и людьми; сокращение незаконных финансовых потоков",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=57"
  },
  {
    ID: 345,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Исследования, анализ тенденций и судебная экспертиза",
    Title: "Государства-члены все чаще используют результаты исследований УНП ООН при разработке политики",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление борьбы с торговлей наркотиками, незаконными товарами и людьми; сокращение незаконных финансовых потоков",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=58"
  },
  {
    ID: 346,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Поддержка в вопросах политики",
    Title: "Оказание жертвам торговли людьми всесторонней поддержки, ориентированной на их интересы, по линии Целевого фонда добровольных взносов Организации Объединенных Наций для жертв торговли людьми, особенно женщинами и детьми",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Женщины и девочки",
    SpecificResult: "Усиление борьбы с торговлей наркотиками, незаконными товарами и людьми; сокращение незаконных финансовых потоков",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=61"
  },
  {
    ID: 347,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Поддержка в вопросах политики",
    Title: "Конструктивное участие молодежи в процессах принятия решений по вопросам наркотиков, преступности и коррупции",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление многосторонности",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=62"
  },
  {
    ID: 348,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Поддержка в вопросах политики",
    Title: "Реализация инициатив в рамках государственно-частных партнерств в контексте Конвенции Организации Объединенных Наций против киберпреступности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Частный сектор, включая микро-, малые и средние предприятия ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DO,NG",
    Image: "16UNODC27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=63"
  },
  {
    ID: 349,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Поддержка в вопросах политики",
    Title: "Повышение информированности общественности об угрозах, исходящих от наркотиков, преступности, коррупции и терроризма, посредством целевого контента в социальных сетях",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=63"
  },
  {
    ID: 350,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Техническое сотрудничество и поддержка деятельности на местах",
    Title: "Повышение уровня подотчетности и эффективности системы правосудия в Гаити",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "HT",
    Image: "16UNODC29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=66"
  },
  {
    ID: 351,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Техническое сотрудничество и поддержка деятельности на местах",
    Title: "Преодоление проблем в области безопасности на море благодаря укреплению систем управления безопасностью на море",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AO,KM,KE,MG,MU,MZ,NA,SC,TZ",
    Image: "16UNODC30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=67"
  },
  {
    ID: 352,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Техническое сотрудничество и поддержка деятельности на местах",
    Title: "Повышение прозрачности и эффективности управления активами для улучшения профилактики преступности и повышения доверия населения",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "MZ",
    Image: "16UNODC31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=68"
  },
  {
    ID: 353,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Техническое сотрудничество и поддержка деятельности на местах",
    Title: "Предупреждение и пресечение организованной преступной деятельности на землях и территориях, традиционно населяемых коренными народами",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Более строгое обеспечение верховенства права; укрепление системы предупреждения преступности и уголовного правосудия; сокращение масштабов коррупции; предупреждение терроризма и борьба с ним",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BR",
    Image: "16UNODC32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=69"
  },
  {
    ID: 354,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Cекретариатское обслуживание и основная поддержка Комиссии по наркотическим средствам, Комиссии по предупреждению преступности и уголовному правосудию и Конгресса Организации Объединенных Наций по предупреждению преступности и уголовному правосудию",
    Title: "Содействие подготовке к пятнадцатому Конгрессу Организации Объединенных Наций по предупреждению преступности и уголовному правосудию",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление многосторонности",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT,CR,ET,MA,TH",
    Image: "16UNODC33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=72"
  },
  {
    ID: 355,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Cекретариатское обслуживание и основная поддержка Комиссии по наркотическим средствам, Комиссии по предупреждению преступности и уголовному правосудию и Конгресса Организации Объединенных Наций по предупреждению преступности и уголовному правосудию",
    Title: "Более активное выполнение международных обязательств в области предупреждения преступности и уголовного правосудия",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление многосторонности",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=73"
  },
  {
    ID: 356,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Cекретариатское обслуживание и основная поддержка Комиссии по наркотическим средствам, Комиссии по предупреждению преступности и уголовному правосудию и Конгресса Организации Объединенных Наций по предупреждению преступности и уголовному правосудию",
    Title: "Ускорение реализации мер предупреждения преступности, уголовного правосудия и обеспечения верховенства права благодаря принятию и осуществлению Абу-Дабийской декларации",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление многосторонности",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=73"
  },
  {
    ID: 357,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Cекретариатское обслуживание и основная поддержка Комиссии по наркотическим средствам, Комиссии по предупреждению преступности и уголовному правосудию и Конгресса Организации Объединенных Наций по предупреждению преступности и уголовному правосудию",
    Title: "Ускорение выполнения международных обязательств в области наркополитики в целях эффективного решения мировой проблемы наркотиков и борьбы с ней",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление многосторонности",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=74"
  },
  {
    ID: 358,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Cекретариатское обслуживание и основная поддержка Международного комитета по контролю над наркотиками",
    Title: "Эффективное функционирование международной системы исчислений и оценок для законной торговли наркотическими средствами и психотропными веществами в медицинских и научных целях",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление борьбы с торговлей наркотиками, незаконными товарами и людьми; сокращение незаконных финансовых потоков",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=79"
  },
  {
    ID: 359,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Cекретариатское обслуживание и основная поддержка Международного комитета по контролю над наркотиками",
    Title: "Снижение незаконного оборота сильнодействующих новых психоактивных веществ и немедицинских синтетических опиоидов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление борьбы с торговлей наркотиками, незаконными товарами и людьми; сокращение незаконных финансовых потоков",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=79"
  },
  {
    ID: 360,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Cекретариатское обслуживание и основная поддержка Международного комитета по контролю над наркотиками",
    Title: "Укрепление способности государств-членов обеспечивать наличие достаточного количества контролируемых на международном уровне веществ для использования в медицинских и научных целях",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление борьбы с торговлей наркотиками, незаконными товарами и людьми; сокращение незаконных финансовых потоков",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=80"
  },
  {
    ID: 361,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Управление ООН по наркотикам и преступности",
    Programme: "Международный контроль над наркотическими средствами, предупреждение преступности и терроризма и уголовное правосудие",
    Subprogramme: "Cекретариатское обслуживание и основная поддержка Международного комитета по контролю над наркотиками",
    Title: "Снижение доступности химических веществ — прекурсоров и не внесенных в списки химических веществ, используемых для незаконного изготовления наркотиков",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Контроль над наркотиками, предупреждение преступности и борьба с организованной преступностью и международным терроризмом во всех их формах и проявлениях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление борьбы с торговлей наркотиками, незаконными товарами и людьми; сокращение незаконных финансовых потоков",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ru#page=81"
  },
  {
    ID: 362,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Структура Организации Объединённых Наций по вопросам гендерного равенства и расширения прав и возможностей женщин",
    Programme: "Структура «ООН–женщины»",
    Subprogramme: "Межправительственная поддержка, координация и стратегические партнерские отношения",
    Title: "Определены и приняты приоритетные меры по ускорению осуществления Пекинской платформы действий",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=ru#page=10"
  },
  {
    ID: 363,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Структура Организации Объединённых Наций по вопросам гендерного равенства и расширения прав и возможностей женщин",
    Programme: "Структура «ООН–женщины»",
    Subprogramme: "Межправительственная поддержка, координация и стратегические партнерские отношения",
    Title: "Укрепление глобальных норм и стандартов в области обеспечения гендерного равенства и расширения прав и возможностей всех женщин и девочек",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=ru#page=11"
  },
  {
    ID: 364,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Структура Организации Объединённых Наций по вопросам гендерного равенства и расширения прав и возможностей женщин",
    Programme: "Структура «ООН–женщины»",
    Subprogramme: "Межправительственная поддержка, координация и стратегические партнерские отношения",
    Title: "Всесторонний учет гендерной проблематики в рамочных программах Организации Объединенных Наций по сотрудничеству в области устойчивого развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: " ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=ru#page=12"
  },
  {
    ID: 365,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Структура Организации Объединённых Наций по вопросам гендерного равенства и расширения прав и возможностей женщин",
    Programme: "Структура «ООН–женщины»",
    Subprogramme: "Межправительственная поддержка, координация и стратегические партнерские отношения",
    Title: "Более эффективный учет гендерной проблематики в рамках Общесистемного плана действий Организации Объединенных Наций по вопросам гендерного равенства и расширения прав и возможностей женщин 3.0",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=ru#page=12"
  },
  {
    ID: 366,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Структура Организации Объединённых Наций по вопросам гендерного равенства и расширения прав и возможностей женщин",
    Programme: "Структура «ООН–женщины»",
    Subprogramme: "Нормативная и программная деятельность",
    Title: "Государства-члены используют данные об использовании времени для разработки основанных на фактических данных стратегий, направленных на признание, сокращение и перераспределение неоплачиваемой работы по уходу",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=ru#page=16"
  },
  {
    ID: 367,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Структура Организации Объединённых Наций по вопросам гендерного равенства и расширения прав и возможностей женщин",
    Programme: "Структура «ООН–женщины»",
    Subprogramme: "Нормативная и программная деятельность",
    Title: "Правительства проводят налоговую политику и составляют бюджеты с учетом гендерных аспектов в целях поощрения гендерного равенства",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: " ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=ru#page=17"
  },
  {
    ID: 368,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Структура Организации Объединённых Наций по вопросам гендерного равенства и расширения прав и возможностей женщин",
    Programme: "Структура «ООН–женщины»",
    Subprogramme: "Нормативная и программная деятельность",
    Title: "Правительства принимают национальные планы действий по предотвращению насилия в отношении женщин и девочек",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: " ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=ru#page=18"
  },
  {
    ID: 369,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Структура Организации Объединённых Наций по вопросам гендерного равенства и расширения прав и возможностей женщин",
    Programme: "Структура «ООН–женщины»",
    Subprogramme: "Нормативная и программная деятельность",
    Title: "Правительства добиваются прогресса в реформировании дискриминационных законов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=ru#page=18"
  },
  {
    ID: 370,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Макроэкономическая политика, финансовые ресурсы и управление",
    Title: "Совершенствование стратегий управления задолженностью и устойчивого финансирования в малых островных развивающихся государствах",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Развитие Африки",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CV,KM",
    Image: "18ECA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=14"
  },
  {
    ID: 371,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Макроэкономическая политика, финансовые ресурсы и управление",
    Title: "Использование членами ЭКА инновационных подходов к привлечению внутренних ресурсов и внешнего частного капитала",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "BW,ET,GN,MR,UG,TZ",
    Image: "18ECA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=15"
  },
  {
    ID: 372,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Макроэкономическая политика, финансовые ресурсы и управление",
    Title: "Повышение эффективности макроэкономического прогнозирования и планирования развития для обеспечения инклюзивного и устойчивого роста",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BW",
    Image: "18ECA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=16"
  },
  {
    ID: 373,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Макроэкономическая политика, финансовые ресурсы и управление",
    Title: "Совершенствование экономического и финансового управления в целях содействия структурным преобразованиям и инклюзивному развитию",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BJ,ET,GN,UG,ZM",
    Image: "18ECA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=17"
  },
  {
    ID: 374,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Региональная интеграция и торговля",
    Title: "Повышение готовности Эфиопии к торговле в рамках Африканской континентальной зоны свободной торговли",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Развитие Африки",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "ET",
    Image: "18ECA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=20"
  },
  {
    ID: 375,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Региональная интеграция и торговля",
    Title: "Осуществление стратегий в области устойчивой торговли в целях принятия мер в связи с изменением климата",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=22"
  },
  {
    ID: 376,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Региональная интеграция и торговля",
    Title: "Принятие членами ЭКА мер по снижению рисков, связанных с инвестициями в региональные цепочки создания стоимости и особые экономические зоны",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=22"
  },
  {
    ID: 377,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Региональная интеграция и торговля",
    Title: "Улучшение национальной политики и институциональных условий для участия частного сектора во внутриафриканской торговле в рамках Африканской континентальной зоны свободной торговли",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=23"
  },
  {
    ID: 378,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Технологии, инновации, связь и развитие инфраструктуры",
    Title: "Государства-члены имеют доступ к инструменту моделирования налоговой политики для содействия принятию обоснованных решений в целях предоставления доступных по цене возможностей для соединения с сетями, обеспечения инклюзивного экономического роста и создания рабочих мест в Африке",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=27"
  },
  {
    ID: 379,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Технологии, инновации, связь и развитие инфраструктуры",
    Title: "Расширение использования новых технологий членами ЭКА, подкрепленное надежной нормативно-правовой базой",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=28"
  },
  {
    ID: 380,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Технологии, инновации, связь и развитие инфраструктуры",
    Title: "Использование членами ЭКА технологий и инноваций для управления своей транспортной и энергетической инфраструктурой",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "EG,QG,GH,KE,MG",
    Image: "18ECA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=29"
  },
  {
    ID: 381,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Технологии, инновации, связь и развитие инфраструктуры",
    Title: "Укрепление стратегий и политики в области развития инфраструктуры",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SZ,GM",
    Image: "18ECA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=30"
  },
  {
    ID: 382,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Данные и статистика",
    Title: "Члены ЭКА производят и используют улучшенные экономические статистические данные в интересах осуществления политики региональной интеграции",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=35"
  },
  {
    ID: 383,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Данные и статистика",
    Title: "Прогресс в интеграции систем статистической и геопространственной информации",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "ER,GH,NA",
    Image: "18ECA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=36"
  },
  {
    ID: 384,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Данные и статистика",
    Title: "Совершенствование систем регистрации актов гражданского состояния и статистического учета естественного движения населения",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Повышение качества информации о народонаселении, миграции, регистрации актов гражданского состояния и демографической ситуации, включая статистические данные в разбивке по признаку пола",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BI,KE,NA,TZ",
    Image: "18ECA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=37"
  },
  {
    ID: 385,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Данные и статистика",
    Title: "Укрепление национальных статистических систем, обеспечивающих регулярное производство инновационных статистических продуктов для принятия решений на основе фактических данных, и использование этих продуктов для разработки политики",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Повышение качества информации о народонаселении, миграции, регистрации актов гражданского состояния и демографической ситуации, включая статистические данные в разбивке по признаку пола",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=37"
  },
  {
    ID: 386,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Изменение климата, продовольственная безопасность и природные ресурсы",
    Title: "Члены ЭКА укрепляют нормативно-правовую и институциональную базу в целях создания климатически устойчивых сельскохозяйственных цепочек создания стоимости",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Развитие Африки",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CI,GH,ZM,ZW",
    Image: "18ECA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=44"
  },
  {
    ID: 387,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Изменение климата, продовольственная безопасность и природные ресурсы",
    Title: "Разработка и внедрение членами ЭКА национальной и региональной политики и механизмов сотрудничества в интересах рационального использования природных ресурсов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=45"
  },
  {
    ID: 388,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Изменение климата, продовольственная безопасность и природные ресурсы",
    Title: "Жизнестойкие и инклюзивные агропродовольственные системы",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=46"
  },
  {
    ID: 389,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Изменение климата, продовольственная безопасность и природные ресурсы",
    Title: "Постановка более далеко идущих климатических целей и активизация климатических действий в Африке",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=47"
  },
  {
    ID: 390,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Расширение экономических прав и возможностей женщин и молодежи",
    Title: "Укрепление системы сбора данных, мониторинга и представления отчетности по вопросам гендерного равенства и расширения прав и возможностей женщин",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Развитие Африки",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Повышение качества информации о народонаселении, миграции, регистрации актов гражданского состояния и демографической ситуации, включая статистические данные в разбивке по признаку пола",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BI,SS,II",
    Image: "18ECA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=53"
  },
  {
    ID: 391,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Расширение экономических прав и возможностей женщин и молодежи",
    Title: "Учет членами ЭКА гендерных аспектов в налогово-бюджетной политике",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "ET,KE,RW,UG,TZ",
    Image: "18ECA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=54"
  },
  {
    ID: 392,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Расширение экономических прав и возможностей женщин и молодежи",
    Title: "Принятие членами ЭКА мер по расширению доступа женщин к финансовым услугам",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "GM,SL",
    Image: "18ECA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=55"
  },
  {
    ID: 393,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Расширение экономических прав и возможностей женщин и молодежи",
    Title: "Члены ЭКА используют возможности цифровизации для расширения прав и возможностей молодых предпринимателей",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Предпринимательство и повышение конкурентоспособности микро-, малых и средних предприятий",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "ZA",
    Image: "18ECA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=55"
  },
  {
    ID: 394,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе Северной Африки",
    Title: "Члены ЭКА принимают меры по расширению масштабов устойчивого финансирования",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,SL",
    Image: "18ECA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=59"
  },
  {
    ID: 395,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе Северной Африки",
    Title: "Привлечение членами ЭКА финансовых средств для достижения устойчивого развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,LY",
    Image: "18ECA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=60"
  },
  {
    ID: 396,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе Северной Африки",
    Title: "Увеличение темпов инклюзивного и устойчивого роста в членах ЭКА посредством повышения производительности труда, роста диверсификации и увеличения добавленной стоимости",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Предпринимательство и повышение конкурентоспособности микро-, малых и средних предприятий",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,EG,QG,LY,MR,SD,QQ,TN",
    Image: "18ECA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=60"
  },
  {
    ID: 397,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе Северной Африки",
    Title: "Члены ЭКА принимают меры по максимальному привлечению диаспоры в качестве альтернативного источника финансирования развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,EG,QG,LY,MR,SD,QQ,TN",
    Image: "18ECA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=61"
  },
  {
    ID: 398,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе Западной Африки",
    Title: "Члены ЭКА в Западной Африке включают анализ сельскохозяйственных цепочек создания стоимости в системы планирования",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Развитие Африки",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BJ,BF,CV,CI,GM,GH,GN,GW,LR,ML,MR,NE,NG,SN,SL,TG",
    Image: "18ECA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=65"
  },
  {
    ID: 399,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе Западной Африки",
    Title: "Оценка членами ЭКА приемлемости уровня задолженности и разработка ими долгосрочных налогово-бюджетных стратегий",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SL",
    Image: "18ECA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=66"
  },
  {
    ID: 400,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе Западной Африки",
    Title: "Активизация практического осуществления национальных стратегий обеспечения функционирования Африканской континентальной зоны свободной торговли",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CV,GH,LR",
    Image: "18ECA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=66"
  },
  {
    ID: 401,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе Западной Африки",
    Title: "Совершенствование национальных систем бюджетирования и мониторинга в целях использования демографического дивиденда",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BJ,BF,CV,CI,GM,GH,GN,GW,LR,ML,MR,NE,NG,SN,SL,TG",
    Image: "18ECA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=67"
  },
  {
    ID: 402,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе Центральной Африки",
    Title: "Сан-Томе и Принсипи разработало и утвердило свои первые вспомогательные счета туризма",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "ST",
    Image: "18ECA33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=71"
  },
  {
    ID: 403,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе Центральной Африки",
    Title: "Создание членами ЭКА особых экономических зон для устойчивой и инклюзивной диверсификации экономики",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CM,CG,CD,GA",
    Image: "18ECA34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=72"
  },
  {
    ID: 404,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе Центральной Африки",
    Title: "Совершенствование оценок природных активов и повышение их капитализации членами ЭКА из Центральной Африки",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CG,ST",
    Image: "18ECA35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=72"
  },
  {
    ID: 405,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе Центральной Африки",
    Title: "Укрепление систем упрощения процедур торговли и институционального потенциала в целях ускорения региональной экономической интеграции",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BI,CM,CF,TD,GQ,CD,GA,CG,RW,ST",
    Image: "18ECA36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=73"
  },
  {
    ID: 406,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе Восточной Африки",
    Title: "Сомали объявляет о начале претворения в жизнь «Видения на период до 2060 года — столетней годовщины независимости» и ратифицирует Соглашение о создании Африканской континентальной зоны свободной торговли",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SO",
    Image: "18ECA37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=77"
  },
  {
    ID: 407,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе Восточной Африки",
    Title: "Разработка членами ЭКА и региональными организациями стратегий поощрения инвестиций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BI,DJ,ER,ET,KE,RW,SC,SO,SS,II,UG,TZ",
    Image: "18ECA38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=78"
  },
  {
    ID: 408,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе Восточной Африки",
    Title: "Осуществление членами ЭКА региональных рамочных программ в области туризма и «голубой» экономики",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "BI,DJ,ER,ET,KE,RW,SC,SO,SS,II,UG,TZ",
    Image: "18ECA39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=79"
  },
  {
    ID: 409,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе Восточной Африки",
    Title: "Расширение возможностей соединения с сетями и укрепление инфраструктуры в целях углубления региональной интеграции",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BI,DJ,ER,ET,KE,RW,SC,SO,SS,II,UG,TZ",
    Image: "18ECA40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=79"
  },
  {
    ID: 410,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе южной части Африки",
    Title: "Активизация внутрирегиональной торговли и инвестиционной деятельности в регионе САДК с помощью цифровых технологий",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AO,BW,KM,CD,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,TZ,ZM,ZW",
    Image: "18ECA41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=84"
  },
  {
    ID: 411,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе южной части Африки",
    Title: "Ускорение перехода стран юга Африки к более устойчивой экономике",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "18ECA42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=85"
  },
  {
    ID: 412,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе южной части Африки",
    Title: "Инклюзивная индустриализация посредством развития цепочек создания стоимости в странах юга Африки",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "18ECA43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=85"
  },
  {
    ID: 413,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Субрегиональная деятельность в целях развития: Деятельность в субрегионе южной части Африки",
    Title: "Ускоренное осуществление Соглашения об учреждении Африканской континентальной зоны свободной торговли и других торговых соглашений в странах юга Африки",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "18ECA44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=86"
  },
  {
    ID: 414,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Экономическое развитие и планирование",
    Title: "Разработка членами ЭКА политики, направленной на развитие региональной и международной торговли",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Развитие Африки",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CM,SN,ZW",
    Image: "18ECA45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=90"
  },
  {
    ID: 415,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Экономическое развитие и планирование",
    Title: "Формирование членами ЭКА кадровых ресурсов, соответствующих требованиям будущего",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=91"
  },
  {
    ID: 416,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Экономическое развитие и планирование",
    Title: "Укрепление деятельности по планированию развития и финансированию развития с учетом местных особенностей",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=92"
  },
  {
    ID: 417,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Экономическое развитие и планирование",
    Title: "Совершенствование систем учебной подготовки специалистов в области государственного управления в целях укрепления национального планирования развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DJ",
    Image: "18ECA48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=92"
  },
  {
    ID: 418,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Бедность, неравенство и социальная политика",
    Title: "Выработка членами ЭКА общей позиции африканских стран по вопросам социального развития на второй Всемирной встрече на высшем уровне в интересах социального развития",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Развитие Африки",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=96"
  },
  {
    ID: 419,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Бедность, неравенство и социальная политика",
    Title: "Совершенствование систем социальной защиты в интересах наиболее уязвимых слоев населения",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "GH,NA,SN,TZ",
    Image: "18ECA50.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=97"
  },
  {
    ID: 420,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Бедность, неравенство и социальная политика",
    Title: "Укрепление национальных и региональных обзоров рамочных программ в области народонаселения в целях содействия устойчивому развитию и тому, чтобы никто не остался без внимания",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA51.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=98"
  },
  {
    ID: 421,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Экономическая комиссия для Африки",
    Programme: "Экономическое и социальное развитие в Африке",
    Subprogramme: "Бедность, неравенство и социальная политика",
    Title: "Укрепление основанной на фактах политики в области занятости в целях задействования демографического дивиденда Африки",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Развитие Африки",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Государства-члены в Африке ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA52.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ru#page=98"
  },
  {
    ID: 422,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Макроэкономическая политика, сокращение масштабов нищеты и финансирование развития",
    Title: "Приоритеты стран Азиатско-Тихоокеанского региона, отраженные в глобальной повестке дня в области финансирования развития",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государства-члены в Азиатско-Тихоокеанском регионе",
    BeneficiaryTwo: "Государственное управление ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=21"
  },
  {
    ID: 423,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Макроэкономическая политика, сокращение масштабов нищеты и финансирование развития",
    Title: "Совершенствование процесса формирования политики по вопросам макроэкономики и финансирования развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "SD,QQ,BT,KH,MV,MN,PK,LK",
    Image: "19ESCAP2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=22"
  },
  {
    ID: 424,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Макроэкономическая политика, сокращение масштабов нищеты и финансирование развития",
    Title: "Государства-члены внедряют новые инициативы и реформы в области политики, направленные на ускорение финансирования деятельности в области устойчивого развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SD,QQ,BT,KH,LK",
    Image: "19ESCAP3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=22"
  },
  {
    ID: 425,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Макроэкономическая политика, сокращение масштабов нищеты и финансирование развития",
    Title: "Государства-члены разрабатывают, оценивают или реализуют макроэкономические стратегии, направленные на ускорение прогресса в области устойчивого к изменению климата развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государства-члены в Азиатско-Тихоокеанском регионе",
    BeneficiaryTwo: "Климат и окружающая среда ",
    SpecificResult: "Инклюзивное и устойчивое восстановление после бедствий; повышение устойчивости к будущим бедствиям",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=23"
  },
  {
    ID: 426,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Торговля, инвестиции и инновации",
    Title: "Страны активизируют переговоры по торговым соглашениям с помощью аналитических инструментов, адаптированных к конкретным условиям",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государства-члены в Азиатско-Тихоокеанском регионе",
    BeneficiaryTwo: "Государственное управление ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=28"
  },
  {
    ID: 427,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Торговля, инвестиции и инновации",
    Title: "Повышение устойчивости и эффективности торговых процессов за счет активизации мер в целях внедрения цифровых технологий содействия устойчивой торговле",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=28"
  },
  {
    ID: 428,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Торговля, инвестиции и инновации",
    Title: "Учреждения по содействию инвестициям берут на себя обязательства по продвижению гендерного равенства посредством прямых иностранных инвестиций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=29"
  },
  {
    ID: 429,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Торговля, инвестиции и инновации",
    Title: "Расширение доступа к возможностям передачи технологий и знаний о новых и инновационных технологиях",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государства-члены в Азиатско-Тихоокеанском регионе",
    BeneficiaryTwo: " ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=30"
  },
  {
    ID: 430,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Транспорт",
    Title: "Государства-члены все чаще учитывают принципы инклюзивного транспорта в процессах планирования и разработки политики, стремясь создать более доступные и социально инклюзивные транспортные системы в городах Азиатско-Тихоокеанского региона",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государства-члены в Азиатско-Тихоокеанском регионе",
    BeneficiaryTwo: " ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AZ,LA,MN,NP,FJ,KI,PG,SB,TL",
    Image: "19ESCAP9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=34"
  },
  {
    ID: 431,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Транспорт",
    Title: "Повышение эффективности и устойчивости к внешним факторам транспортного сообщения и логистических сетей в Азиатско-Тихоокеанском регионе",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Предпринимательство и повышение конкурентоспособности микро-, малых и средних предприятий",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=35"
  },
  {
    ID: 432,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Транспорт",
    Title: "Ускоренный переход к видам транспорта с низким уровнем выбросов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=36"
  },
  {
    ID: 433,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Транспорт",
    Title: "Укрепление регионального сотрудничества в интересах устойчивого, жизнеспособного и инклюзивного развития транспортной сферы",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государства-члены в Азиатско-Тихоокеанском регионе",
    BeneficiaryTwo: " ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=36"
  },
  {
    ID: 434,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Окружающая среда и развитие, а также снижение и регулирование риска бедствий",
    Title: "Ускоренное осуществление мер по борьбе с изменением климата",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BT,PG",
    Image: "19ESCAP13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=40"
  },
  {
    ID: 435,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Окружающая среда и развитие, а также снижение и регулирование риска бедствий",
    Title: "Государства-члены в Азиатско-Тихоокеанском регионе расширяют сотрудничество в целях продвижения основанных на широком участии подходов к решению экологических вопросов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=41"
  },
  {
    ID: 436,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Окружающая среда и развитие, а также снижение и регулирование риска бедствий",
    Title: "Расширение регионального сотрудничества в области действий по борьбе с изменением климата, связанных с Мировым океаном, в том числе на базе экосистемных подходов и природоохранных решений",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=42"
  },
  {
    ID: 437,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Окружающая среда и развитие, а также снижение и регулирование риска бедствий",
    Title: "Расширение и укрепление регионального сотрудничества, партнерских отношений и инициатив в области устойчивого городского развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Улучшение сотрудничества и партнерских отношений, повышение согласованности и синергии и уменьшение дублирования благодаря последовательной коммуникации",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=43"
  },
  {
    ID: 438,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Информационно-коммуникационные технологии и космические разработки",
    Title: "Активизация осуществления инициативы «Системы раннего оповещения для всех»",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Инклюзивное и устойчивое восстановление после бедствий; повышение устойчивости к будущим бедствиям",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=47"
  },
  {
    ID: 439,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Информационно-коммуникационные технологии и космические разработки",
    Title: "Более широкое внедрение инноваций, основанных на цифровых технологиях, для обеспечения преобразующей адаптации к изменению климата",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Технические достижения, позволяющие повысить качество, наличие, доступность и безопасность информации",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "MN,LA",
    Image: "19ESCAP18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=48"
  },
  {
    ID: 440,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Информационно-коммуникационные технологии и космические разработки",
    Title: "Расширение масштабов применения геопространственных технологий странами, находящимися в особой ситуации, в целях осуществления Повестки дня на период до 2030 года",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=48"
  },
  {
    ID: 441,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Информационно-коммуникационные технологии и космические разработки",
    Title: "Укрепление регионального сотрудничества в области эффективного использования новых технологий, в частности искусственного интеллекта",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государства-члены в Азиатско-Тихоокеанском регионе",
    BeneficiaryTwo: " ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=49"
  },
  {
    ID: 442,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Социальное развитие",
    Title: "Активизация регионального диалога и взаимодействия, а также проведение совместного обзора вопросов безопасной, упорядоченной и легальной миграции в Азиатско-Тихоокеанском регионе",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государства-члены в Азиатско-Тихоокеанском регионе",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Повышение качества информации о народонаселении, миграции, регистрации актов гражданского состояния и демографической ситуации, включая статистические данные в разбивке по признаку пола",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=54"
  },
  {
    ID: 443,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Социальное развитие",
    Title: "Разработка государствами-членами политических мер по оценке сектора экономики, связанного с обеспечением ухода, и осуществлению инвестиций в него",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Повышение качества информации о народонаселении, миграции, регистрации актов гражданского состояния и демографической ситуации, включая статистические данные в разбивке по признаку пола",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "LA,TL",
    Image: "19ESCAP22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=55"
  },
  {
    ID: 444,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Социальное развитие",
    Title: "Укрепление национального потенциала для разработки инклюзивной политики в отношении старения населения",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Повышение качества информации о народонаселении, миграции, регистрации актов гражданского состояния и демографической ситуации, включая статистические данные в разбивке по признаку пола",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=56"
  },
  {
    ID: 445,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Социальное развитие",
    Title: "Определение государствами-членами национальных стратегий развития политики в области социальной защиты, обеспечивающих устойчивость к изменению климата",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государства-члены в Азиатско-Тихоокеанском регионе",
    BeneficiaryTwo: "Климат и окружающая среда ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=56"
  },
  {
    ID: 446,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Статистика",
    Title: "Использование данных для содействия прогрессу в сфере регистрации актов гражданского состояния",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Повышение качества информации о народонаселении, миграции, регистрации актов гражданского состояния и демографической ситуации, включая статистические данные в разбивке по признаку пола",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=60"
  },
  {
    ID: 447,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Статистика",
    Title: "Улучшение управления данными со стороны национальных статистических управлений всех стран Азиатско-Тихоокеанского региона",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Повышение качества информации о народонаселении, миграции, регистрации актов гражданского состояния и демографической ситуации, включая статистические данные в разбивке по признаку пола",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=61"
  },
  {
    ID: 448,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Статистика",
    Title: "Создание национальных платформ по целям в области устойчивого развития для отслеживания хода осуществления Повестки дня в области устойчивого развития на период до 2030 года в Азиатско-Тихоокеанском регионе",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Укрепление потенциала для подготовки отчетности о прогрессе в достижении ЦУР; увеличение числа/повышение качества добровольных национальных обзоров",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=62"
  },
  {
    ID: 449,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Статистика",
    Title: "Укрепление национальных статистических систем на основе общесоциального подхода",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государства-члены в Азиатско-Тихоокеанском регионе",
    BeneficiaryTwo: "Государственное управление ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=63"
  },
  {
    ID: 450,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в Тихоокеанском субрегионе",
    Title: "Укрепление потенциала правительств стран Тихоокеанского региона в области учета экономической оценки экосистемных услуг при разработке политики и планировании",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: "Климат и окружающая среда ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=66"
  },
  {
    ID: 451,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в Тихоокеанском субрегионе",
    Title: "Способы включения Повестки дня Антигуа и Барбуды для малых островных развивающихся государств в национальные стратегии развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=67"
  },
  {
    ID: 452,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в Тихоокеанском субрегионе",
    Title: "Повышение эффективности разработки и использования основных показателей для национальной, региональной и глобальной отчетности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Укрепление потенциала для подготовки отчетности о прогрессе в достижении ЦУР; увеличение числа/повышение качества добровольных национальных обзоров",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=68"
  },
  {
    ID: 453,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в Тихоокеанском субрегионе",
    Title: "Усиление голоса стран Тихоокеанского региона для продвижения более конкретизированного индекса многоаспектной уязвимости Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=69"
  },
  {
    ID: 454,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в субрегионе Восточной и Северо-Восточной Азии",
    Title: "Расширение обмена знаниями в целях содействия реализации мер по борьбе с изменением климата на местном уровне",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Укрепление потенциала для подготовки отчетности о прогрессе в достижении ЦУР; увеличение числа/повышение качества добровольных национальных обзоров",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=72"
  },
  {
    ID: 455,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в субрегионе Восточной и Северо-Восточной Азии",
    Title: "Эффективное управление трансграничными железнодорожными перевозками и транзитом",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Предпринимательство и повышение конкурентоспособности микро-, малых и средних предприятий",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "MN,KR,RU,KU",
    Image: "19ESCAP34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=73"
  },
  {
    ID: 456,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в субрегионе Восточной и Северо-Восточной Азии",
    Title: "Укрепление трансграничного сотрудничества по решению проблем опустынивания и деградации земель в Восточной и Северо-Восточной Азии",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CN,HK,TW,KX,MO,KP,JP,MN,KR,RU,KU",
    Image: "19ESCAP35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=74"
  },
  {
    ID: 457,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в субрегионе Восточной и Северо-Восточной Азии",
    Title: "Укрепление сотрудничества в области морских охраняемых районов в Северо-Восточной Азии",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CN,HK,TW,KX,MO,KP,JP,MN,KR,RU,KU",
    Image: "19ESCAP36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=74"
  },
  {
    ID: 458,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в субрегионе Северной и Центральной Азии",
    Title: "Государства-члены в Северной и Центральной Азии разрабатывают рекомендации по активизации торговли",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государства-члены в Азиатско-Тихоокеанском регионе",
    BeneficiaryTwo: "Государственное управление ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=78"
  },
  {
    ID: 459,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в субрегионе Северной и Центральной Азии",
    Title: "Инструменты укрепления сотрудничества в рамках Специальной программы Организации Объединенных Наций для стран Центральной Азии",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Предпринимательство и повышение конкурентоспособности микро-, малых и средних предприятий",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=79"
  },
  {
    ID: 460,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в субрегионе Северной и Центральной Азии",
    Title: "Государства-члены продвигают политику в области цифровой трансформации",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=79"
  },
  {
    ID: 461,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в субрегионе Северной и Центральной Азии",
    Title: "Укрепление субрегионального сотрудничества в области модернизации энергосистем и интеграции возобновляемых источников энергии в Северной и Центральной Азии",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=80"
  },
  {
    ID: 462,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в субрегионе Южной и Юго-Западной Азии",
    Title: "Укрепление многостороннего сотрудничества по вопросам взаимосвязи между водными ресурсами и изменением климата в Южной Азии",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=83"
  },
  {
    ID: 463,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в субрегионе Южной и Юго-Западной Азии",
    Title: "Ускоренный переход к устойчивой энергетике",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=84"
  },
  {
    ID: 464,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в субрегионе Южной и Юго-Западной Азии",
    Title: "Преодоление цифрового разрыва в Южной и Юго-Западной Азии, чтобы никто не был забыт",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=85"
  },
  {
    ID: 465,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в субрегионе Южной и Юго-Западной Азии",
    Title: "Укрепление связей в сфере трансграничной торговли в Южной и ЮгоЗападной Азии с уделением особого внимания женщинам-предпринимателям и стартапам в приграничных районах",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государства-члены в Азиатско-Тихоокеанском регионе",
    BeneficiaryTwo: "Женщины и девочки",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=85"
  },
  {
    ID: 466,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в субрегионе Юго-Восточной Азии",
    Title: "Комплексное взаимодействие с различными заинтересованными сторонами в интересах устойчивого развития в Юго-Восточной Азии",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государства-члены в Азиатско-Тихоокеанском регионе",
    BeneficiaryTwo: " ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BN,KH,ID,LA,MY,MM,PH,SG,TH,TL,VN",
    Image: "19ESCAP45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=88"
  },
  {
    ID: 467,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в субрегионе Юго-Восточной Азии",
    Title: "Согласование политики и нормативных положений в отношении инвестиций в интересах достижения целей в области устойчивого развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "BN,KH,ID,LA,MY,MM,PH,SG,TH,TL,VN",
    Image: "19ESCAP46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=89"
  },
  {
    ID: 468,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в субрегионе Юго-Восточной Азии",
    Title: "Вовлечение молодежи в деятельность по достижению целей в области устойчивого развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BN,KH,ID,LA,MY,MM,PH,SG,TH,TL,VN",
    Image: "19ESCAP47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=89"
  },
  {
    ID: 469,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Деятельность в целях развития в субрегионах: Деятельность в целях развития в субрегионе Юго-Восточной Азии",
    Title: "Активизация регионального диалога и сотрудничества в области цифровой трансформации в целях устойчивого развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государства-члены в Азиатско-Тихоокеанском регионе",
    BeneficiaryTwo: " ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "19ESCAP48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=90"
  },
  {
    ID: 470,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Энергетика",
    Title: "Усовершенствованные меры в области перехода к устойчивой энергетике",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KH,FJ,FM,TO,VN",
    Image: "19ESCAP49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=94"
  },
  {
    ID: 471,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Энергетика",
    Title: "Страны принимают национальные планы действий в области охлаждения",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "VN",
    Image: "19ESCAP50.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=95"
  },
  {
    ID: 472,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Энергетика",
    Title: "Расширение сотрудничества государств-членов в Азиатско-Тихоокеанском регионе по проектам трансграничной энергетической связуемости",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP51.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=96"
  },
  {
    ID: 473,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Экономическая и социальная комиссия для Азии и Тихого океана",
    Programme: "Экономическое и социальное развитие в Азиатско-Тихоокеанском регионе",
    Subprogramme: "Энергетика",
    Title: "Согласование на межправительственном уровне контрольных показателей для продвижения связуемости региональных энергосистем",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Азиатско-Тихоокеанском регионе",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP52.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ru#page=97"
  },
  {
    ID: 474,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Окружающая среда",
    Title: "Применение государствами-членами методов прогнозирования для выработки рекомендаций по экологической политике с целью устранения пробелов и решения возникающих проблем",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=17"
  },
  {
    ID: 475,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Окружающая среда",
    Title: "Модернизированная база данных по загрязняющим веществам, позволяющая принимать оперативные решения на основе фактов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=18"
  },
  {
    ID: 476,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Окружающая среда",
    Title: "Улучшение общеевропейской базы экологических знаний для разработки обоснованной политики",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=18"
  },
  {
    ID: 477,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Окружающая среда",
    Title: "Совершенствование отчетности по данным о выбросах в атмосферу",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=19"
  },
  {
    ID: 478,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Транспорт",
    Title: "Применение программного обеспечения с открытым исходным кодом обеспечивает осуществление приложения 11 к Конвенции о международной перевозке грузов с применением книжки МДП",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=24"
  },
  {
    ID: 479,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Транспорт",
    Title: "Увеличение числа сторон, присоединившихся к основным конвенциям по безопасности дорожного движения в качестве первого шага, способствующего снижению смертности и травматизма в результате дорожно-транспортных происшествий во всем мире",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=25"
  },
  {
    ID: 480,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Транспорт",
    Title: "Укрепление нормативно-правовой базы по устойчивым внутренним транспортным системам",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=26"
  },
  {
    ID: 481,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Транспорт",
    Title: "Ускорение оцифровки правовых документов, касающихся внутреннего транспорта",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=26"
  },
  {
    ID: 482,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Статистика",
    Title: "Принятие государствами-членами усовершенствованных глобальных статистических стандартов",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=31"
  },
  {
    ID: 483,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Статистика",
    Title: "База статистических данных Европейской экономической комиссии для повышения качества исследований и процесса принятия решений",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=32"
  },
  {
    ID: 484,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Статистика",
    Title: "Улучшение отчетности о ходе достижения целей в области устойчивого развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Укрепление потенциала для подготовки отчетности о прогрессе в достижении ЦУР; увеличение числа/повышение качества добровольных национальных обзоров",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=32"
  },
  {
    ID: 485,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Статистика",
    Title: "Повышение показателей наличия и доступности статистических данных, касающихся изменения климата",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=33"
  },
  {
    ID: 486,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Экономическое сотрудничество и интеграция",
    Title: "Принятие государствами-членами Хартии преобразующих инноваций ЕЭК",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=36"
  },
  {
    ID: 487,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Экономическое сотрудничество и интеграция",
    Title: "Увеличение числа осуществляемых по линии государственно-частных партнерств инфраструктурных проектов, которые квалифицируются как соответствующие целям в области устойчивого развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=37"
  },
  {
    ID: 488,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Экономическое сотрудничество и интеграция",
    Title: "Оптимизация политики в области инноваций и инициатив в интересах устойчивого развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=38"
  },
  {
    ID: 489,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Экономическое сотрудничество и интеграция",
    Title: "Создание государственно-частных партнерств в соответствии со стандартами и методическими рекомендациями ЕЭК по государственно-частным партнерствам в поддержку достижения целей в области устойчивого развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=38"
  },
  {
    ID: 490,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Устойчивая энергетика",
    Title: "Укрепление трансграничного сотрудничества в области энергетической связуемости",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=42"
  },
  {
    ID: 491,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Устойчивая энергетика",
    Title: "Более рациональное и устойчивое управление природными ресурсами на основе Рамочной классификации ресурсов Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=43"
  },
  {
    ID: 492,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Устойчивая энергетика",
    Title: "Расширение использования электротранспорта для перехода к устойчивой энергетике",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=44"
  },
  {
    ID: 493,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Устойчивая энергетика",
    Title: "Сокращение выбросов парниковых газов в отраслях с высокой интенсивностью выбросов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Инклюзивное и устойчивое восстановление после бедствий; повышение устойчивости к будущим бедствиям",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=45"
  },
  {
    ID: 494,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Торговля",
    Title: "Принятые планы действий по обеспечению гендерного равенства способствуют развитию инклюзивной инфраструктуры качества для торговли",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=48"
  },
  {
    ID: 495,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Торговля",
    Title: "Повышение уровня цифровизации торговли",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=49"
  },
  {
    ID: 496,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Торговля",
    Title: "Повышение степени прозрачности и отслеживаемости в цепочках создания стоимости в критических секторах",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=50"
  },
  {
    ID: 497,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Торговля",
    Title: "Пересмотр стандартов качества сельскохозяйственной продукции в целях сокращения продовольственных потерь и пищевых отходов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=51"
  },
  {
    ID: 498,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Леса и лесная промышленность",
    Title: "Расширение интеграции устойчивых решений в области городского лесного хозяйства в процессы национального планирования",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=55"
  },
  {
    ID: 499,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Леса и лесная промышленность",
    Title: "Фактологически обоснованное планирование и принятие мер в интересах рационального производства и потребления лесохозяйственной продукции",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=56"
  },
  {
    ID: 500,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Леса и лесная промышленность",
    Title: "Расширение доступа к данным о лесах и лесной промышленности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=57"
  },
  {
    ID: 501,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Леса и лесная промышленность",
    Title: "Планирование на основе методов прогнозирования в интересах обеспечения жизнестойкости и устойчивости лесной промышленности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=57"
  },
  {
    ID: 502,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Жилищное хозяйство, землепользование и народонаселение",
    Title: "Государства-члены обязуются содействовать повышению доступности и устойчивости жилья",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=61"
  },
  {
    ID: 503,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Жилищное хозяйство, землепользование и народонаселение",
    Title: "Более чувствительная к возрасту и инклюзивная политика, позволяющая реагировать на проблемы и возможности, связанные с индивидуальным и демографическим старением",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=62"
  },
  {
    ID: 504,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Жилищное хозяйство, землепользование и народонаселение",
    Title: "Ускорение локализации целей в области устойчивого развития местными и региональными органами власти",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=62"
  },
  {
    ID: 505,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Европейская экономическая комиссия",
    Programme: "Экономическое развитие в Европе",
    Subprogramme: "Жилищное хозяйство, землепользование и народонаселение",
    Title: "Рамки упреждающей региональной политики по проблемам старения",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ru#page=63"
  },
  {
    ID: 506,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Международная торговля, интеграция и инфраструктура",
    Title: "Региональная таблица «затраты-выпуск» для разработки политики на основе фактических данных в странах Латинской Америки и Карибского бассейна",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=19"
  },
  {
    ID: 507,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Международная торговля, интеграция и инфраструктура",
    Title: "Более эффективная координация стратегий по обеспечению устойчивых и жизнеспособных систем торговли продовольствием и транспортных и логистических систем для повышения региональной продовольственной безопасности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=20"
  },
  {
    ID: 508,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Международная торговля, интеграция и инфраструктура",
    Title: "Стратегии, способствующие обеспечению всесторонней и доступной физической интеграции, инфраструктуры, транспорта и логистики",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=20"
  },
  {
    ID: 509,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Международная торговля, интеграция и инфраструктура",
    Title: "Государства-члены диверсифицируют свою экспортную корзину посредством увеличения объема продаж за рубеж услуг, предоставляемых с использованием цифровых технологий",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=21"
  },
  {
    ID: 510,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Производство и инновации",
    Title: "Обеспечение более полного учета гендерных аспектов в территориальных стратегиях развития производства",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "UY",
    Image: "21ECLAC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=25"
  },
  {
    ID: 511,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Производство и инновации",
    Title: "Расширение и усиление кластерных инициатив и других инициатив по объединению территориальных производств",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=26"
  },
  {
    ID: 512,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Производство и инновации",
    Title: "Укрепление стратегий развития производства для стимулирования роста производительности в ключевых секторах",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=27"
  },
  {
    ID: 513,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Производство и инновации",
    Title: "Стратегии развития производства, способствующие повышению технологичности производства, его диверсификации и структурным преобразованиям в интересах достижения равенства",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=27"
  },
  {
    ID: 514,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Макроэкономическая политика и рост",
    Title: "Коста-Рика содействует развитию рынка облигаций социального воздействия в целях активизации мобилизации внутренних ресурсов",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CR",
    Image: "21ECLAC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=31"
  },
  {
    ID: 515,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Макроэкономическая политика и рост",
    Title: "Макроэкономическая политика и политика финансирования развития для обеспечения экономического роста, инвестиций, бюджетной устойчивости и климатической жизнестойкости",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=31"
  },
  {
    ID: 516,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Макроэкономическая политика и рост",
    Title: "Разработка более эффективной политики в отношении налоговых расходов для содействия осуществлению целей в области устойчивого развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=32"
  },
  {
    ID: 517,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Макроэкономическая политика и рост",
    Title: "Расширение мобилизации внутренних государственных ресурсов в соответствии с целями, изложенными в Севильском обязательстве",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=33"
  },
  {
    ID: 518,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Социальное развитие и равенство",
    Title: "Парагвай создает социальный реестр домохозяйств, что способствует укреплению его системы социальной защиты",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PY",
    Image: "21ECLAC13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=36"
  },
  {
    ID: 519,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Социальное развитие и равенство",
    Title: "Расширение систем социальной защиты для охвата работников неформального сектора и независимых работников",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=37"
  },
  {
    ID: 520,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Социальное развитие и равенство",
    Title: "Более эффективное проведение политики инклюзивного трудоустройства, в том числе с учетом последствий изменения климата",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=38"
  },
  {
    ID: 521,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Социальное развитие и равенство",
    Title: "Разработка межотраслевых инструментов политики для обеспечения цифровой инклюзии и трансформации в целях сокращения неравенства",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=38"
  },
  {
    ID: 522,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Гендерное равенство и самостоятельность женщин",
    Title: "Десятилетие действий по достижению реального гендерного равенства и построению общества, основанного на принципе заботы",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=41"
  },
  {
    ID: 523,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Гендерное равенство и самостоятельность женщин",
    Title: "Прогресс в подготовке гендерной статистики по использованию времени и неоплачиваемому труду по уходу",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Укрепление потенциала для подготовки отчетности о прогрессе в достижении ЦУР; увеличение числа/повышение качества добровольных национальных обзоров",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=42"
  },
  {
    ID: 524,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Гендерное равенство и самостоятельность женщин",
    Title: "Всесторонний учет гендерных аспектов во внешней политике и международном сотрудничестве",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Повышение качества информации о народонаселении, миграции, регистрации актов гражданского состояния и демографической ситуации, включая статистические данные в разбивке по признаку пола",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=43"
  },
  {
    ID: 525,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Гендерное равенство и самостоятельность женщин",
    Title: "Страны оценивают отдачу от инвестиций в программы по обеспечению ухода",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=43"
  },
  {
    ID: 526,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Народонаселение и развитие ",
    Title: "Многонациональное Государство Боливия публикует результаты переписи населения и жилищного фонда",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Повышение качества информации о народонаселении, миграции, регистрации актов гражданского состояния и демографической ситуации, включая статистические данные в разбивке по признаку пола",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BO",
    Image: "21ECLAC21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=47"
  },
  {
    ID: 527,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Народонаселение и развитие ",
    Title: "Улучшенный демографический анализ для разработки государственной политики",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Повышение качества информации о народонаселении, миграции, регистрации актов гражданского состояния и демографической ситуации, включая статистические данные в разбивке по признаку пола",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=47"
  },
  {
    ID: 528,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Народонаселение и развитие ",
    Title: "Реализация Мадридского международного плана действий по проблемам старения на страновом уровне",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=48"
  },
  {
    ID: 529,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Народонаселение и развитие ",
    Title: "Страны самостоятельно готовят обновленные оценки и прогнозы численности населения и рабочей силы",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Укрепление потенциала для подготовки отчетности о прогрессе в достижении ЦУР; увеличение числа/повышение качества добровольных национальных обзоров",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=49"
  },
  {
    ID: 530,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Устойчивое развитие и населенные пункты",
    Title: "Усовершенствование систем оценки экологического воздействия в Латинской Америке",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=52"
  },
  {
    ID: 531,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Устойчивое развитие и населенные пункты",
    Title: "Разработка стратегий устойчивого потребления и производства, включая экономику замкнутого цикла, для улучшения экологических показателей",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=53"
  },
  {
    ID: 532,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Устойчивое развитие и населенные пункты",
    Title: "Улучшение моделей, имитирующих вероятные последствия изменения климата, для обоснования разработки политики и вариантов инвестирования",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Технические достижения, позволяющие повысить качество, наличие, доступность и безопасность информации",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=54"
  },
  {
    ID: 533,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Устойчивое развитие и населенные пункты",
    Title: "Определение национальных приоритетов на основе единых рамок для осуществления Соглашения Эскаcу",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=55"
  },
  {
    ID: 534,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Природные ресурсы",
    Title: "Укрепление политического диалога и регионального управления в горнодобывающей отрасли",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=58"
  },
  {
    ID: 535,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Природные ресурсы",
    Title: "Страны региона поставляют критически важные минералы, необходимые для энергетического перехода, с обеспечением повышенной экономической, социальной и экологической устойчивости",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=59"
  },
  {
    ID: 536,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Природные ресурсы",
    Title: "Новые инициативы по содействию энергетическому переходу в Латинской Америке и Карибском бассейне",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=59"
  },
  {
    ID: 537,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Природные ресурсы",
    Title: "Укрепление системы регулирования деятельности по освоению океанических ресурсов и соответствующей политики в целях содействия устойчивому использованию океанических ресурсов в регионе и рациональному управлению ими",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=60"
  },
  {
    ID: 538,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Планирование и государственное управление в целях",
    Title: "Утверждение Региональной повестки дня по вопросам регулирования планирования и государственного управления в целях устойчивого развития в Латинской Америке и Карибском бассейне в качестве ориентира для долгосрочного стратегического планирования",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=63"
  },
  {
    ID: 539,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Планирование и государственное управление в целях",
    Title: "Проведение комплексной политики развития для создания более жизнестойких территорий в целях ускорения реализации Повестки дня на период до 2030 года",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=64"
  },
  {
    ID: 540,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Планирование и государственное управление в целях",
    Title: "Улучшение технического, оперативного, политического и рассчитанного на перспективу потенциала государственных учреждений для управления преобразованиями и решения сложных задач в меняющихся условиях",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=65"
  },
  {
    ID: 541,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Планирование и государственное управление в целях",
    Title: "Государства-члены разрабатывают долгосрочные национальные и субнациональные планы развития, охватывающие четыре стратегических направления, предусмотренных Региональной повесткой дня по вопросам регулирования планирования и государственного управления в целях устойчивого развития в Латинской Америке и Карибском бассейне",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=65"
  },
  {
    ID: 542,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Статистика",
    Title: "Повышение точности данных, используемых при разработке политики, касающейся бедности, неравенства, занятости, образования и условий жизни",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=69"
  },
  {
    ID: 543,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Статистика",
    Title: "Более активное внедрение Комплексной системы геопространственной информации Организации Объединенных Наций на национальном уровне",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=70"
  },
  {
    ID: 544,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Статистика",
    Title: "Более широкое использование административных регистров для подготовки статистических данных",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Повышение качества информации о народонаселении, миграции, регистрации актов гражданского состояния и демографической ситуации, включая статистические данные в разбивке по признаку пола",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=71"
  },
  {
    ID: 545,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Статистика",
    Title: "Модернизация национальных статистических систем для оценки экономической деятельности в странах Латинской Америки и Карибского бассейна",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=71"
  },
  {
    ID: 546,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Деятельность в субрегионе Гаити, Доминиканской Республики, Кубы, Мексики и Центральной Америки",
    Title: "Страны активизируют усилия по развитию производства на основе цепочек создания стоимости",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=74"
  },
  {
    ID: 547,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Деятельность в субрегионе Гаити, Доминиканской Республики, Кубы, Мексики и Центральной Америки",
    Title: "Ускорение достижения целей в области устойчивого развития благодаря устранению структурных недостатков",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=75"
  },
  {
    ID: 548,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Деятельность в субрегионе Гаити, Доминиканской Республики, Кубы, Мексики и Центральной Америки",
    Title: "Совершенствование системы упреждающего управления для обеспечения информированности при разработке политики в субрегионе",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=76"
  },
  {
    ID: 549,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Деятельность в субрегионе Гаити, Доминиканской Республики, Кубы, Мексики и Центральной Америки",
    Title: "Совершенствование государственных стратегий по содействию развития производства в конкретных субнациональных регионах и секторах",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=76"
  },
  {
    ID: 550,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Деятельность в субрегионе Карибского бассейна",
    Title: "Разработка комплексного подхода к управлению природными ресурсами для борьбы с саргассовыми водорослями в Карибском бассейне",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=79"
  },
  {
    ID: 551,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Деятельность в субрегионе Карибского бассейна",
    Title: "Цифровая инклюзия в Карибском бассейне",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=80"
  },
  {
    ID: 552,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Деятельность в субрегионе Карибского бассейна",
    Title: "Интеграция Повестки дня Антигуа и Барбуды для малых островных развивающихся государств в национальные процессы и повестки дня в области развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=81"
  },
  {
    ID: 553,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Деятельность в субрегионе Карибского бассейна",
    Title: "Диверсификация экономики путем расширения сотрудничества Юг — Юг со странами Латинской Америки",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Улучшение сотрудничества и партнерских отношений, повышение согласованности и синергии и уменьшение дублирования благодаря последовательной коммуникации",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=81"
  },
  {
    ID: 554,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Поддержка процессов и организаций региональной и субрегиональной интеграции и сотрудничества",
    Title: "Региональный консенсус по вопросу об оценке устойчивого развития, выходящей за рамки валового внутреннего продукта",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Улучшение сотрудничества и партнерских отношений, повышение согласованности и синергии и уменьшение дублирования благодаря последовательной коммуникации",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=85"
  },
  {
    ID: 555,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Поддержка процессов и организаций региональной и субрегиональной интеграции и сотрудничества",
    Title: "Укрепление многосторонних инициатив в рамках сотрудничества Юг — Юг и трехстороннего сотрудничества",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC50.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=86"
  },
  {
    ID: 556,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Поддержка процессов и организаций региональной и субрегиональной интеграции и сотрудничества",
    Title: "Страны Латинской Америки и Карибского бассейна взаимодействуют с внерегиональными субъектами по вопросам сотрудничества Юг — Юг и трехстороннего сотрудничества",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC51.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=87"
  },
  {
    ID: 557,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Экономическая комиссия для Латинской Америки и Карибского бассейна",
    Programme: "Экономическое и социальное развитие в Латинской Америке и Карибском бассейне",
    Subprogramme: "Поддержка процессов и организаций региональной и субрегиональной интеграции и сотрудничества",
    Title: "Расширение сотрудничества Юг — Юг и трехстороннего сотрудничества, а также региональной интеграции в соответствии с Севильским обязательством",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Государства-члены в Латинской Америке и Карибском бассейне ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC52.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ru#page=87"
  },
  {
    ID: 558,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Изменение климата и рациональное использование природных ресурсов",
    Title: "Наименее развитые арабские страны переходят к использованию недорогих, надежных, устойчивых и современных источников энергии посредством внедрения способствующих снижению рисков финансовых инструментов и инструментов для разработки моделей работы",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=13"
  },
  {
    ID: 559,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Изменение климата и рациональное использование природных ресурсов",
    Title: "Переход к устойчивым продовольственным системам",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Укрепление нормативно-правовой базы и системы экологического управления; активизация действий, связанных с изменением климата, в интересах устойчивого развития",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "22ESCWA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=14"
  },
  {
    ID: 560,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Изменение климата и рациональное использование природных ресурсов",
    Title: "Государства-члены определяют совместные приоритетные действия по борьбе с песчаными и пыльными бурями",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Инклюзивное и устойчивое восстановление после бедствий; повышение устойчивости к будущим бедствиям",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=15"
  },
  {
    ID: 561,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Изменение климата и рациональное использование природных ресурсов",
    Title: "Повышение жизнестойкости поверхностных водосборных бассейнов и бассейнов грунтовых вод в арабском регионе",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Климат и окружающая среда ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=15"
  },
  {
    ID: 562,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Гендерная справедливость, народонаселение и всеохватное развитие",
    Title: "Молодежь в арабском регионе имеет доступ к возможностям для трудоустройства",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=19"
  },
  {
    ID: 563,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Гендерная справедливость, народонаселение и всеохватное развитие",
    Title: "Государства-члены применяют многоаспектный подход к сокращению масштабов нищеты",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Укрепление потенциала для подготовки отчетности о прогрессе в достижении ЦУР; увеличение числа/повышение качества добровольных национальных обзоров",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=20"
  },
  {
    ID: 564,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Гендерная справедливость, народонаселение и всеохватное развитие",
    Title: "Государства-члены используют машинное обучение для прогнозирования бюджетных потребностей в связи с программами социальной помощи",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=21"
  },
  {
    ID: 565,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Гендерная справедливость, народонаселение и всеохватное развитие",
    Title: "Государства-члены определяют и начинают осуществлять приоритетные меры по расширению экономических прав и возможностей инвалидов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Обеспечение более инклюзивного развития, чтобы никто не был забыт; искоренение нищеты и уменьшение неравенства; сокращение масштабов дискриминации в отношении женщин и девочек и усиление гендерного равенства",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=21"
  },
  {
    ID: 566,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Общее экономическое процветание",
    Title: "Иордания и Тунис разработали макрофискальную политику, направленную на расширение масштабов финансирования социального сектора и повышение фискальной устойчивости",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=25"
  },
  {
    ID: 567,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Общее экономическое процветание",
    Title: "Улучшение ситуации с сохранением приемлемого уровня задолженности для увеличения инвестиций в решение приоритетных задач в области устойчивого развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Повышение качества информации о народонаселении, миграции, регистрации актов гражданского состояния и демографической ситуации, включая статистические данные в разбивке по признаку пола",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=26"
  },
  {
    ID: 568,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Общее экономическое процветание",
    Title: "Государства-члены заключают двусторонние торговые соглашения за пределами региона",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Частный сектор, включая микро-, малые и средние предприятия ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=27"
  },
  {
    ID: 569,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Общее экономическое процветание",
    Title: "Арабские страны проводят оценки макроэкономических последствий мер по диверсификации экономики",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=27"
  },
  {
    ID: 570,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Статистика, информационное общество и технологии",
    Title: "Усовершенствование национальных счетов в арабском регионе для содействия разработке политики на основе фактических данных",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=31"
  },
  {
    ID: 571,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Статистика, информационное общество и технологии",
    Title: "Геостатистические данные повышают эффективность принятия решений и планирования развития в арабском регионе",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=32"
  },
  {
    ID: 572,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Статистика, информационное общество и технологии",
    Title: "Арабские государства-члены, включая наименее развитые страны, подготавливают статистические данные по внешней торговле",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Повышение качества измерения и статистики в целях разработки основанных на фактах стратегий в области устойчивого развития",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=32"
  },
  {
    ID: 573,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Статистика, информационное общество и технологии",
    Title: "Директивные органы используют комплексную региональную платформу данных для разработки обоснованной политики",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Технические достижения, позволяющие повысить качество, наличие, доступность и безопасность информации",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=33"
  },
  {
    ID: 574,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Повестка дня на период до 2030 года и координация деятельности по достижению целей в области устойчивого развития",
    Title: "Государства-члены вырабатывают общую позицию для согласования политической декларации второй Всемирной встречи на высшем уровне в интересах социального развития",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=38"
  },
  {
    ID: 575,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Повестка дня на период до 2030 года и координация деятельности по достижению целей в области устойчивого развития",
    Title: "Увеличение инвестиций частного сектора в решение региональных и национальных приоритетных задач в области устойчивого развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Углубление понимания потребностей в финансировании, совершенствование вариантов политики в области финансирования устойчивых капиталовложений и усиление заинтересованности и расширение участия в финансировании устойчивых проектов",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=38"
  },
  {
    ID: 576,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Повестка дня на период до 2030 года и координация деятельности по достижению целей в области устойчивого развития",
    Title: "Государства-члены выявляют и устраняют пробелы в политике в связи с реализацией Повестки дня на период до 2030 года",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=39"
  },
  {
    ID: 577,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Повестка дня на период до 2030 года и координация деятельности по достижению целей в области устойчивого развития",
    Title: "Разработка региональной концепции для определения направлений регионального развития в средне- и долгосрочной перспективе",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=40"
  },
  {
    ID: 578,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Государственное управление и предотвращение конфликтов",
    Title: "Оман осуществляет планирование развития на местном уровне на основе фактических данных",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "OM",
    Image: "22ESCWA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=43"
  },
  {
    ID: 579,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Государственное управление и предотвращение конфликтов",
    Title: "Модернизация систем государственного управления в интересах обеспечения эффективности и прозрачности государственного управления и социально-экономического развития",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Укрепление институтов и верховенства права и более эффективное предотвращение конфликтов",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=44"
  },
  {
    ID: 580,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Государственное управление и предотвращение конфликтов",
    Title: "Государства-члены разрабатывают и внедряют политику в области развития, устойчивую к нестабильности и внезапным потрясениям",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=45"
  },
  {
    ID: 581,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Экономическая и социальная комиссия для Западной Азии",
    Programme: "Экономическое и социальное развитие в Западной Азии",
    Subprogramme: "Государственное управление и предотвращение конфликтов",
    Title: "Укрепление механизмов регулирования конкуренции в целях обеспечения транспарентности и инклюзивности рынков",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: "Государства-члены в Европе, Центральной Азии и Западной Азии ",
    SpecificResult: "Укрепление потенциала и устранение барьеров, в том числе с помощью электронной торговли и цифровой экономики, в целях улучшения торговли и повышения конкурентоспособности",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ru#page=45"
  },
  {
    ID: 582,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Всесторонний учет прав человека, право на развитие и исследования и анализ: Всесторонний учет прав человека",
    Title: "Учет норм и стандартов в области прав человека в общих страновых анализах и рамочных программах сотрудничества Организации Объединенных Наций в области устойчивого развития",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=19"
  },
  {
    ID: 583,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Всесторонний учет прав человека, право на развитие и исследования и анализ: Всесторонний учет прав человека",
    Title: "Учет при составлении государственных бюджетов международных стандартов в области прав человека, касающихся экономических, социальных и культурных прав",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=20"
  },
  {
    ID: 584,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Всесторонний учет прав человека, право на развитие и исследования и анализ: Всесторонний учет прав человека",
    Title: "Улучшение поощрения и защиты прав человека в национальной политике и практике с помощью центра знаний по экономическим, социальным и культурным правам",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=21"
  },
  {
    ID: 585,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Всесторонний учет прав человека, право на развитие и исследования и анализ: Всесторонний учет прав человека",
    Title: "Государства-члены принимают законы о борьбе с терроризмом и меры по их осуществлению, которые соответствуют правам, закрепленным во Всеобщей декларации прав человека, и обязательствам государств, вытекающим из международного права в области прав человека",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=21"
  },
  {
    ID: 586,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Всесторонний учет прав человека, право на развитие и исследования и анализ: Право на развитие",
    Title: "Государства-члены и другие заинтересованные стороны располагают необходимыми ресурсами для реализации права на развитие в рамках достижения целей в области устойчивого развития",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=24"
  },
  {
    ID: 587,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Всесторонний учет прав человека, право на развитие и исследования и анализ: Право на развитие",
    Title: "Реализация антикоррупционных политики и практических мер, направленных на устранение негативного воздействия коррупции на осуществление прав человека",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=25"
  },
  {
    ID: 588,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Всесторонний учет прав человека, право на развитие и исследования и анализ: Право на развитие",
    Title: "Активизация поощрения и защиты права на развитие",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=26"
  },
  {
    ID: 589,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Всесторонний учет прав человека, право на развитие и исследования и анализ: Право на развитие",
    Title: "Активизация деятельности по продвижению права на развитие на региональном и национальном уровнях",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Наименее развитые страны, развивающиеся страны, не имеющие выхода к морю, малые островные развивающиеся государства и другие развивающиеся страны ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=27"
  },
  {
    ID: 590,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Всесторонний учет прав человека, право на развитие и исследования и анализ: Исследования и анализ",
    Title: "Государства-члены содействуют принятию законов, политики и практических мер в области борьбы с наркотиками, которые соответствуют нормам международного права в области прав человека",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BR,CO,PK",
    Image: "24UHCHR9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=30"
  },
  {
    ID: 591,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Всесторонний учет прав человека, право на развитие и исследования и анализ: Исследования и анализ",
    Title: "Углубление понимания прав человека молодыми правозащитниками — представителями коренных народов, меньшинств и лиц африканского происхождения",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Молодежь",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=31"
  },
  {
    ID: 592,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Всесторонний учет прав человека, право на развитие и исследования и анализ: Исследования и анализ",
    Title: "Улучшение понимания государствами-членами и другими заинтересованными сторонами влияния цифровых технологий на права человека",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=31"
  },
  {
    ID: 593,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Всесторонний учет прав человека, право на развитие и исследования и анализ: Исследования и анализ",
    Title: "Государства-члены принимают и осуществляют основанные на фактических данных меры и политику по борьбе с расизмом, направленные на укрепление равенства, недискриминации, толерантности и обеспечение соблюдения всех прав человека",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=32"
  },
  {
    ID: 594,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Вспомогательное обслуживание договорных органов по правам человека",
    Title: "Расширение практики использования договорными органами перечней тем и перечней тем до представления докладов",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=35"
  },
  {
    ID: 595,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Вспомогательное обслуживание договорных органов по правам человека",
    Title: "Расширение международного сотрудничества в поддержку национальных механизмов осуществления, представления докладов и последующей деятельности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=36"
  },
  {
    ID: 596,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Вспомогательное обслуживание договорных органов по правам человека",
    Title: "Улучшение доступа государств-участников и заинтересованных сторон к рекомендациям договорных органов для содействия их выполнению",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=37"
  },
  {
    ID: 597,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Вспомогательное обслуживание договорных органов по правам человека",
    Title: "Единая платформа для доступа к информации о работе договорных органов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=38"
  },
  {
    ID: 598,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Консультационные услуги, техническое сотрудничество и деятельность на местах",
    Title: "Расследования, проводимые по поручению Совета по правам человека, способствуют процессу привлечения к ответственности, обеспечивая всесторонний, независимый и основанный на фактах анализ нарушений прав человека, а также нарушений норм международного гуманитарного права и международного права прав человека",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=43"
  },
  {
    ID: 599,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Консультационные услуги, техническое сотрудничество и деятельность на местах",
    Title: "Повышение эффективности национальных правозащитных учреждений в соответствии с Парижскими принципами",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=44"
  },
  {
    ID: 600,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Консультационные услуги, техническое сотрудничество и деятельность на местах",
    Title: "Расширение технического сотрудничества для оказания государствам — членам Карибского сообщества поддержки в их усилиях по поощрению, защите и осуществлению прав человека",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Государства-члены в Латинской Америке и Карибском бассейне ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,BS,BD,BZ,DM,GD,GY,HT,JM,MS,LC,KN,VC,SR,TT,AI,BM,VG,KY,TC",
    Image: "24UHCHR19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=45"
  },
  {
    ID: 601,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Консультационные услуги, техническое сотрудничество и деятельность на местах",
    Title: "Государства-члены и другие заинтересованные стороны принимают меры по урегулированию ситуации с правами человека на страновом и региональном уровнях",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=45"
  },
  {
    ID: 602,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Поддержка Совета по правам человека, его вспомогательных органов и механизмов",
    Title: "Повышение эффективности специальных процедур на глобальном, региональном и национальном уровнях",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=50"
  },
  {
    ID: 603,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Поддержка Совета по правам человека, его вспомогательных органов и механизмов",
    Title: "Увеличение вклада национальных правозащитных учреждений в работу механизма универсального периодического обзора",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=51"
  },
  {
    ID: 604,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Поддержка Совета по правам человека, его вспомогательных органов и механизмов",
    Title: "Активизация привлечения страновых групп Организации Объединенных Наций к участию в работе механизма универсального периодического обзора",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Прогресс в деле защиты и реализации прав человека, сокращение неравенства и масштабов дискриминации; дальнейшая интеграция права на развитие",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=52"
  },
  {
    ID: 605,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Поддержка Совета по правам человека, его вспомогательных органов и механизмов",
    Title: "Расширение доступа людей с ограниченными возможностями к работе Совета по правам человека",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Повышение эффективности многосторонних заседаний и обсуждений",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=52"
  },
  {
    ID: 606,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Канцелярия Защитника прав жертв",
    Title: "Укрепление общесистемного осуществления стратегии Генерального секретаря по уделению первоочередного внимания правам и достоинству жертв в рамках усилий по предотвращению сексуальной эксплуатации и сексуальных надругательств и реагированию на них",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Женщины и девочки",
    SpecificResult: "Принятие более эффективных мер реагирования на случаи сексуальной эксплуатации и сексуальных злоупотреблений, сексуальных домогательств, мошенничества и коррупции; более широкое применение подхода, ориентированного на интересы жертв",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=129"
  },
  {
    ID: 607,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по правам человека",
    Programme: "Права человека",
    Subprogramme: "Канцелярия Защитника прав жертв",
    Title: "Оказание жертвам более эффективной поддержки за счет использования разнообразного опыта и знаний специалистов по правам жертв, задействованных в миротворческой и гуманитарной сфере и в сфере развития",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Поощрение прав человека ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Женщины и девочки",
    SpecificResult: "Принятие более эффективных мер реагирования на случаи сексуальной эксплуатации и сексуальных злоупотреблений, сексуальных домогательств, мошенничества и коррупции; более широкое применение подхода, ориентированного на интересы жертв",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "ET,HT,ML,UA",
    Image: "24UHCHR26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ru#page=129"
  },
  {
    ID: 608,
    BudgetSection: "25",
    Entity: "UNHCR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по делам беженцев",
    Programme: "Международная защита беженцев, поиск долговременных решений  их проблем и оказание им помощи",
    Subprogramme: "Международная защита беженцев, поиск долговременных решений их проблем и оказание им помощи",
    Title: "Взятые на Глобальном форуме по беженцам обязательства по содействию распределению ответственности и оказанию поддержки беженцам и принимающим общинам",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.25)&l=ru#page=6"
  },
  {
    ID: 609,
    BudgetSection: "25",
    Entity: "UNHCR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по делам беженцев",
    Programme: "Международная защита беженцев, поиск долговременных решений  их проблем и оказание им помощи",
    Subprogramme: "Международная защита беженцев, поиск долговременных решений их проблем и оказание им помощи",
    Title: "Увеличение доли национальных и местных партнеров в планах оказания помощи беженцам на глобальном уровне",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.25)&l=ru#page=7"
  },
  {
    ID: 610,
    BudgetSection: "25",
    Entity: "UNHCR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по делам беженцев",
    Programme: "Международная защита беженцев, поиск долговременных решений  их проблем и оказание им помощи",
    Subprogramme: "Международная защита беженцев, поиск долговременных решений их проблем и оказание им помощи",
    Title: "Усиление защиты и расширение доступа к услугам для беженцев и просителей убежища",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.25)&l=ru#page=8"
  },
  {
    ID: 611,
    BudgetSection: "25",
    Entity: "UNHCR",
    EntityFullName: "Управление Верховного комиссара Организации Объединённых Наций по делам беженцев",
    Programme: "Международная защита беженцев, поиск долговременных решений  их проблем и оказание им помощи",
    Subprogramme: "Международная защита беженцев, поиск долговременных решений их проблем и оказание им помощи",
    Title: "Более строгое соблюдение международных конвенций о безгражданстве",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.25)&l=ru#page=8"
  },
  {
    ID: 612,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Защита палестинских беженцев путем реализации их прав в соответствии с международным правом",
    Title: "Расширение доступа к реабилитационной поддержке для палестинских беженцев с инвалидностью",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=9"
  },
  {
    ID: 613,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Защита палестинских беженцев путем реализации их прав в соответствии с международным правом",
    Title: "Повышение уровня безопасности и укрепление достоинства палестинских беженцев, получающих услуги Агентства",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=10"
  },
  {
    ID: 614,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Защита палестинских беженцев путем реализации их прав в соответствии с международным правом",
    Title: "Усиление защиты палестинских беженцев от гендерного насилия",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Женщины и девочки",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=10"
  },
  {
    ID: 615,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Защита палестинских беженцев путем реализации их прав в соответствии с международным правом",
    Title: "Повышение эффективности социальной работы в интересах уязвимых палестинских беженцев",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=11"
  },
  {
    ID: 616,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Обеспечение палестинским беженцам всеобщего доступа к качественной первичной медико-санитарной помощи и целевого доступа к специализированному и высокотехнологичному медицинскому обслуживанию в целях улучшения показателей здоровья",
    Title: "Повышение эффективности борьбы с неинфекционными заболеваниями среди палестинских беженцев",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=13"
  },
  {
    ID: 617,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Обеспечение палестинским беженцам всеобщего доступа к качественной первичной медико-санитарной помощи и целевого доступа к специализированному и высокотехнологичному медицинскому обслуживанию в целях улучшения показателей здоровья",
    Title: "Расширение доступа палестинских беженцев к прегравидарной подготовке и услугам по репродуктивному планированию",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Женщины и девочки",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=14"
  },
  {
    ID: 618,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Обеспечение палестинским беженцам всеобщего доступа к качественной первичной медико-санитарной помощи и целевого доступа к специализированному и высокотехнологичному медицинскому обслуживанию в целях улучшения показателей здоровья",
    Title: "Борьба с инфекционными заболеваниями в общинах палестинских беженцев",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=15"
  },
  {
    ID: 619,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Обеспечение палестинским беженцам всеобщего доступа к качественной первичной медико-санитарной помощи и целевого доступа к специализированному и высокотехнологичному медицинскому обслуживанию в целях улучшения показателей здоровья",
    Title: "Обеспечение постоянного доступа к поддержке в области охраны психического здоровья и психосоциальной поддержке для палестинских беженцев, у которых выявлены соответствующие потребности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=15"
  },
  {
    ID: 620,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Предоставление палестинским беженцам возможности получить качественное образование на основе принципов всеохватности и справедливости",
    Title: "Обеспечение стабильного охвата детей из числа палестинских беженцев начальным образованием",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Молодежь",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=17"
  },
  {
    ID: 621,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Предоставление палестинским беженцам возможности получить качественное образование на основе принципов всеохватности и справедливости",
    Title: "Создание более безопасной и инклюзивной учебной среды для учащихся в школах Агентства",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Молодежь",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=18"
  },
  {
    ID: 622,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Предоставление палестинским беженцам возможности получить качественное образование на основе принципов всеохватности и справедливости",
    Title: "Защита социального и эмоционального развития детей из числа палестинских беженцев",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Молодежь",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=19"
  },
  {
    ID: 623,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Предоставление палестинским беженцам возможности получить качественное образование на основе принципов всеохватности и справедливости",
    Title: "Расширение масштабов использования смешанного и адаптивного обучения во всех районах деятельности БАПОР",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Молодежь",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=19"
  },
  {
    ID: 624,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Обеспечение палестинским беженцам стабильных и, насколько позволяют обстоятельства, более широких возможностей для получения достойной работы и дохода за счет развития навыков, поддержки предпринимательства и предоставления справедливого доступа к рынкам",
    Title: "Расширение возможностей трудоустройства за счет проведения работ по развитию инфраструктуры и благоустройству лагерей",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=22"
  },
  {
    ID: 625,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Обеспечение палестинским беженцам стабильных и, насколько позволяют обстоятельства, более широких возможностей для получения достойной работы и дохода за счет развития навыков, поддержки предпринимательства и предоставления справедливого доступа к рынкам",
    Title: "Создание возможностей для трудоустройства в частном секторе",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=22"
  },
  {
    ID: 626,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Обеспечение палестинским беженцам стабильных и, насколько позволяют обстоятельства, более широких возможностей для получения достойной работы и дохода за счет развития навыков, поддержки предпринимательства и предоставления справедливого доступа к рынкам",
    Title: "Расширение возможностей для трудоустройства молодежи посредством профессиональной подготовки",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Молодежь",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=23"
  },
  {
    ID: 627,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Обеспечение палестинским беженцам стабильных и, насколько позволяют обстоятельства, более широких возможностей для получения достойной работы и дохода за счет развития навыков, поддержки предпринимательства и предоставления справедливого доступа к рынкам",
    Title: "Расширение возможностей пользования общедоступными финансовыми услугами для женщин из числа палестинских беженцев",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Женщины и девочки",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=24"
  },
  {
    ID: 628,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Обеспечение доступа палестинских беженцев к объектам базовой и общественной инфраструктуры на территории безопасных и рационально обустроенных лагерей, где созданы условия для охраны их здоровья и уважения их достоинства",
    Title: "Снижение рисков для здоровья палестинских беженцев, обусловленных состоянием систем водоснабжения и санитарии в лагерях",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=26"
  },
  {
    ID: 629,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Обеспечение доступа палестинских беженцев к объектам базовой и общественной инфраструктуры на территории безопасных и рационально обустроенных лагерей, где созданы условия для охраны их здоровья и уважения их достоинства",
    Title: "Повышение уровня безопасности и укрепление достоинства палестинских беженцев, живущих в лагерях",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=27"
  },
  {
    ID: 630,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Обеспечение доступа палестинских беженцев к объектам базовой и общественной инфраструктуры на территории безопасных и рационально обустроенных лагерей, где созданы условия для охраны их здоровья и уважения их достоинства",
    Title: "Улучшение качества водоснабжения для палестинских беженцев",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=27"
  },
  {
    ID: 631,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Обеспечение доступа палестинских беженцев к объектам базовой и общественной инфраструктуры на территории безопасных и рационально обустроенных лагерей, где созданы условия для охраны их здоровья и уважения их достоинства",
    Title: "Улучшение условий жизни палестинских беженцев в лагерях",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=28"
  },
  {
    ID: 632,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Предоставление более эффективной и адресной социальной помощи для наиболее уязвимых палестинских беженцев",
    Title: "Расширение возможностей трудоустройства для уязвимой молодежи из числа палестинских беженцев",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Молодежь",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=30"
  },
  {
    ID: 633,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Предоставление более эффективной и адресной социальной помощи для наиболее уязвимых палестинских беженцев",
    Title: "Обеспечение доступа к недорогому больничному обслуживанию",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=30"
  },
  {
    ID: 634,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Предоставление более эффективной и адресной социальной помощи для наиболее уязвимых палестинских беженцев",
    Title: "Гарантирование социальных выплат для наиболее уязвимых палестинских беженцев",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=31"
  },
  {
    ID: 635,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Предоставление более эффективной и адресной социальной помощи для наиболее уязвимых палестинских беженцев",
    Title: "Повышение устойчивости домохозяйств, получающих социальные выплаты",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=32"
  },
  {
    ID: 636,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Точная регистрация палестинских беженцев и надежная защита данных об их статусе",
    Title: "Обеспечение сохранности и защиты архивных семейных документов путем их масштабного оцифровывания",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,LU,PS,SY",
    Image: "26UNRWA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=33"
  },
  {
    ID: 637,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Ближневосточное агентство Организации Объединённых Наций для помощи палестинским беженцам и организации работ",
    Programme: "Палестинские беженцы",
    Subprogramme: "Точная регистрация палестинских беженцев и надежная защита данных об их статусе",
    Title: "Предоставление зарегистрированным палестинским беженцам более удобного цифрового доступа к своим данным и услугам",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Усиление защиты прав беженцев, улучшение их условий жизни, включая здравоохранение и образование, более оперативное реагирование и разделение бремени",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ru#page=34"
  },
  {
    ID: 638,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Управление по координации гуманитарных вопросов",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Политика и анализ",
    Title: "Определение приоритетов в области гуманитарного реагирования, решение вопросов финансирования и принятие мер по обеспечению готовности на основе консультаций, организованных на местах",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение согласованности, своевременности и эффективности и расширение масштаба гуманитарного реагирования; существенное снижение риска бедствий",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CO,PH,SO",
    Image: "27OCHA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=9"
  },
  {
    ID: 639,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Управление по координации гуманитарных вопросов",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Политика и анализ",
    Title: "Расширение участия общин в мероприятиях по гуманитарному реагированию в целях эффективного удовлетворения их потребностей",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение согласованности, своевременности и эффективности и расширение масштаба гуманитарного реагирования; существенное снижение риска бедствий",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CO,NE,PH,SS,II,SO",
    Image: "27OCHA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=10"
  },
  {
    ID: 640,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Управление по координации гуманитарных вопросов",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Политика и анализ",
    Title: "Улучшение коллективного обучения через учет мнения местного населения",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение согласованности, своевременности и эффективности и расширение масштаба гуманитарного реагирования; существенное снижение риска бедствий",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=11"
  },
  {
    ID: 641,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Управление по координации гуманитарных вопросов",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Политика и анализ",
    Title: "Более эффективное и структурированное гуманитарное реагирование в интересах пострадавших общин",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение согласованности, своевременности и эффективности и расширение масштаба гуманитарного реагирования; существенное снижение риска бедствий",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=11"
  },
  {
    ID: 642,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Управление по координации гуманитарных вопросов",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Координация гуманитарной деятельности и мер реагирования на чрезвычайные ситуации",
    Title: "Оказание помощи нуждающимся в условиях острого дефицита финансовых средств",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение согласованности, своевременности и эффективности и расширение масштаба гуманитарного реагирования; существенное снижение риска бедствий",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=14"
  },
  {
    ID: 643,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Управление по координации гуманитарных вопросов",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Координация гуманитарной деятельности и мер реагирования на чрезвычайные ситуации",
    Title: "Расширение участия местных и национальных субъектов в механизмах координации гуманитарной деятельности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение согласованности, своевременности и эффективности и расширение масштаба гуманитарного реагирования; существенное снижение риска бедствий",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=15"
  },
  {
    ID: 644,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Управление по координации гуманитарных вопросов",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Координация гуманитарной деятельности и мер реагирования на чрезвычайные ситуации",
    Title: "Расширение применения упреждающих подходов и систем раннего предупреждения и ранних действий",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение согласованности, своевременности и эффективности и расширение масштаба гуманитарного реагирования; существенное снижение риска бедствий",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=16"
  },
  {
    ID: 645,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Управление по координации гуманитарных вопросов",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Координация гуманитарной деятельности и мер реагирования на чрезвычайные ситуации",
    Title: "Укрепление общесистемной дипломатии в целях отстаивания гуманитарных принципов, обеспечения доступа и защиты гражданского населения",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение согласованности, своевременности и эффективности и расширение масштаба гуманитарного реагирования; существенное снижение риска бедствий",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=17"
  },
  {
    ID: 646,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Управление по координации гуманитарных вопросов",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Услуги по оказанию поддержки в чрезвычайных ситуациях",
    Title: "Укрепление международных мер реагирования на чрезвычайные ситуации посредством обновления методических рекомендаций",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Повышение согласованности, своевременности и эффективности и расширение масштаба гуманитарного реагирования; существенное снижение риска бедствий",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=20"
  },
  {
    ID: 647,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Управление по координации гуманитарных вопросов",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Услуги по оказанию поддержки в чрезвычайных ситуациях",
    Title: "Расширение партнерства с частным сектором в осуществлении совместной гуманитарной деятельности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Повышение согласованности, своевременности и эффективности и расширение масштаба гуманитарного реагирования; существенное снижение риска бедствий",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "SD,QQ,SB",
    Image: "27OCHA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=21"
  },
  {
    ID: 648,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Управление по координации гуманитарных вопросов",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Услуги по оказанию поддержки в чрезвычайных ситуациях",
    Title: "Получение пострадавшими от кризиса лицами экстренной гуманитарной помощи сразу после катастрофы",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение согласованности, своевременности и эффективности и расширение масштаба гуманитарного реагирования; существенное снижение риска бедствий",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=22"
  },
  {
    ID: 649,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Управление по координации гуманитарных вопросов",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Услуги по оказанию поддержки в чрезвычайных ситуациях",
    Title: "Повышение глобальной готовности поисково-спасательных групп в городских районах",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение согласованности, своевременности и эффективности и расширение масштаба гуманитарного реагирования; существенное снижение риска бедствий",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=23"
  },
  {
    ID: 650,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Управление по координации гуманитарных вопросов",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Информационно-пропагандистская работа в связи с чрезвычайными ситуациями гуманитарного характера",
    Title: "Получение людьми, пострадавшими от кризиса, основанной на данных помощи от субъектов, оказывающих гуманитарную помощь",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение согласованности, своевременности и эффективности и расширение масштаба гуманитарного реагирования; существенное снижение риска бедствий",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=26"
  },
  {
    ID: 651,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Управление по координации гуманитарных вопросов",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Информационно-пропагандистская работа в связи с чрезвычайными ситуациями гуманитарного характера",
    Title: "Надежные сети и услуги связи для сотрудников служб гуманитарного реагирования",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение согласованности, своевременности и эффективности и расширение масштаба гуманитарного реагирования; существенное снижение риска бедствий",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=27"
  },
  {
    ID: 652,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Управление по координации гуманитарных вопросов",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Информационно-пропагандистская работа в связи с чрезвычайными ситуациями гуманитарного характера",
    Title: "Расширенный доступ к важнейшим данным и информации",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение согласованности, своевременности и эффективности и расширение масштаба гуманитарного реагирования; существенное снижение риска бедствий",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=28"
  },
  {
    ID: 653,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Управление по координации гуманитарных вопросов",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Информационно-пропагандистская работа в связи с чрезвычайными ситуациями гуманитарного характера",
    Title: "Повышение информированности общественности о гуманитарных кризисах",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=28"
  },
  {
    ID: 654,
    BudgetSection: "27",
    Entity: "UNDRR",
    EntityFullName: "Управление Организации Объединённых Наций по снижению риска бедствий",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Управление Организации Объединенных Наций по снижению риска бедствий",
    Title: "Государства-члены и заинтересованные стороны проводят обзор прогресса, достигнутого в реализации Сендайской рамочной программы, и выносят рекомендации в отношении повышения эффективности мер по снижению риска бедствий",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Инклюзивное и устойчивое восстановление после бедствий; повышение устойчивости к будущим бедствиям",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=51"
  },
  {
    ID: 655,
    BudgetSection: "27",
    Entity: "UNDRR",
    EntityFullName: "Управление Организации Объединённых Наций по снижению риска бедствий",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Управление Организации Объединенных Наций по снижению риска бедствий",
    Title: "Укрепление инклюзивных систем заблаговременного предупреждения о многих опасных явлениях, позволяющих оказывать помощь наиболее уязвимым группам населения",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Инклюзивное и устойчивое восстановление после бедствий; повышение устойчивости к будущим бедствиям",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=52"
  },
  {
    ID: 656,
    BudgetSection: "27",
    Entity: "UNDRR",
    EntityFullName: "Управление Организации Объединённых Наций по снижению риска бедствий",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Управление Организации Объединенных Наций по снижению риска бедствий",
    Title: "Наличие национальных стратегий для финансирования мер по снижению риска бедствий",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Инклюзивное и устойчивое восстановление после бедствий; повышение устойчивости к будущим бедствиям",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=53"
  },
  {
    ID: 657,
    BudgetSection: "27",
    Entity: "UNDRR",
    EntityFullName: "Управление Организации Объединённых Наций по снижению риска бедствий",
    Programme: "Гуманитарная помощь",
    Subprogramme: "Управление Организации Объединенных Наций по снижению риска бедствий",
    Title: "Правительства оценивают, укрепляют и закрепляют на институциональном уровне свою готовность к устойчивому восстановлению с целью восстановления по принципу «лучше, чем было»",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Эффективная координация усилий по оказанию гуманитарной помощи и поддержке беженцев",
    Beneficiary: "Государственное управление ",
    BeneficiaryTwo: " ",
    SpecificResult: "Инклюзивное и устойчивое восстановление после бедствий; повышение устойчивости к будущим бедствиям",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ru#page=54"
  },
  {
    ID: 658,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Департамент глобальных коммуникаций",
    Programme: "Глобальные коммуникации",
    Subprogramme: "Услуги по проведению кампаний и обслуживание страновых операций",
    Title: "Усиление взаимодействия с общественностью по приоритетным вопросам, которыми занимается Организация Объединенных Наций",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ru#page=7"
  },
  {
    ID: 659,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Департамент глобальных коммуникаций",
    Programme: "Глобальные коммуникации",
    Subprogramme: "Услуги по проведению кампаний и обслуживание страновых операций",
    Title: "Активизация деятельности по реализации Повестки дня в области устойчивого развития на период до 2030 года",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ru#page=8"
  },
  {
    ID: 660,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Департамент глобальных коммуникаций",
    Programme: "Глобальные коммуникации",
    Subprogramme: "Услуги по проведению кампаний и обслуживание страновых операций",
    Title: "Углубление понимания общественностью важнейших вопросов, связанных с целями в области устойчивого развития, и укрепление взаимодействия с ней по этим вопросам",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Расширение сотрудничества, обмена информацией и передовым опытом в целях достижения прогресса в реализации ЦУР",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ru#page=9"
  },
  {
    ID: 661,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Департамент глобальных коммуникаций",
    Programme: "Глобальные коммуникации",
    Subprogramme: "Услуги по проведению кампаний и обслуживание страновых операций",
    Title: "Расширение доступа к информационно-пропагандистским материалам и сообщениям по приоритетным вопросам",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Улучшение сотрудничества и партнерских отношений, повышение согласованности и синергии и уменьшение дублирования благодаря последовательной коммуникации",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ru#page=9"
  },
  {
    ID: 662,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Департамент глобальных коммуникаций",
    Programme: "Глобальные коммуникации",
    Subprogramme: "Новостное обслуживание",
    Title: "Расширение охвата общественности новостями Организации Объединенных Наций",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ru#page=12"
  },
  {
    ID: 663,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Департамент глобальных коммуникаций",
    Programme: "Глобальные коммуникации",
    Subprogramme: "Новостное обслуживание",
    Title: "Расширение вовлечения аудитории с помощью инструментов и форматов живых блогов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ru#page=13"
  },
  {
    ID: 664,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Департамент глобальных коммуникаций",
    Programme: "Глобальные коммуникации",
    Subprogramme: "Новостное обслуживание",
    Title: "Рост вовлеченности аудитории в поддержку международных памятных дат и периодов Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ru#page=14"
  },
  {
    ID: 665,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Департамент глобальных коммуникаций",
    Programme: "Глобальные коммуникации",
    Subprogramme: "Новостное обслуживание",
    Title: "Расширение и своевременность глобальной посещаемости вебсайта «Новости Организации Объединенных Наций»",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ru#page=14"
  },
  {
    ID: 666,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Департамент глобальных коммуникаций",
    Programme: "Глобальные коммуникации",
    Subprogramme: "Информационное обслуживание и обмен знаниями",
    Title: "Усиление глобальной поддержки работы Организации Объединенных Наций и действий в ее интересах",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Улучшение сотрудничества и партнерских отношений, повышение согласованности и синергии и уменьшение дублирования благодаря последовательной коммуникации",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ru#page=17"
  },
  {
    ID: 667,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Департамент глобальных коммуникаций",
    Programme: "Глобальные коммуникации",
    Subprogramme: "Информационное обслуживание и обмен знаниями",
    Title: "Получение молодыми журналистами доступа к информации о работе Организации Объединенных Наций и представления об этой работе",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Улучшение сотрудничества и партнерских отношений, повышение согласованности и синергии и уменьшение дублирования благодаря последовательной коммуникации",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ru#page=18"
  },
  {
    ID: 668,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Департамент глобальных коммуникаций",
    Programme: "Глобальные коммуникации",
    Subprogramme: "Информационное обслуживание и обмен знаниями",
    Title: "Содействие достижению целей в области устойчивого развития с помощью высших учебных заведений",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Устойчивое развитие ",
    Beneficiary: "Молодежь",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Улучшение сотрудничества и партнерских отношений, повышение согласованности и синергии и уменьшение дублирования благодаря последовательной коммуникации",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ru#page=18"
  },
  {
    ID: 669,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Департамент глобальных коммуникаций",
    Programme: "Глобальные коммуникации",
    Subprogramme: "Информационное обслуживание и обмен знаниями",
    Title: "Увеличение числа посетителей Центральных учреждений Организации Объединенных Наций благодаря проведению тематических экскурсий",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Международное сообщество ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ru#page=19"
  },
  {
    ID: 670,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Система общеорганизационного планирования ресурсов, обслуживание Пятого комитета Генеральной Ассамблеи и Комитета по программе и координации и консультационное обслуживание по вопросам управления: Система общеорганизационного планирования ресурсов",
    Title: "Обеспечение цифровых преобразований с использованием системы «Умоджа» в целях повышения эффективности и оптимизации процесса принятия решений",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=10"
  },
  {
    ID: 671,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Система общеорганизационного планирования ресурсов, обслуживание Пятого комитета Генеральной Ассамблеи и Комитета по программе и координации и консультационное обслуживание по вопросам управления: Система общеорганизационного планирования ресурсов",
    Title: "Основанные на данных практические выводы, полученные с помощью функций нового поколения в аналитическом компоненте системы «Умоджа»",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=10"
  },
  {
    ID: 672,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Система общеорганизационного планирования ресурсов, обслуживание Пятого комитета Генеральной Ассамблеи и Комитета по программе и координации и консультационное обслуживание по вопросам управления: Система общеорганизационного планирования ресурсов",
    Title: "Содействие принятию решений благодаря совершенствованию порталов, предназначенных для государств-членов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности многосторонних заседаний и обсуждений",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=11"
  },
  {
    ID: 673,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Система общеорганизационного планирования ресурсов, обслуживание Пятого комитета Генеральной Ассамблеи и Комитета по программе и координации и консультационное обслуживание по вопросам управления: Система общеорганизационного планирования ресурсов",
    Title: "Переход на систему общеорганизационного планирования ресурсов нового поколения (NextGen ERP)",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=12"
  },
  {
    ID: 674,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Система общеорганизационного планирования ресурсов, обслуживание Пятого комитета Генеральной Ассамблеи и Комитета по программе и координации и консультационное обслуживание по вопросам управления: Обслуживание Пятого комитета Генеральной Ассамблеи и Комитета по программе и координации",
    Title: "Содействие работе Пятого комитета путем предоставления более полной информации и эффективной отчетности",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Повышение эффективности многосторонних заседаний и обсуждений",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=14"
  },
  {
    ID: 675,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Система общеорганизационного планирования ресурсов, обслуживание Пятого комитета Генеральной Ассамблеи и Комитета по программе и координации и консультационное обслуживание по вопросам управления: Обслуживание Пятого комитета Генеральной Ассамблеи и Комитета по программе и координации",
    Title: "Улучшение доступа к информации, включая предсессионную информацию, для членов Пятого комитета и Комитета по программе и координации",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=14"
  },
  {
    ID: 676,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Система общеорганизационного планирования ресурсов, обслуживание Пятого комитета Генеральной Ассамблеи и Комитета по программе и координации и консультационное обслуживание по вопросам управления: Обслуживание Пятого комитета Генеральной Ассамблеи и Комитета по программе и координации",
    Title: "Упрощение и упорядочение процессов и повышение качества услуг для участников заседаний",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Повышение эффективности многосторонних заседаний и обсуждений",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=15"
  },
  {
    ID: 677,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Система общеорганизационного планирования ресурсов, обслуживание Пятого комитета Генеральной Ассамблеи и Комитета по программе и координации и консультационное обслуживание по вопросам управления: Обслуживание Пятого комитета Генеральной Ассамблеи и Комитета по программе и координации",
    Title: "Более эффективная поддержка процессов, связанных с выборами и назначениями",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=16"
  },
  {
    ID: 678,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Система общеорганизационного планирования ресурсов, обслуживание Пятого комитета Генеральной Ассамблеи и Комитета по программе и координации и консультационное обслуживание по вопросам управления: Консультационное обслуживание по вопросам управления",
    Title: "Своевременное реагирование на просьбы о проведении управленческой оценки",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=19"
  },
  {
    ID: 679,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Система общеорганизационного планирования ресурсов, обслуживание Пятого комитета Генеральной Ассамблеи и Комитета по программе и координации и консультационное обслуживание по вопросам управления: Консультационное обслуживание по вопросам управления",
    Title: "Система обеспечения организационной жизнеспособности институционализирована в организациях системы Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=19"
  },
  {
    ID: 680,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Система общеорганизационного планирования ресурсов, обслуживание Пятого комитета Генеральной Ассамблеи и Комитета по программе и координации и консультационное обслуживание по вопросам управления: Консультационное обслуживание по вопросам управления",
    Title: "Принятие уполномоченными должностными лицами рекомендаций Комитета Центральных учреждений по контрактам",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=20"
  },
  {
    ID: 681,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Система общеорганизационного планирования ресурсов, обслуживание Пятого комитета Генеральной Ассамблеи и Комитета по программе и координации и консультационное обслуживание по вопросам управления: Консультационное обслуживание по вопросам управления",
    Title: "Улучшение понимания сотрудниками формальной системы отправления правосудия Организации",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление механизмов внутреннего правосудия и посредничества в целях обеспечения более этичного поведения, более гармоничных отношений и более широкого доступа к правосудию в рамках ООН",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=20"
  },
  {
    ID: 682,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Планирование по программам, финансы и бюджет: Финансы",
    Title: "Расширение доступа к сводной информации о возмещении расходов для принятия решений подразделениями Секретариата",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Упрощение, транспарентность и облегчение доступа для более эффективного осуществления программ",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=23"
  },
  {
    ID: 683,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Планирование по программам, финансы и бюджет: Финансы",
    Title: "Повышение качества обслуживания с помощью глобальных платежных систем Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=24"
  },
  {
    ID: 684,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Планирование по программам, финансы и бюджет: Финансы",
    Title: "Внедрение утвержденных обновлений Международных стандартов учета в государственном секторе и анализ влияния предстоящих изменений",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=25"
  },
  {
    ID: 685,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Планирование по программам, финансы и бюджет: Финансы",
    Title: "Укрепление нормативно-правовой основы финансового управления путем внедрения новых и обновления существующих инструментов политики",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Создание благоприятной нормативно-правовой базы; снижение риска наступления юридической ответственности",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=26"
  },
  {
    ID: 686,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Планирование по программам, финансы и бюджет: Финансы полевых операций",
    Title: "Усиление надзора и подотчетности в области управления имуществом",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=29"
  },
  {
    ID: 687,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Планирование по программам, финансы и бюджет: Финансы полевых операций",
    Title: "Координация действий и обмен передовым опытом в целях обеспечения синергии и стандартизации в области эксплуатации зданий и помещений",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности многосторонних заседаний и обсуждений",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=30"
  },
  {
    ID: 688,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Планирование по программам, финансы и бюджет: Финансы полевых операций",
    Title: "Осуществление качественных и эффективных с точки зрения затрат проектов капитального строительства Организации",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=31"
  },
  {
    ID: 689,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Планирование по программам, финансы и бюджет: Финансы полевых операций",
    Title: "Повышение транспарентности и эффективности при определении бюджетных потребностей специальных политических миссий",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Упрощение, транспарентность и облегчение доступа для более эффективного осуществления программ",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=32"
  },
  {
    ID: 690,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Планирование по программам, финансы и бюджет: Планирование по программам и бюджетирование",
    Title: "Успешное завершение в сжатые сроки обсуждений по бюджетным вопросам в связи с инициативой «ООН-80»",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Повышение эффективности многосторонних заседаний и обсуждений",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=35"
  },
  {
    ID: 691,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Планирование по программам, финансы и бюджет: Планирование по программам и бюджетирование",
    Title: "Повышение транспарентности в отношении процесса определения последствий для бюджета по программам для государств-членов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=35"
  },
  {
    ID: 692,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Планирование по программам, финансы и бюджет: Планирование по программам и бюджетирование",
    Title: "Совершенствование содержания внедренного в экспериментальном режиме модуля для предоставления бюджетной информации в целях содействия принятию решений государствами-членами",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=36"
  },
  {
    ID: 693,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Планирование по программам, финансы и бюджет: Планирование по программам и бюджетирование",
    Title: "Повышение эффективности, находящее отражение в бюджетных потребностях всех подразделений Секретариата",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=37"
  },
  {
    ID: 694,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Людские ресурсы: Глобальная стратегия и политика",
    Title: "Адаптация сотрудников, менеджеров и старшего руководства к организационным изменениям",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=41"
  },
  {
    ID: 695,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Людские ресурсы: Глобальная стратегия и политика",
    Title: "Уменьшение числа непредставленных и недопредставленных государств-членов в системе желательных квот",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Улучшение ситуации с набором персонала и укомплектованием штатов структур ООН, включая сокращение неравенства с точки зрения гендерного и географического представительства",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=42"
  },
  {
    ID: 696,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Людские ресурсы: Глобальная стратегия и политика",
    Title: "Создание справедливой, эффективной, действенной и гибкой системы отбора персонала",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Улучшение ситуации с набором персонала и укомплектованием штатов структур ООН, включая сокращение неравенства с точки зрения гендерного и географического представительства",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=42"
  },
  {
    ID: 697,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Людские ресурсы: Глобальная стратегия и политика",
    Title: "Комплексный подход к работе с молодыми квалифицированными специалистами, способствующий укреплению потенциала Организации в областях привлечения, профессионального развития и удержания специалистов, находящихся в начале карьерного пути",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: "Молодежь",
    SpecificResult: "Улучшение ситуации с набором персонала и укомплектованием штатов структур ООН, включая сокращение неравенства с точки зрения гендерного и географического представительства",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=43"
  },
  {
    ID: 698,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Людские ресурсы: Административное право",
    Title: "Расширение использования инструментов проверки в работе по вопросам поведения и дисциплины",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Принятие более эффективных мер реагирования на случаи сексуальной эксплуатации и сексуальных злоупотреблений, сексуальных домогательств, мошенничества и коррупции; более широкое применение подхода, ориентированного на интересы жертв",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=46"
  },
  {
    ID: 699,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Людские ресурсы: Административное право",
    Title: "Корректировка нормативной базы и методов управления Секретариата исходя из решений Трибунала по спорам Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Создание благоприятной нормативно-правовой базы; снижение риска наступления юридической ответственности",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=47"
  },
  {
    ID: 700,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Людские ресурсы: Административное право",
    Title: "Расширение возможностей старшего руководства в плане принятия решений по делам, связанным с вопросами поведения и дисциплины",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление механизмов внутреннего правосудия и посредничества в целях обеспечения более этичного поведения, более гармоничных отношений и более широкого доступа к правосудию в рамках ООН",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=47"
  },
  {
    ID: 701,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Людские ресурсы: Административное право",
    Title: "Усиление подотчетности путем повышения эффективности и последовательности действий при рассмотрении и разрешении дисциплинарных дел",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление механизмов внутреннего правосудия и посредничества в целях обеспечения более этичного поведения, более гармоничных отношений и более широкого доступа к правосудию в рамках ООН",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=48"
  },
  {
    ID: 702,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Реорганизация рабочих процессов и обеспечение подотчетности",
    Title: "Решение проблем с использованием генеративного искусственного интеллекта в интересах повышения эффективности",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Технические достижения, позволяющие повысить качество, наличие, доступность и безопасность информации",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=51"
  },
  {
    ID: 703,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Реорганизация рабочих процессов и обеспечение подотчетности",
    Title: "Расширение использования внутренней оценки менее крупными подразделениями для обоснования принимаемых решений",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Технические достижения, позволяющие повысить качество, наличие, доступность и безопасность информации",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=52"
  },
  {
    ID: 704,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Реорганизация рабочих процессов и обеспечение подотчетности",
    Title: "Повышение эффективности принятия решений на основе данных путем постоянного совершенствования управленческой информационной панели",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Технические достижения, позволяющие повысить качество, наличие, доступность и безопасность информации",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=52"
  },
  {
    ID: 705,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Реорганизация рабочих процессов и обеспечение подотчетности",
    Title: "Своевременное выполнение рекомендаций надзорных органов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=53"
  },
  {
    ID: 706,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Борьба с расизмом на рабочем месте",
    Title: "Противодействие межличностным, институциональным и системным формам расизма в Организации",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление механизмов внутреннего правосудия и посредничества в целях обеспечения более этичного поведения, более гармоничных отношений и более широкого доступа к правосудию в рамках ООН",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=56"
  },
  {
    ID: 707,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Борьба с расизмом на рабочем месте",
    Title: "Укрепление систем подотчетности в связи с предполагаемыми случаями расизма на рабочем месте",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление механизмов внутреннего правосудия и посредничества в целях обеспечения более этичного поведения, более гармоничных отношений и более широкого доступа к правосудию в рамках ООН",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=57"
  },
  {
    ID: 708,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Борьба с расизмом на рабочем месте",
    Title: "Повышение институциональной транспарентности в отношении многообразия",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление механизмов внутреннего правосудия и посредничества в целях обеспечения более этичного поведения, более гармоничных отношений и более широкого доступа к правосудию в рамках ООН",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=58"
  },
  {
    ID: 709,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Департамент по стратегии, политике и контролю в области управления",
    Programme: "Департамент по стратегии, политике и контролю в области управления",
    Subprogramme: "Борьба с расизмом на рабочем месте",
    Title: "Расширение знаний о борьбе с расизмом и расовой дискриминацией на рабочем месте",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ru#page=59"
  },
  {
    ID: 710,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Вспомогательные операции: Кадровая поддержка",
    Title: "Структуры Секретариата получают всестороннюю оперативную поддержку в области людских ресурсов, а также рекомендации по реструктуризации и сокращению штатов",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Улучшение ситуации с набором персонала и укомплектованием штатов структур ООН, включая сокращение неравенства с точки зрения гендерного и географического представительства",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=8"
  },
  {
    ID: 711,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Вспомогательные операции: Кадровая поддержка",
    Title: "Повышение эффективности организации служебной деятельности в рамках всего Секретариата",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=9"
  },
  {
    ID: 712,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Вспомогательные операции: Кадровая поддержка",
    Title: "Более эффективное составление и ведение реестров для глобального Секретариата",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Улучшение ситуации с набором персонала и укомплектованием штатов структур ООН, включая сокращение неравенства с точки зрения гендерного и географического представительства",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=9"
  },
  {
    ID: 713,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Вспомогательные операции: Кадровая поддержка",
    Title: "Расширение набора персонала, предоставляемого на безвозмездной основе",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Улучшение ситуации с набором персонала и укомплектованием штатов структур ООН, включая сокращение неравенства с точки зрения гендерного и географического представительства",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=10"
  },
  {
    ID: 714,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Вспомогательные операции: Укрепление потенциала и оперативная подготовка",
    Title: "Штатные и внештатные сотрудники Организации Объединенных Наций, государства-члены, соискатели и руководители, отвечающие за наем сотрудников, имеют доступ к централизованной платформе для обучения языкам и навыкам в области коммуникаций",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=13"
  },
  {
    ID: 715,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Вспомогательные операции: Укрепление потенциала и оперативная подготовка",
    Title: "Инициатива UNTold: коллективное обучение и новаторская деятельность во всей системе Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "",
    Image: "29BDOS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=14"
  },
  {
    ID: 716,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Вспомогательные операции: Укрепление потенциала и оперативная подготовка",
    Title: "Укрепление организационного потенциала в том, что касается инноваций, анализа данных, цифровой трансформации, стратегического прогнозирования и поведенческих наук",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=14"
  },
  {
    ID: 717,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Вспомогательные операции: Укрепление потенциала и оперативная подготовка",
    Title: "Улучшение ситуации в плане наличия и доступности руководящих указаний по административным вопросам и по вопросам оперативной деятельности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Упрощение, транспарентность и облегчение доступа для более эффективного осуществления программ",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=15"
  },
  {
    ID: 718,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Вспомогательные операции: Управление медицинским обслуживанием, техника безопасности и гигиена труда",
    Title: "Повышение готовности к предотвращению и снижению связанных с инфекционными заболеваниями рисков, которые могут затронуть штатных и внештатных сотрудников Организации Объединенных Наций",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=17"
  },
  {
    ID: 719,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Вспомогательные операции: Управление медицинским обслуживанием, техника безопасности и гигиена труда",
    Title: "Использование сотрудниками Организации Объединенных Наций профилактических медицинских услуг для улучшения своего состояния здоровья и благополучия",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=18"
  },
  {
    ID: 720,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Вспомогательные операции: Управление медицинским обслуживанием, техника безопасности и гигиена труда",
    Title: "Повышение качества медицинского обслуживания",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Технические достижения, позволяющие повысить качество, наличие, доступность и безопасность информации",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "",
    Image: "29BDOS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=19"
  },
  {
    ID: 721,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Вспомогательные операции: Управление медицинским обслуживанием, техника безопасности и гигиена труда",
    Title: "Расширение доступа к поддержке в области психического здоровья в цифровом формате для миротворческого персонала",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности, охраны и безопасности миссий по поддержанию мира, включая обеспечение плавного перехода в соответствии с резолюциями Совета Безопасности",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=20"
  },
  {
    ID: 722,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Управление цепью снабжения: Управление цепью комплексного снабжения",
    Title: "Безопасная и своевременная репатриация негражданского персонала в соответствии с планами действий миссий на случай чрезвычайных ситуаций",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности, охраны и безопасности миссий по поддержанию мира, включая обеспечение плавного перехода в соответствии с резолюциями Совета Безопасности",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=22"
  },
  {
    ID: 723,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Управление цепью снабжения: Управление цепью комплексного снабжения",
    Title: "Диверсификация участников процесса закупок в Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Женщины и девочки",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "",
    Image: "29BDOS14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=23"
  },
  {
    ID: 724,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Управление цепью снабжения: Управление цепью комплексного снабжения",
    Title: "Повышение доступности дежурных логистических механизмов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Упрощение, транспарентность и облегчение доступа для более эффективного осуществления программ",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=24"
  },
  {
    ID: 725,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Управление цепью снабжения: Управление цепью комплексного снабжения",
    Title: "Комплексные механизмы снабжения в гуманитарных ситуациях и сложных условиях",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Упрощение, транспарентность и облегчение доступа для более эффективного осуществления программ",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=24"
  },
  {
    ID: 726,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Управление цепью снабжения: Управление цепью комплексного снабжения",
    Title: "Миссии по поддержанию мира реализуют планы действий на случай чрезвычайных ситуаций, что позволило сократить расходы",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности, охраны и безопасности миссий по поддержанию мира, включая обеспечение плавного перехода в соответствии с резолюциями Совета Безопасности",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=28"
  },
  {
    ID: 727,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Управление цепью снабжения: Управление цепью комплексного снабжения",
    Title: "Безопасный единый портал, позволяющий государствам-членам подавать требования и получать доступ к информации о своем участии в операциях в пользу мира",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Технические достижения, позволяющие повысить качество, наличие, доступность и безопасность информации",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=28"
  },
  {
    ID: 728,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Управление цепью снабжения: Управление цепью комплексного снабжения",
    Title: "Обновление стратегий, процедур, нормативов и определений в отношении негражданского персонала и принадлежащего контингентам имущества",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Упрощение, транспарентность и облегчение доступа для более эффективного осуществления программ",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=29"
  },
  {
    ID: 729,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Управление цепью снабжения: Управление цепью комплексного снабжения",
    Title: "Укрепление системы управления запасами боеприпасов, принадлежащих контингентам",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=30"
  },
  {
    ID: 730,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Специальные мероприятия",
    Title: "Создано Отделение Организации Объединенных Наций по поддержке в Гаити",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "HT",
    Image: "29BDOS21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=34"
  },
  {
    ID: 731,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Специальные мероприятия",
    Title: "Повышение эффективности управления функциями оперативной поддержки на протяжении всего жизненного цикла в структурах, находящихся в процессе преобразования",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности, охраны и безопасности миссий по поддержанию мира, включая обеспечение плавного перехода в соответствии с резолюциями Совета Безопасности",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=35"
  },
  {
    ID: 732,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Специальные мероприятия",
    Title: "Эффективное и более качественное предоставление услуг через расширение вспомогательных и консультационных услуг",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Упрощение, транспарентность и облегчение доступа для более эффективного осуществления программ",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CO,PK,ZW",
    Image: "29BDOS23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=35"
  },
  {
    ID: 733,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Специальные мероприятия",
    Title: "Укрепление механизмов партнерства в сфере оказания поддержки",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Упрощение, транспарентность и облегчение доступа для более эффективного осуществления программ",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=36"
  },
  {
    ID: 734,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Административное обслуживание, НьюЙорк",
    Title: "Автоматизация возмещения расходов на аренду через систему расчета заработной платы",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=39"
  },
  {
    ID: 735,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Административное обслуживание, НьюЙорк",
    Title: "Сохранение исторических данных в цифровом виде",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=40"
  },
  {
    ID: 736,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Административное обслуживание, НьюЙорк",
    Title: "Приведение служебных помещений в соответствие с потребностями Организации",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=40"
  },
  {
    ID: 737,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Департамент оперативной поддержки",
    Programme: "Департамент оперативной поддержки",
    Subprogramme: "Административное обслуживание, НьюЙорк",
    Title: "Повышение доступности помещений и объектов в Центральных учреждениях Организации Объединенных Наций для инвалидов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    BeneficiaryTwo: "Создание благоприятных условий ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ru#page=41"
  },
  {
    ID: 738,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Управление информационно-коммуникационных технологий",
    Programme: "Управление информационно-коммуникационных технологий",
    Subprogramme: "Стратегия и технологические инновации",
    Title: "Повышение осведомленности о вопросах информационной и технологической безопасности в целях обеспечения защиты Секретариата",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ru#page=8"
  },
  {
    ID: 739,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Управление информационно-коммуникационных технологий",
    Programme: "Управление информационно-коммуникационных технологий",
    Subprogramme: "Стратегия и технологические инновации",
    Title: "Повышение эффективности выполнения мандатов путем использования генеративного искусственного интеллекта",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ru#page=9"
  },
  {
    ID: 740,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Управление информационно-коммуникационных технологий",
    Programme: "Управление информационно-коммуникационных технологий",
    Subprogramme: "Стратегия и технологические инновации",
    Title: "Этичное и ответственное использование искусственного интеллекта",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Технические достижения, позволяющие повысить качество, наличие, доступность и безопасность информации",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ru#page=10"
  },
  {
    ID: 741,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Управление информационно-коммуникационных технологий",
    Programme: "Управление информационно-коммуникационных технологий",
    Subprogramme: "Стратегия и технологические инновации",
    Title: "Обеспечение структурам Секретариата возможности эффективно применять стратегию в области информационно-коммуникационных технологий для более качественного выполнения мандата",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ru#page=11"
  },
  {
    ID: 742,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Управление информационно-коммуникационных технологий",
    Programme: "Управление информационно-коммуникационных технологий",
    Subprogramme: "Поддержка операций",
    Title: "Более надежное и стабильное подключение для делегатов и сотрудников благодаря улучшенной сети Wi-Fi в Центральных учреждениях",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ru#page=14"
  },
  {
    ID: 743,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Управление информационно-коммуникационных технологий",
    Programme: "Управление информационно-коммуникационных технологий",
    Subprogramme: "Поддержка операций",
    Title: "Повышение эффективности управления технологиями, используемыми в поддержку проведения межправительственных совещаний",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ru#page=15"
  },
  {
    ID: 744,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Управление информационно-коммуникационных технологий",
    Programme: "Управление информационно-коммуникационных технологий",
    Subprogramme: "Поддержка операций",
    Title: "Снижение рисков благодаря облачной аутентификации для обеспечения безопасного доступа",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ru#page=16"
  },
  {
    ID: 745,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Управление информационно-коммуникационных технологий",
    Programme: "Управление информационно-коммуникационных технологий",
    Subprogramme: "Поддержка операций",
    Title: "Снижение раздробленности и повышение жизнестойкости, безопасности и стандартизации инфраструктуры центров обработки данных в сфере информационно-коммуникационных технологий",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ru#page=17"
  },
  {
    ID: 746,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Управление информационно-коммуникационных технологий",
    Programme: "Управление информационно-коммуникационных технологий",
    Subprogramme: "Общеорганизационные решения",
    Title: "Повышение доступности вебсайтов и приложений за счет миграции из основного технологического центра в НьюЙорке",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ru#page=20"
  },
  {
    ID: 747,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Управление информационно-коммуникационных технологий",
    Programme: "Управление информационно-коммуникационных технологий",
    Subprogramme: "Общеорганизационные решения",
    Title: "Своевременные кастомизированные информационно-технологические решения для выполнения мандатов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Использование научно-технических достижений и инноваций, включая искусственный интеллект, в целях устойчивого развития",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ru#page=20"
  },
  {
    ID: 748,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Управление информационно-коммуникационных технологий",
    Programme: "Управление информационно-коммуникационных технологий",
    Subprogramme: "Общеорганизационные решения",
    Title: "Интеграция искусственного интеллекта в информационно-технологические решения для оказания содействия в принятии решений",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ru#page=21"
  },
  {
    ID: 749,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Управление информационно-коммуникационных технологий",
    Programme: "Управление информационно-коммуникационных технологий",
    Subprogramme: "Общеорганизационные решения",
    Title: "Повышение стандартов, а также уровня безопасности, многоязычия и доступности вебсайтов Организации Объединенных Наций, посвященных общественной информации",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29COICT12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ru#page=22"
  },
  {
    ID: 750,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Отделение Организации Объединённых Наций в Найроби",
    Programme: "Административное обслуживание, Найроби",
    Subprogramme: "Планирование по программам, финансы и бюджет",
    Title: "Более оперативная обработка бухгалтерских журналов для клиентов",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ru#page=8"
  },
  {
    ID: 751,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Отделение Организации Объединённых Наций в Найроби",
    Programme: "Административное обслуживание, Найроби",
    Subprogramme: "Планирование по программам, финансы и бюджет",
    Title: "Более эффективный учет активов зданий, объектов и инфраструктуры Отделения Организации Объединенных Наций в Найроби",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Упрощение, транспарентность и облегчение доступа для более эффективного осуществления программ",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ru#page=9"
  },
  {
    ID: 752,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Отделение Организации Объединённых Наций в Найроби",
    Programme: "Административное обслуживание, Найроби",
    Subprogramme: "Планирование по программам, финансы и бюджет",
    Title: "Более оперативное урегулирование ситуаций с отклоненными и возвращенными платежами",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "KE",
    Image: "29DUNON3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ru#page=10"
  },
  {
    ID: 753,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Отделение Организации Объединённых Наций в Найроби",
    Programme: "Административное обслуживание, Найроби",
    Subprogramme: "Планирование по программам, финансы и бюджет",
    Title: "Более оперативное представление финансовой отчетности донорам",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Упрощение, транспарентность и облегчение доступа для более эффективного осуществления программ",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ru#page=10"
  },
  {
    ID: 754,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Отделение Организации Объединённых Наций в Найроби",
    Programme: "Административное обслуживание, Найроби",
    Subprogramme: "Управление людскими ресурсами",
    Title: "Штатные и внештатные сотрудники имеют доступ к расширенной поддержке в вопросах обеспечения благополучия и психического здоровья",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ru#page=13"
  },
  {
    ID: 755,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Отделение Организации Объединённых Наций в Найроби",
    Programme: "Административное обслуживание, Найроби",
    Subprogramme: "Управление людскими ресурсами",
    Title: "Штатные и внештатные сотрудники приобретают новые знания и навыки для повышения организационной эффективности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Улучшение ситуации с набором персонала и укомплектованием штатов структур ООН, включая сокращение неравенства с точки зрения гендерного и географического представительства",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ru#page=14"
  },
  {
    ID: 756,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Отделение Организации Объединённых Наций в Найроби",
    Programme: "Административное обслуживание, Найроби",
    Subprogramme: "Управление людскими ресурсами",
    Title: "Более оперативное предоставление услуг по оформлению пособий и льгот всем сотрудникам обслуживаемых структур",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ru#page=14"
  },
  {
    ID: 757,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Отделение Организации Объединённых Наций в Найроби",
    Programme: "Административное обслуживание, Найроби",
    Subprogramme: "Управление людскими ресурсами",
    Title: "Более оперативное проведение обслуживаемыми структурами предварительной проверки кандидатов при наборе персонала",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Улучшение ситуации с набором персонала и укомплектованием штатов структур ООН, включая сокращение неравенства с точки зрения гендерного и географического представительства",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ru#page=15"
  },
  {
    ID: 758,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Отделение Организации Объединённых Наций в Найроби",
    Programme: "Административное обслуживание, Найроби",
    Subprogramme: "Вспомогательное обслуживание",
    Title: "Структуры Организации Объединенных Наций в Кении имеют доступ к центру мероприятий, расположенному в комплексе Организации Объединенных Наций в Найроби",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ru#page=18"
  },
  {
    ID: 759,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Отделение Организации Объединённых Наций в Найроби",
    Programme: "Административное обслуживание, Найроби",
    Subprogramme: "Вспомогательное обслуживание",
    Title: "Создание новых помещений для участия в совещаниях и совместной работы делегатов и штатных и внештатных сотрудников",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ru#page=18"
  },
  {
    ID: 760,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Отделение Организации Объединённых Наций в Найроби",
    Programme: "Административное обслуживание, Найроби",
    Subprogramme: "Вспомогательное обслуживание",
    Title: "Бесперебойное и эффективное оказание принимающей страной услуг сотрудникам Организации Объединенных Наций в Кении и в регионе",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ru#page=19"
  },
  {
    ID: 761,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Отделение Организации Объединённых Наций в Найроби",
    Programme: "Административное обслуживание, Найроби",
    Subprogramme: "Вспомогательное обслуживание",
    Title: "Улучшение помещений для конференционного обслуживания, объединенных с помещениями Организации Объединенных Наций в Найроби",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ru#page=20"
  },
  {
    ID: 762,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Отделение Организации Объединённых Наций в Найроби",
    Programme: "Административное обслуживание, Найроби",
    Subprogramme: "Деятельность в области информационно-коммуникационных технологий",
    Title: "Модернизированная платформа информационно-коммуникационных технологий, соответствующая глобальным стандартам Организации Объединенных Наций",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Технические достижения, позволяющие повысить качество, наличие, доступность и безопасность информации",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ru#page=23"
  },
  {
    ID: 763,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Отделение Организации Объединённых Наций в Найроби",
    Programme: "Административное обслуживание, Найроби",
    Subprogramme: "Деятельность в области информационно-коммуникационных технологий",
    Title: "Повышение согласованности политики и практики в области информационно-коммуникационных технологий в Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Технические достижения, позволяющие повысить качество, наличие, доступность и безопасность информации",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ru#page=23"
  },
  {
    ID: 764,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Отделение Организации Объединённых Наций в Найроби",
    Programme: "Административное обслуживание, Найроби",
    Subprogramme: "Деятельность в области информационно-коммуникационных технологий",
    Title: "Обеспечение бесперебойной работы межправительственных органов благодаря модернизации и техническому обслуживанию средств конференционных технологий",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности многосторонних заседаний и обсуждений",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "KE",
    Image: "29DUNON15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ru#page=24"
  },
  {
    ID: 765,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Отделение Организации Объединённых Наций в Найроби",
    Programme: "Административное обслуживание, Найроби",
    Subprogramme: "Деятельность в области информационно-коммуникационных технологий",
    Title: "Повышение сетевой совместимости в рамках единой платформы поставщиков услуг",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ru#page=25"
  },
  {
    ID: 766,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Планирование по программам, финансы и бюджет",
    Title: "Повышение своевременности платежей поставщикам",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=8"
  },
  {
    ID: 767,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Планирование по программам, финансы и бюджет",
    Title: "Получение специализированной поддержки структурами, переезжающими во Дворец Наций или из него",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=8"
  },
  {
    ID: 768,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Планирование по программам, финансы и бюджет",
    Title: "Обеспечение надежности и эффективности процессов осуществления казначейских операций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=9"
  },
  {
    ID: 769,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Планирование по программам, финансы и бюджет",
    Title: "Клиенты получают более четкое представление о качестве обслуживания благодаря ежеквартальной отчетности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=10"
  },
  {
    ID: 770,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Управление людскими ресурсами",
    Title: "Поддержка персонала в переквалификации и досрочном прекращении службы",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Улучшение ситуации с набором персонала и укомплектованием штатов структур ООН, включая сокращение неравенства с точки зрения гендерного и географического представительства",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=12"
  },
  {
    ID: 771,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Управление людскими ресурсами",
    Title: "Сотрудники и внешние кандидаты лучше информированы о процессе набора персонала в Организации Объединенных Наций и принимают обоснованные решения, связанные с карьерой",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Улучшение ситуации с набором персонала и укомплектованием штатов структур ООН, включая сокращение неравенства с точки зрения гендерного и географического представительства",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CH",
    Image: "29EUNOG6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=13"
  },
  {
    ID: 772,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Управление людскими ресурсами",
    Title: "Повышение вовлеченности молодежи и расширение межпоколенческого диалога",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: "Молодежь",
    SpecificResult: "Улучшение ситуации с набором персонала и укомплектованием штатов структур ООН, включая сокращение неравенства с точки зрения гендерного и географического представительства",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CH",
    Image: "29EUNOG7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=13"
  },
  {
    ID: 773,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Управление людскими ресурсами",
    Title: "Улучшение поддержки персонала и повышение готовности организации к переходным процессам",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Улучшение ситуации с набором персонала и укомплектованием штатов структур ООН, включая сокращение неравенства с точки зрения гендерного и географического представительства",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=14"
  },
  {
    ID: 774,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Вспомогательное обслуживание",
    Title: "Оборудование зала Ассамблеи аудиовизуальными системами, позволяющими проводить крупномасштабные межправительственные встречи и мероприятия",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=16"
  },
  {
    ID: 775,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Вспомогательное обслуживание",
    Title: "Центр обслуживания мероприятий, этап II — получение государствами-членами и обслуживаемыми структурами более эффективной поддержки в области аудиовизуального сопровождения",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=18"
  },
  {
    ID: 776,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Вспомогательное обслуживание",
    Title: "Обслуживаемые структуры пользуются преимуществами модернизации зданий после проведения ремонтных работ по стратегическому плану сохранения наследия",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=18"
  },
  {
    ID: 777,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Вспомогательное обслуживание",
    Title: "Улучшение управления энергопотреблением во всем комплексе Дворца Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: "Климат и окружающая среда ",
    SpecificResult: "Рациональное использование ресурсов; прогресс в освоении возобновляемых источников энергии",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=19"
  },
  {
    ID: 778,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Деятельность в области информационно-коммуникационных технологий",
    Title: "Повышение эффективности использования клиентами стационарных телефонных линий",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=21"
  },
  {
    ID: 779,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Деятельность в области информационно-коммуникационных технологий",
    Title: "Центр обслуживания мероприятий, этап I — использование обслуживаемыми структурами единого контактного центра и онлайнового инструмента для организации культурных, параллельных и иных мероприятий",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности многосторонних заседаний и обсуждений",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=22"
  },
  {
    ID: 780,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Деятельность в области информационно-коммуникационных технологий",
    Title: "Повышение эффективности и безопасности с помощью интернета вещей для улучшения обслуживания",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=23"
  },
  {
    ID: 781,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Деятельность в области информационно-коммуникационных технологий",
    Title: "Более быстрые и надежные сетевые услуги для клиентов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=23"
  },
  {
    ID: 782,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Библиотечное обслуживание",
    Title: "Сохранение незаменимых и исторических библиотечных фондов для будущих поколений во время ремонта",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=26"
  },
  {
    ID: 783,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Библиотечное обслуживание",
    Title: "Повышение доступности инструментов, позволяющих обслуживаемым структурам получать доступ к информационным ресурсам и использовать эти ресурсы эффективным и ответственным образом",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CH",
    Image: "29EUNOG18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=26"
  },
  {
    ID: 784,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Библиотечное обслуживание",
    Title: "Расширение доступа к знаниям Организации Объединенных Наций и увеличение объема доступных знаний",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=27"
  },
  {
    ID: 785,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Отделение Организации Объединённых Наций в Женеве",
    Programme: "Административное обслуживание, Женева",
    Subprogramme: "Библиотечное обслуживание",
    Title: "Обеспечение долгосрочного и устойчивого доступа государств-членов и других заинтересованных сторон к архивам Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ru#page=28"
  },
  {
    ID: 786,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Отделение Организации Объединённых Наций в Вене",
    Programme: "Административное обслуживание, Вена",
    Subprogramme: "Планирование по программам, финансы и бюджет",
    Title: "Обеспечение дальнейшего выполнения программы на фоне непредвиденных сбоев в финансировании",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Упрощение, транспарентность и облегчение доступа для более эффективного осуществления программ",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ru#page=7"
  },
  {
    ID: 787,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Отделение Организации Объединённых Наций в Вене",
    Programme: "Административное обслуживание, Вена",
    Subprogramme: "Планирование по программам, финансы и бюджет",
    Title: "Улучшение финансового учета и отчетности благодаря внедрению стандарта 47 МСУГС «Поступления»",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ru#page=8"
  },
  {
    ID: 788,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Отделение Организации Объединённых Наций в Вене",
    Programme: "Административное обслуживание, Вена",
    Subprogramme: "Планирование по программам, финансы и бюджет",
    Title: "Сокращение числа нерешенных финансовых вопросов в отделениях на местах",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ru#page=9"
  },
  {
    ID: 789,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Отделение Организации Объединённых Наций в Вене",
    Programme: "Административное обслуживание, Вена",
    Subprogramme: "Планирование по программам, финансы и бюджет",
    Title: "Повышение финансовой прозрачности и усиление управленческого надзора",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ru#page=9"
  },
  {
    ID: 790,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Отделение Организации Объединённых Наций в Вене",
    Programme: "Административное обслуживание, Вена",
    Subprogramme: "Управление людскими ресурсами",
    Title: "Совершенствование механизма заключения контрактов с персоналом, работающим на местах в рамках проектов",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Улучшение ситуации с набором персонала и укомплектованием штатов структур ООН, включая сокращение неравенства с точки зрения гендерного и географического представительства",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ru#page=12"
  },
  {
    ID: 791,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Отделение Организации Объединённых Наций в Вене",
    Programme: "Административное обслуживание, Вена",
    Subprogramme: "Управление людскими ресурсами",
    Title: "Прогресс в обеспечении инклюзии инвалидов в составе рабочей силы",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Улучшение ситуации с набором персонала и укомплектованием штатов структур ООН, включая сокращение неравенства с точки зрения гендерного и географического представительства",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AT",
    Image: "29FUNOV6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ru#page=12"
  },
  {
    ID: 792,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Отделение Организации Объединённых Наций в Вене",
    Programme: "Административное обслуживание, Вена",
    Subprogramme: "Управление людскими ресурсами",
    Title: "Обслуживаемые структуры информированы и осведомлены обо всех соответствующих стратегиях и изменениях в области людских ресурсов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Более широкое распространение информации и расширение доступа к ней",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ru#page=13"
  },
  {
    ID: 793,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Отделение Организации Объединённых Наций в Вене",
    Programme: "Административное обслуживание, Вена",
    Subprogramme: "Управление людскими ресурсами",
    Title: "Повышение осведомленности о Кодексе поведения по предотвращению притеснений, включая сексуальные домогательства, во время мероприятий, проводимых в системе Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление механизмов внутреннего правосудия и посредничества в целях обеспечения более этичного поведения, более гармоничных отношений и более широкого доступа к правосудию в рамках ООН",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ru#page=14"
  },
  {
    ID: 794,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Отделение Организации Объединённых Наций в Вене",
    Programme: "Административное обслуживание, Вена",
    Subprogramme: "Вспомогательное обслуживание",
    Title: "Повышение эффективности управления имуществом",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ru#page=17"
  },
  {
    ID: 795,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Отделение Организации Объединённых Наций в Вене",
    Programme: "Административное обслуживание, Вена",
    Subprogramme: "Вспомогательное обслуживание",
    Title: "Улучшение контроля за деятельностью партнеров-исполнителей",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Упрощение, транспарентность и облегчение доступа для более эффективного осуществления программ",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ru#page=17"
  },
  {
    ID: 796,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Отделение Организации Объединённых Наций в Вене",
    Programme: "Административное обслуживание, Вена",
    Subprogramme: "Вспомогательное обслуживание",
    Title: "Оптимизированный порядок регистрации и распространения официальной корреспонденции",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AT",
    Image: "29FUNOV11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ru#page=18"
  },
  {
    ID: 797,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Отделение Организации Объединённых Наций в Вене",
    Programme: "Административное обслуживание, Вена",
    Subprogramme: "Вспомогательное обслуживание",
    Title: "Повышение эффективности использования служебных помещений",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ru#page=18"
  },
  {
    ID: 798,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Отделение Организации Объединённых Наций в Вене",
    Programme: "Административное обслуживание, Вена",
    Subprogramme: "Деятельность в области информационно-коммуникационных технологий",
    Title: "Повышение надежности работы информационно-коммуникационных технологий посредством консолидации виртуальной инфраструктуры и снижения зависимости от подписных лицензий",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ru#page=21"
  },
  {
    ID: 799,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Отделение Организации Объединённых Наций в Вене",
    Programme: "Административное обслуживание, Вена",
    Subprogramme: "Деятельность в области информационно-коммуникационных технологий",
    Title: "Укрепление информационной безопасности на местах",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Технические достижения, позволяющие повысить качество, наличие, доступность и безопасность информации",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ru#page=21"
  },
  {
    ID: 800,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Отделение Организации Объединённых Наций в Вене",
    Programme: "Административное обслуживание, Вена",
    Subprogramme: "Деятельность в области информационно-коммуникационных технологий",
    Title: "Цифровые преобразования, осуществленные обслуживаемыми структурами в целях повышения эффективности выполнения мандатов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Упрощение, транспарентность и облегчение доступа для более эффективного осуществления программ",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ru#page=22"
  },
  {
    ID: 801,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Отделение Организации Объединённых Наций в Вене",
    Programme: "Административное обслуживание, Вена",
    Subprogramme: "Деятельность в области информационно-коммуникационных технологий",
    Title: "Применение согласованного подхода к обеспечению безопасности информационно-коммуникационных технологий во всех местах размещения структур, обслуживаемых Отделением Организации Объединенных Наций в Вене",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ru#page=23"
  },
  {
    ID: 802,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Управление служб внутреннего надзора",
    Programme: "Внутренний надзор",
    Subprogramme: "Внутренняя ревизия",
    Title: "Укрепление подотчетности в том, что касается рабочего времени и посещаемости сотрудников",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ru#page=7"
  },
  {
    ID: 803,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Управление служб внутреннего надзора",
    Programme: "Внутренний надзор",
    Subprogramme: "Внутренняя ревизия",
    Title: "Укрепление систем контроля для улучшения управления эффективностью в поддержку выполнения программы",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ru#page=8"
  },
  {
    ID: 804,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Управление служб внутреннего надзора",
    Programme: "Внутренний надзор",
    Subprogramme: "Внутренняя ревизия",
    Title: "Более эффективное выполнение мандатов и программ Организации Объединенных Наций благодаря укреплению организационного потенциала",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ru#page=9"
  },
  {
    ID: 805,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Управление служб внутреннего надзора",
    Programme: "Внутренний надзор",
    Subprogramme: "Внутренняя ревизия",
    Title: "Повышение эффективности административного управления Организацией",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ru#page=9"
  },
  {
    ID: 806,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Управление служб внутреннего надзора",
    Programme: "Внутренний надзор",
    Subprogramme: "Инспекции и оценки",
    Title: "Укрепление потенциала самооценки в Секретариате",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ru#page=12"
  },
  {
    ID: 807,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Управление служб внутреннего надзора",
    Programme: "Внутренний надзор",
    Subprogramme: "Инспекции и оценки",
    Title: "Укрепление системы координаторов-резидентов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ru#page=12"
  },
  {
    ID: 808,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Управление служб внутреннего надзора",
    Programme: "Внутренний надзор",
    Subprogramme: "Инспекции и оценки",
    Title: "Улучшение результатов программы",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ru#page=13"
  },
  {
    ID: 809,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Управление служб внутреннего надзора",
    Programme: "Внутренний надзор",
    Subprogramme: "Инспекции и оценки",
    Title: "Обеспечение более эффективного выполнения мандатов за счет усовершенствованного планирования по программам",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ru#page=14"
  },
  {
    ID: 810,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Управление служб внутреннего надзора",
    Programme: "Внутренний надзор",
    Subprogramme: "Расследования",
    Title: "Укрепление способности Организации защищать свои ресурсы и привлекать своих сотрудников к ответственности",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Принятие более эффективных мер реагирования на случаи сексуальной эксплуатации и сексуальных злоупотреблений, сексуальных домогательств, мошенничества и коррупции; более широкое применение подхода, ориентированного на интересы жертв",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ru#page=16"
  },
  {
    ID: 811,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Управление служб внутреннего надзора",
    Programme: "Внутренний надзор",
    Subprogramme: "Расследования",
    Title: "Усиление мер реагирования в связи с расследованиями проступков, требующее осуществления ответных мер, ориентированных на нужды и интересы потерпевших",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Принятие более эффективных мер реагирования на случаи сексуальной эксплуатации и сексуальных злоупотреблений, сексуальных домогательств, мошенничества и коррупции; более широкое применение подхода, ориентированного на интересы жертв",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ru#page=17"
  },
  {
    ID: 812,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Управление служб внутреннего надзора",
    Programme: "Внутренний надзор",
    Subprogramme: "Расследования",
    Title: "Повышение эффективности рассмотрения жалоб на проступки и своевременного принятия решений по ним",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Принятие более эффективных мер реагирования на случаи сексуальной эксплуатации и сексуальных злоупотреблений, сексуальных домогательств, мошенничества и коррупции; более широкое применение подхода, ориентированного на интересы жертв",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ru#page=17"
  },
  {
    ID: 813,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Управление служб внутреннего надзора",
    Programme: "Внутренний надзор",
    Subprogramme: "Расследования",
    Title: "Своевременное расследование дел, связанных с возможными финансовыми потерями для Организации",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Принятие более эффективных мер реагирования на случаи сексуальной эксплуатации и сексуальных злоупотреблений, сексуальных домогательств, мошенничества и коррупции; более широкое применение подхода, ориентированного на интересы жертв",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ru#page=18"
  },
  {
    ID: 814,
    BudgetSection: "31",
    Entity: "ICSC",
    EntityFullName: "Комиссия по международной гражданской службе",
    Programme: "Совместно финансируемая административная деятельность",
    Subprogramme: "Комиссия по международной гражданской службе",
    Title: "Модель расчета индивидуальной временной надбавки на справедливой и равноправной основе",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ru#page=5"
  },
  {
    ID: 815,
    BudgetSection: "31",
    Entity: "ICSC",
    EntityFullName: "Комиссия по международной гражданской службе",
    Programme: "Совместно финансируемая административная деятельность",
    Subprogramme: "Комиссия по международной гражданской службе",
    Title: "Обеспечение большей гибкости для сотрудников, работающих в местах службы с крайне трудными условиями",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ru#page=5"
  },
  {
    ID: 816,
    BudgetSection: "31",
    Entity: "ICSC",
    EntityFullName: "Комиссия по международной гражданской службе",
    Programme: "Совместно финансируемая административная деятельность",
    Subprogramme: "Комиссия по международной гражданской службе",
    Title: "Пересмотр стандартов поведения, которыми организации руководствуются при решении формирующихся проблем",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ru#page=6"
  },
  {
    ID: 817,
    BudgetSection: "31",
    Entity: "ICSC",
    EntityFullName: "Комиссия по международной гражданской службе",
    Programme: "Совместно финансируемая административная деятельность",
    Subprogramme: "Комиссия по международной гражданской службе",
    Title: "Формирование пакета вознаграждения, отражающего цели, критерии и параметры, утвержденные Генеральной Ассамблеей",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ru#page=7"
  },
  {
    ID: 818,
    BudgetSection: "31",
    Entity: "JIU",
    EntityFullName: "Объединённая инспекционная группа",
    Programme: "Совместно финансируемая административная деятельность",
    Subprogramme: "Объединенная инспекционная группа",
    Title: "Более активное реагирование на рекомендации Объединенной инспекционной группы благодаря доступу к новому инструменту для отслеживания хода выполнения рекомендаций",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ru#page=16"
  },
  {
    ID: 819,
    BudgetSection: "31",
    Entity: "JIU",
    EntityFullName: "Объединённая инспекционная группа",
    Programme: "Совместно финансируемая административная деятельность",
    Subprogramme: "Объединенная инспекционная группа",
    Title: "Совершенствование управления административной и программной деятельностью в организациях системы Организации Объединенных Наций путем выполнения стратегических и практических рекомендаций Объединенной инспекционной группы",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ru#page=17"
  },
  {
    ID: 820,
    BudgetSection: "31",
    Entity: "JIU",
    EntityFullName: "Объединённая инспекционная группа",
    Programme: "Совместно финансируемая административная деятельность",
    Subprogramme: "Объединенная инспекционная группа",
    Title: "Увеличение воздействия рекомендаций Объединенной инспекционной группы",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ru#page=18"
  },
  {
    ID: 821,
    BudgetSection: "31",
    Entity: "JIU",
    EntityFullName: "Объединённая инспекционная группа",
    Programme: "Совместно финансируемая административная деятельность",
    Subprogramme: "Объединенная инспекционная группа",
    Title: "Укрепление общесистемной базы знаний и принятие обоснованных решений на основе полученных из фактических данных выводов надзорных органов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ru#page=19"
  },
  {
    ID: 822,
    BudgetSection: "31",
    Entity: "CEB",
    EntityFullName: "Координационный совет руководителей системы Организации Объединённых Наций",
    Programme: "Совместно финансируемая административная деятельность",
    Subprogramme: "Координационный совет руководителей системы Организации Объединенных Наций",
    Title: "Более активное реагирование на рекомендации Объединенной инспекционной группы благодаря доступу к новому инструменту для отслеживания хода выполнения рекомендаций",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ru#page=29"
  },
  {
    ID: 823,
    BudgetSection: "31",
    Entity: "CEB",
    EntityFullName: "Координационный совет руководителей системы Организации Объединённых Наций",
    Programme: "Совместно финансируемая административная деятельность",
    Subprogramme: "Координационный совет руководителей системы Организации Объединенных Наций",
    Title: "Цифровое удостоверение Организации Объединенных Наций — структурный элемент в деле обеспечения операционной совместимости между организациями системы Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Технические достижения, позволяющие повысить качество, наличие, доступность и безопасность информации",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ru#page=30"
  },
  {
    ID: 824,
    BudgetSection: "31",
    Entity: "CEB",
    EntityFullName: "Координационный совет руководителей системы Организации Объединённых Наций",
    Programme: "Совместно финансируемая административная деятельность",
    Subprogramme: "Координационный совет руководителей системы Организации Объединенных Наций",
    Title: "Повышение слаженности работы системы Организации Объединенных Наций в целях ускорения прогресса в достижении целей в области устойчивого развития и реализации Пакта во имя будущего",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Ускорение прогресса в достижении целей в области устойчивого развития, в том числе за счет создания надежных координационных структур и использования взаимосвязей в рамках всех ЦУР",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ru#page=30"
  },
  {
    ID: 825,
    BudgetSection: "31",
    Entity: "CEB",
    EntityFullName: "Координационный совет руководителей системы Организации Объединённых Наций",
    Programme: "Совместно финансируемая административная деятельность",
    Subprogramme: "Координационный совет руководителей системы Организации Объединенных Наций",
    Title: "Скоординированная и согласованная работа в рамках системы Организации Объединенных Наций обеспечивает экономически эффективную, непрерывную и соответствующую ее принципам деятельность",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Упрощение, транспарентность и облегчение доступа для более эффективного осуществления программ",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ru#page=31"
  },
  {
    ID: 826,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Департамент по вопросам охраны и безопасности",
    Programme: "Охрана и безопасность",
    Subprogramme: "Службы безопасности и охраны",
    Title: "Безопасная и спокойная обстановка для всех делегатов и участников на восьмидесятой сессии Генеральной Ассамблеи",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: "Международное сообщество ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ru#page=8"
  },
  {
    ID: 827,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Департамент по вопросам охраны и безопасности",
    Programme: "Охрана и безопасность",
    Subprogramme: "Службы безопасности и охраны",
    Title: "Повышение удобства перемещения делегатов и сотрудников между местами службы",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ru#page=9"
  },
  {
    ID: 828,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Департамент по вопросам охраны и безопасности",
    Programme: "Охрана и безопасность",
    Subprogramme: "Службы безопасности и охраны",
    Title: "Улучшение условий регистрации, выдачи пропусков и обеспечения безопасности для инвалидов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: "Беженцы, меньшин-ства и другие группы, находящиеся в уязви-мом положении",
    SpecificResult: "Модернизация инфраструктуры для оказания более эффективной и действенной поддержки операциям ООН",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ru#page=9"
  },
  {
    ID: 829,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Департамент по вопросам охраны и безопасности",
    Programme: "Охрана и безопасность",
    Subprogramme: "Службы безопасности и охраны",
    Title: "Улучшение процесса принятия решений по вопросам охраны и безопасности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ru#page=10"
  },
  {
    ID: 830,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Департамент по вопросам охраны и безопасности",
    Programme: "Охрана и безопасность",
    Subprogramme: "Полевые операции",
    Title: "Повышение эффективности деятельности с уделением особого внимания районам с высокой степенью риска",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ru#page=13"
  },
  {
    ID: 831,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Департамент по вопросам охраны и безопасности",
    Programme: "Охрана и безопасность",
    Subprogramme: "Полевые операции",
    Title: "Повышение готовности к кризисам и улучшение реагирования на них",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ru#page=13"
  },
  {
    ID: 832,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Департамент по вопросам охраны и безопасности",
    Programme: "Охрана и безопасность",
    Subprogramme: "Полевые операции",
    Title: "Улучшение процесса принятия решений по вопросам безопасности",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ru#page=14"
  },
  {
    ID: 833,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Департамент по вопросам охраны и безопасности",
    Programme: "Охрана и безопасность",
    Subprogramme: "Полевые операции",
    Title: "Обеспечение принятия решений по вопросам охраны и безопасности с учетом рисков",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ru#page=15"
  },
  {
    ID: 834,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Департамент по вопросам охраны и безопасности",
    Programme: "Охрана и безопасность",
    Subprogramme: "Партнерства и специализированные услуги",
    Title: "Внедрение новых цифровых систем позволило укрепить функции обеспечения охраны и безопасности персонала Организации Объединенных Наций",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Повышение эффективности процессов благодаря использованию научно-технических достижений и инноваций",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ru#page=17"
  },
  {
    ID: 835,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Департамент по вопросам охраны и безопасности",
    Programme: "Охрана и безопасность",
    Subprogramme: "Партнерства и специализированные услуги",
    Title: "Последовательные и слаженные операции в рамках всей системы обеспечения безопасности Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ru#page=18"
  },
  {
    ID: 836,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Департамент по вопросам охраны и безопасности",
    Programme: "Охрана и безопасность",
    Subprogramme: "Партнерства и специализированные услуги",
    Title: "Укрепление служб личной охраны старших должностных лиц Организации Объединенных Наций",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ru#page=19"
  },
  {
    ID: 837,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Департамент по вопросам охраны и безопасности",
    Programme: "Охрана и безопасность",
    Subprogramme: "Партнерства и специализированные услуги",
    Title: "Согласованный подход к оказанию психосоциальной поддержки после серьезных инцидентов",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Содействие прогрессу в восьми приоритетных областях ",
    Beneficiary: "Создание благоприятных условий ",
    BeneficiaryTwo: " ",
    SpecificResult: "Укрепление организационного потенциала, повышение подотчетности и скорости реагирования в целях более эффективного выполнения мандатов",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ru#page=20"
  }
]